import React, { useState, useEffect, useRef, PureComponent, Component, createRef } from 'react';
import PropTypes, { oneOf } from 'prop-types';
import { iconWarningGlyph, iconSearch, iconCloseGlyph, iconWarning, iconWarningSolid, iconInfoSolid, iconCheckmark, iconHome, iconCheckmarkGlyph, iconWfpLogoStandardBlackEn, iconWfpLogoVerticalEn, iconArrowRight, iconArrowLeft, iconClose, iconCaretDown, iconError, iconInfoGlyph, iconChevronLeft, iconChevronRight, iconCaretUp, iconEllipsis, iconLocked, iconOverflowMenu, iconErrorGlyph, iconMenu, iconUser } from '@wfp/icons';
import 'invariant';
import { usePopperTooltip } from 'react-popper-tooltip';
import ReactDOM from 'react-dom';
import warning from 'warning';

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized(self);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var classnames = createCommonjsModule(function (module) {
/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg) && arg.length) {
				var inner = classNames.apply(null, arg);
				if (inner) {
					classes.push(inner);
				}
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else {
		window.classNames = classNames;
	}
}());
});

var classnames$1 = classnames;

var settings = {
  prefix: 'wfp'
}; //module.exports = settings;

var settings$1 = settings;

var _excluded$16 = ["title", "children", "className"];
var prefix$19 = settings$1.prefix;

function AnchorNavigation(_ref) {
  var title = _ref.title,
      children = _ref.children,
      className = _ref.className,
      other = _objectWithoutProperties(_ref, _excluded$16);

  var wrapperClasses = classnames$1("".concat(prefix$19, "--anchor-navigation"), className);
  return /*#__PURE__*/React.createElement("div", _extends({
    className: wrapperClasses
  }, other), /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefix$19, "--anchor-header-title")
  }, title), /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefix$19, "--anchor-content")
  }, children));
}

AnchorNavigation.propTypes = {
  /**
   * The `title` is represented in the header
   */
  title: PropTypes.string,

  /**
   * The content usually consisting out of `Links`
   */
  children: PropTypes.node,

  /**
   * The CSS class name to be placed on the wrapping element.
   */
  className: PropTypes.string
};

var _excluded$15 = ["image", "backgroundContent", "children", "className"],
    _excluded2$5 = ["children"];
var prefix$18 = settings$1.prefix;

var AuthLayout = function AuthLayout(_ref) {
  var _classNames;

  var image = _ref.image,
      backgroundContent = _ref.backgroundContent,
      children = _ref.children,
      className = _ref.className,
      other = _objectWithoutProperties(_ref, _excluded$15);

  var style = image ? {
    backgroundImage: "url(".concat(image, ")")
  } : {};
  var wrapperClasses = classnames$1("".concat(prefix$18, "--auth-background-wrapper"), (_classNames = {}, _defineProperty(_classNames, "".concat(prefix$18, "--auth-background-image"), image), _defineProperty(_classNames, "".concat(className), className), _classNames));
  return /*#__PURE__*/React.createElement("div", _extends({
    className: "".concat(prefix$18, "--auth-wrapper")
  }, other), /*#__PURE__*/React.createElement("div", {
    className: wrapperClasses,
    style: style
  }, backgroundContent), /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefix$18, "--auth-content-wrapper")
  }, children));
};

AuthLayout.propTypes = {
  /**
   * The content usually consisting out of forms
   */
  children: PropTypes.node.isRequired,

  /**
   * The image is set as background on the left section when provided
   */
  image: PropTypes.node,

  /**
   * This usually consist of `<BackgroundContent/>` if you wish to provide content and background color instead of an image
   */
  backgroundContent: PropTypes.node,

  /**
   * The CSS class name to be placed on the wrapping element.
   */
  className: PropTypes.string
};

var BackgroundContent = function BackgroundContent(_ref2) {
  var children = _ref2.children,
      other = _objectWithoutProperties(_ref2, _excluded2$5);

  return /*#__PURE__*/React.createElement("div", _extends({}, other, {
    className: "".concat(prefix$18, "--auth-background-content")
  }), children);
};

BackgroundContent.propTypes = {
  /**
   * The content usually consisting out of `<BackgroundContent/>`
   */
  children: PropTypes.node.isRequired,

  /**
   * The CSS class name to be placed on the wrapping element.
   */
  className: PropTypes.string
};

var _excluded$14 = ["background", "backgroundStyle", "children", "className", "pageWidth", "mobilePageWidth", "spacing"];
var prefix$17 = settings$1.prefix;
var pageWidths = ['sm', 'md', 'lg', 'full'];
/** Wrapper can wrap it's content in a specific width depending on if the application has a full or fixed width. */

var Wrapper = function Wrapper(props) {
  var _classNames;

  var background = props.background,
      backgroundStyle = props.backgroundStyle,
      children = props.children,
      className = props.className,
      pageWidth = props.pageWidth,
      mobilePageWidth = props.mobilePageWidth,
      spacing = props.spacing,
      other = _objectWithoutProperties(props, _excluded$14);

  var wrapperClasses = classnames$1((_classNames = {}, _defineProperty(_classNames, "".concat(prefix$17, "--wrapper"), true), _defineProperty(_classNames, "".concat(prefix$17, "--wrapper--width-lg"), pageWidth === 'narrow' || pageWidth === 'lg'), _defineProperty(_classNames, "".concat(prefix$17, "--wrapper--width-md"), pageWidth === 'narrower' || pageWidth === 'md'), _defineProperty(_classNames, "".concat(prefix$17, "--wrapper--width-sm"), pageWidth === 'narrowest' || pageWidth === 'sm'), _defineProperty(_classNames, "".concat(prefix$17, "--wrapper--width-xs"), pageWidth === 'narrowest' || pageWidth === 'xs'), _defineProperty(_classNames, "".concat(prefix$17, "--wrapper--width-mobile-full"), mobilePageWidth === 'full'), _defineProperty(_classNames, "".concat(prefix$17, "--wrapper--spacing-md"), spacing === 'md'), _defineProperty(_classNames, "".concat(prefix$17, "--wrapper--spacing-xl"), spacing === 'xl'), _defineProperty(_classNames, "".concat(className), className), _classNames));

  if (background || backgroundStyle) {
    var _classNames2;

    var backgroundClasses = classnames$1((_classNames2 = {}, _defineProperty(_classNames2, "".concat(prefix$17, "--wrapper--background-lighter"), background === 'lighter'), _defineProperty(_classNames2, "".concat(prefix$17, "--wrapper--background-dark"), background === 'dark'), _classNames2));
    return /*#__PURE__*/React.createElement("div", {
      className: backgroundClasses,
      style: backgroundStyle
    }, /*#__PURE__*/React.createElement("div", _extends({
      className: wrapperClasses
    }, other), children));
  } else {
    return /*#__PURE__*/React.createElement("div", _extends({
      className: wrapperClasses
    }, other), children);
  }
};

Wrapper.propTypes = {
  /**
   * The content which should be displayed
   */
  children: PropTypes.node,

  /**
  Specify additional className which will be added
  */
  className: PropTypes.string,

  /**
    `xs` `sm` `md` `lg`:  Set the maximum width of the Wrapper content `xs`: `500px` `sm`: `700px` `md`:`1000px` `lg`: `1200px` 
  */
  pageWidth: PropTypes.oneOf(['sm', 'md', 'lg', 'full']),

  /**
    Width on mobile devices
  */
  mobilePageWidth: PropTypes.string,

  /**
    `full` `sm` `md` `lg`:  Width on mobile devices `full`: `100%`      
  */
  spacing: PropTypes.string
};
var Wrapper$1 = Wrapper;

var _excluded$13 = ["children", "className", "pageWidth"];
var prefix$16 = settings$1.prefix;

var BannerNavigationItem = function BannerNavigationItem(_ref) {
  var className = _ref.className,
      children = _ref.children;
  var wrapperClasses = classnames$1("".concat(prefix$16, "--banner-navigation__item"), className);
  return /*#__PURE__*/React.createElement("li", {
    className: wrapperClasses
  }, children);
};

BannerNavigationItem.propTypes = {
  /**
   * The CSS class name to be placed on the wrapping element.
   */
  className: PropTypes.string,
  children: PropTypes.node.isRequired
};
/**
 * A thin bar on top of the main navigation used to crosslink among apps or pages.
 */

var BannerNavigation = function BannerNavigation(_ref2) {
  var children = _ref2.children,
      className = _ref2.className;
      _ref2.pageWidth;
      var props = _objectWithoutProperties(_ref2, _excluded$13);

  var wrapperClasses = classnames$1("".concat(prefix$16, "--banner-navigation"), className);
  return /*#__PURE__*/React.createElement("div", {
    className: wrapperClasses
  }, /*#__PURE__*/React.createElement(Wrapper$1, props, /*#__PURE__*/React.createElement("ul", {
    className: "".concat(prefix$16, "--banner-navigation__list")
  }, children)));
};

BannerNavigation.propTypes = {
  /**
   * The content usually consisting out of `BannerNavigationItem`
   */
  children: PropTypes.node.isRequired,

  /**
   * The CSS class name to be placed on the wrapping element.
   */
  className: PropTypes.string,

  /**
   * Specify the max-width on desktop devices (same as \`Wrapper\` component)
   */
  pageWidth: PropTypes.oneOf(['sm', 'md', 'lg', 'full'])
};
BannerNavigation.defaultProps = {
  pageWidth: 'lg'
};

var _excluded$12 = ["className", "children", "invalid"];
var prefix$15 = settings$1.prefix;

var FormItem = function FormItem(_ref) {
  var className = _ref.className,
      children = _ref.children,
      invalid = _ref.invalid,
      other = _objectWithoutProperties(_ref, _excluded$12);

  var classNames = classnames$1("".concat(prefix$15, "--form-item"), _defineProperty({}, "".concat(prefix$15, "--form-item--invalid"), invalid), className);
  return /*#__PURE__*/React.createElement("div", _extends({
    className: classNames
  }, other), children);
};

FormItem.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
};
var FormItem$1 = FormItem;

/**
 * @param {Object<string, Function>} propTypes The list of type checkers, keyed by prop names.
 * @returns {Object<string, Function>}
 *   The new prop type checkers that checks if one of the given props exist,
 *   in addition to the original type checkings.
 */
function isRequiredOneOf(propTypes) {
  var names = Object.keys(propTypes);

  var checker = function checker(propType) {
    return function (props, propName, componentName) {
      if (process.env.NODE_ENV !== "production" && names.every(function (name) {
        return !props.hasOwnProperty(name);
      })) {
        return new Error("".concat(componentName, " requires one of the following props: ").concat(names.join(', ')));
      }

      for (var _len = arguments.length, rest = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
        rest[_key - 3] = arguments[_key];
      }

      return propType.apply(void 0, [props, propName, componentName].concat(rest));
    };
  };

  return names.reduce(function (o, name) {
    return _objectSpread2(_objectSpread2({}, o), {}, _defineProperty({}, name, checker(propTypes[name])));
  }, {});
}

var _excluded$11 = ["className", "description", "fill", "fillRule", "height", "icon", "iconTitle", "role", "style", "width", "iconRef"];
/**
 * @param {Object} svgData - JSON Object for an SVG icon
 * @returns {ReactElement} Elements/Nodes for SVG
 * @example
 * // Returns SVG elements
 * const svgData = getSvgData('copy-code');
 * svgShapes(svgData);
 */

function svgShapes(svgData) {
  var svgElements = Object.keys(svgData).filter(function (key) {
    return svgData[key];
  }).map(function (svgProp) {
    var data = svgData[svgProp];

    if (svgProp === 'circles') {
      return data.map(function (circle, index) {
        var circleProps = {
          cx: circle.cx,
          cy: circle.cy,
          r: circle.r,
          fill: circle.fill,
          key: "circle".concat(index)
        };
        return /*#__PURE__*/React.createElement("circle", circleProps);
      });
    } else if (svgProp === 'paths') {
      return data.map(function (path, index) {
        return /*#__PURE__*/React.createElement("path", {
          fill: path.fill,
          d: path.d,
          key: "key".concat(index)
        });
      });
    }

    return '';
  });
  return svgElements;
}
/** Icons are visual representations of commands, devices, directories, or common actions. */

var Icon = function Icon(_ref) {
  var className = _ref.className,
      description = _ref.description,
      fill = _ref.fill,
      fillRule = _ref.fillRule,
      height = _ref.height,
      icon = _ref.icon;
      _ref.iconTitle;
      var role = _ref.role,
      style = _ref.style,
      width = _ref.width,
      iconRef = _ref.iconRef,
      other = _objectWithoutProperties(_ref, _excluded$11);

  if ( /*#__PURE__*/React.isValidElement(icon)) {
    width = width ? width : icon.props.width;
    height = height ? height : icon.props.height;
    var clonedIcon = /*#__PURE__*/React.cloneElement(icon, {
      className: className,
      role: role,
      width: width,
      height: height,
      style: style,
      fill: fill,
      fillRule: fillRule,
      description: description
    });
    return clonedIcon;
  }

  var props = _objectSpread2({
    className: className,
    fill: fill,
    fillRule: fillRule,
    height: height || icon.height,
    //name: isPrefixed ? name : `icon--${name}`,
    role: role,
    style: style,
    viewBox: icon.viewBox,
    width: width || icon.width,
    ref: iconRef
  }, other);

  var svgContent = icon ? svgShapes(icon.svgData) : '';
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    "aria-label": description,
    alt: description
  }), /*#__PURE__*/React.createElement("title", null, description), svgContent);
};

Icon.propTypes = _objectSpread2(_objectSpread2({
  /**
   * The CSS class name.
   */
  className: PropTypes.string,

  /**
   * The icon description.
   */
  description: PropTypes.string.isRequired,

  /**
   * The `svg` `fill` attribute.
   */
  fill: PropTypes.string,

  /**
   * The `svg` `fillRule` attribute.
   */
  fillRule: PropTypes.string,

  /**
   * The `svg` `height` attribute.
   */
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
}, isRequiredOneOf({
  /**
   * The icon data.
   */
  icon: PropTypes.oneOfType([PropTypes.shape({
    width: PropTypes.string,
    height: PropTypes.string,
    viewBox: PropTypes.string.isRequired,
    svgData: PropTypes.object.isRequired
  }), PropTypes.node]),

  /**
   * The name in the sprite.
   */
  name: PropTypes.string
})), {}, {
  /**
   * The `role` attribute.
   */
  role: PropTypes.string,

  /**
   * The CSS styles.
   */
  style: PropTypes.object,

  /**
   * The `svg` `viewbox` attribute.
   */
  viewBox: PropTypes.string,

  /**
   * The `svg` `width` attribute.
   */
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  /**
   * The `ref` callback for the icon.
   */
  iconRef: PropTypes.func
});
Icon.defaultProps = {
  fillRule: 'evenodd',
  role: 'img',
  description: 'Provide a description that will be used as the title'
}; //export { icons };

var Icon$1 = Icon;

var _excluded$10 = ["additional", "addonBefore", "addonAfter", "labelText", "children", "className", "iconDescription", "id", "formItemClassName", "inputWrapperClassName", "placeholder", "type", "onChange", "onClick", "hideLabel", "invalid", "invalidText", "helperText", "light", "required"];
var prefix$14 = settings$1.prefix;
/**
 * Input is a wrapper for custom inputs providing the label, helperText and errors. */

var Input = function Input(_ref) {
  var _classNames, _classNames2;

  var additional = _ref.additional,
      addonBefore = _ref.addonBefore,
      addonAfter = _ref.addonAfter,
      labelText = _ref.labelText,
      children = _ref.children,
      className = _ref.className;
      _ref.iconDescription;
      var id = _ref.id,
      formItemClassName = _ref.formItemClassName,
      inputWrapperClassName = _ref.inputWrapperClassName,
      placeholder = _ref.placeholder,
      type = _ref.type,
      _onChange = _ref.onChange,
      _onClick = _ref.onClick,
      hideLabel = _ref.hideLabel,
      invalid = _ref.invalid,
      invalidText = _ref.invalidText,
      helperText = _ref.helperText,
      light = _ref.light,
      required = _ref.required,
      other = _objectWithoutProperties(_ref, _excluded$10);

  var calculatedId = id ? id : name;
  var inputProps = {
    id: calculatedId,
    onChange: function onChange(evt) {
      if (!other.disabled && !other.readOnly) {
        _onChange(evt);
      }
    },
    onClick: function onClick(evt) {
      if (!other.disabled && !other.readOnly) {
        _onClick(evt);
      }
    },
    placeholder: placeholder,
    type: type
  };
  var errorId = calculatedId + '-error-msg';
  var inputClasses = classnames$1("".concat(prefix$14, "--input"), className, (_classNames = {}, _defineProperty(_classNames, "".concat(prefix$14, "--input--light"), light), _defineProperty(_classNames, "".concat(prefix$14, "--input--invalid"), invalid), _classNames));
  var labelClasses = classnames$1("".concat(prefix$14, "--label"), (_classNames2 = {}, _defineProperty(_classNames2, "".concat(prefix$14, "--visually-hidden"), hideLabel || !labelText), _defineProperty(_classNames2, "".concat(prefix$14, "--label--disabled"), other.disabled), _classNames2));
  var inputWrapperClasses = classnames$1("".concat(prefix$14, "--input-wrapper"), inputWrapperClassName);
  var helperTextClasses = classnames$1("".concat(prefix$14, "--form__helper-text"), _defineProperty({}, "".concat(prefix$14, "--form__helper-text--disabled"), other.disabled));
  var errorIcon = /*#__PURE__*/React.createElement(Icon$1, {
    icon: iconWarningGlyph,
    fill: "#c5192d"
  });
  var label = /*#__PURE__*/React.createElement("label", {
    htmlFor: calculatedId,
    className: labelClasses
  }, labelText && labelText, required && '*');
  var error = invalid ? /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefix$14, "--form-requirement"),
    id: errorId
  }, errorIcon, ' ', /*#__PURE__*/React.createElement("span", null, _typeof(invalid) === 'object' && invalid.message ? invalid.message : typeof invalid === 'string' ? invalid : invalidText ? invalidText : 'required')) : null;
  var elementProps = invalid ? _objectSpread2(_objectSpread2(_objectSpread2({}, other), inputProps), {}, {
    'data-invalid': true,
    'aria-invalid': true,
    'aria-describedby': errorId,
    className: inputClasses
  }) : _objectSpread2(_objectSpread2(_objectSpread2({}, other), inputProps), {}, {
    className: inputClasses
  });
  var helper = helperText ? /*#__PURE__*/React.createElement("div", {
    className: helperTextClasses
  }, helperText) : null;
  return /*#__PURE__*/React.createElement(FormItem$1, {
    className: formItemClassName,
    invalid: true
  }, label, helper, additional, /*#__PURE__*/React.createElement("div", {
    className: inputWrapperClasses
  }, addonBefore && /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefix$14, "--input-addon-before")
  }, addonBefore), children(elementProps), addonAfter && /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefix$14, "--input-addon-after")
  }, addonAfter)), error);
};

Input.propTypes = {
  /**
   * Specify an optional className to be applied to the &lt;input&gt; node
   */
  className: PropTypes.string,

  /**
   * Optionally provide the default value of the &lt;input&gt;
   */
  defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  /**
   * Specify whether the &lt;input&gt; should be disabled
   */
  disabled: PropTypes.bool,

  /**
   * Specify an optional className to be applied to the form-item node
   */
  formItemClassName: PropTypes.string,

  /**
   * Specify an optional className to be applied to the input wrapper node
   */
  inputWrapperClassName: PropTypes.string,

  /**
   * Specify a custom `id` for the &lt;input&gt;
   */
  id: PropTypes.string,

  /**
   * Provide the text that will be read by a screen reader when visiting this
   * control
   */
  labelText: PropTypes.node,

  /**
   * Optionally provide an `onChange` handler that is called whenever &lt;input&gt;
   * is updated
   */
  onChange: PropTypes.func,

  /**
   * Optionally provide an `onClick` handler that is called whenever the
   * &lt;input&gt; is clicked
   */
  onClick: PropTypes.func,

  /**
   * Specify the placeholder attribute for the &lt;input&gt;
   */
  placeholder: PropTypes.string,

  /**
   * Specify the type of the &lt;input&gt;
   */
  type: PropTypes.string,

  /**
   * Specify the value of the &lt;input&gt;
   */
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.object]),

  /**
   * Specify whether you want the underlying label to be visually hidden
   */
  hideLabel: PropTypes.bool,

  /**
   * Specify whether the control is currently invalid.
   * Either a boolean in combination with `invalidText` or an `object`( eg. { message: "Message", …otherErrorProperties }) can be passed.
   */
  invalid: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),

  /**
   * Provide the text that is displayed when the control is in an invalid state
   */
  invalidText: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),

  /**
   * Provide additional component that is used alongside the input for customization
   */
  additional: PropTypes.node,

  /**
   * Provide text that is used alongside the control label for additional help
   */
  helperText: PropTypes.node,

  /**
   * `true` to use the light version.
   */
  light: PropTypes.bool
};
Input.defaultProps = {
  className: 'wfp--input',
  disabled: false,
  type: 'text',
  onChange: function onChange() {},
  onClick: function onClick() {},
  invalid: false,
  invalidText: '',
  helperText: '',
  light: false
};
var Input$1 = Input;

var _excluded$$ = ["className", "closeButtonLabelText", "disabled", "formItemClassName", "id", "hideLabel", "hideControls", "labelText", "kind", "onChange", "onClick", "onSearchIconClick", "helperText", "light", "inputRef"];
var prefix$13 = settings$1.prefix;
/** Search enables users to specify a word or a phrase to find relevant pieces of content without the use of navigation. */

function Search(props) {
  var _classNames;

  var className = props.className,
      closeButtonLabelText = props.closeButtonLabelText,
      disabled = props.disabled;
      props.formItemClassName;
      var id = props.id,
      hideLabel = props.hideLabel,
      hideControls = props.hideControls,
      labelText = props.labelText,
      _props$kind = props.kind,
      kind = _props$kind === void 0 ? 'large' : _props$kind,
      _props$onChange = props.onChange,
      onChange = _props$onChange === void 0 ? function () {} : _props$onChange;
      props.onClick;
      var _props$onSearchIconCl = props.onSearchIconClick,
      onSearchIconClick = _props$onSearchIconCl === void 0 ? function () {} : _props$onSearchIconCl,
      helperText = props.helperText,
      light = props.light,
      inputRef = props.inputRef,
      other = _objectWithoutProperties(props, _excluded$$);

  var initialValue = props.value;

  var _useState = useState(initialValue),
      _useState2 = _slicedToArray(_useState, 2),
      value = _useState2[0],
      setValue = _useState2[1];

  useEffect(function () {
    setValue(props.value);
  }, [props.value]);
  var newInputRef = useRef(null);

  var _inputRef = inputRef ? inputRef : newInputRef;

  var handleChange = function handleChange(evt) {
    if (!disabled) {
      evt.persist();
      evt.imaginaryTarget = _inputRef;
      setValue(evt.target.value);
      onChange(evt.target.value, evt);
    }
  };

  var clearSearch = function clearSearch() {
    var valueState = '';
    setValue(valueState);
    onChange(valueState);
  };

  var numberInputClasses = classnames$1("".concat(prefix$13, "--number"), className, (_classNames = {}, _defineProperty(_classNames, "".concat(prefix$13, "--number--light"), light), _defineProperty(_classNames, "".concat(prefix$13, "--number--helpertext"), helperText), _defineProperty(_classNames, "".concat(prefix$13, "--number--nolabel"), hideLabel), _defineProperty(_classNames, "".concat(prefix$13, "--number--nocontrols"), hideControls), _defineProperty(_classNames, 'wfp--search', true), _defineProperty(_classNames, 'wfp--search--lg', kind === 'large'), _defineProperty(_classNames, 'wfp--search--sm', kind === 'small'), _defineProperty(_classNames, 'wfp--search--main', kind === 'main'), _defineProperty(_classNames, 'wfp--search--banner', kind === 'banner'), _defineProperty(_classNames, 'wfp--search--light', kind === 'light'), _classNames));
  var newProps = {
    disabled: disabled,
    id: id,
    onChange: handleChange,
    value: value
  };
  var clearClasses = classnames$1({
    'wfp--search-close': true,
    'wfp--search-close--hidden': !value
  });
  return /*#__PURE__*/React.createElement(Input$1, _extends({}, props, {
    formItemClassName: numberInputClasses,
    inputWrapperClassName: "".concat(prefix$13, "--search-input__wrapper")
  }), function () {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Icon$1, {
      icon: iconSearch,
      description: labelText,
      className: "".concat(prefix$13, "--search-magnifier"),
      onClick: onSearchIconClick
    }), /*#__PURE__*/React.createElement("input", _extends({
      className: "wfp--search-input",
      type: "text"
    }, other, newProps, {
      ref: _inputRef
    })), /*#__PURE__*/React.createElement("button", {
      className: clearClasses,
      onClick: clearSearch,
      type: "button",
      "aria-label": closeButtonLabelText
    }, /*#__PURE__*/React.createElement(Icon$1, {
      icon: iconCloseGlyph,
      description: closeButtonLabelText
    })));
  });
}

Search.propTypes = {
  /**
   * Specify if the control should be disabled, or not
   */
  disabled: PropTypes.bool,

  /**
   * Generic `label` that will be used as the textual representation of what
   * this field is for
   */
  labelText: PropTypes.node,

  /**
   * Specify whether you want the underlying label to be visually hidden
   */
  hideLabel: PropTypes.bool,

  /**
   * Provide text that is used alongside the control label for additional help
   */
  helperText: PropTypes.node,

  /**
   * Specify the placeholder attribute for the &lt;input&gt;
   */
  placeholder: PropTypes.string,

  /**
   * Specify an optional className to be applied to the wrapper node
   */
  className: PropTypes.string,

  /**
   * Specify an optional className to be applied to the form-item node
   */
  formItemClassName: PropTypes.string,

  /**
   * Specify a custom `id` for the input
   */
  id: PropTypes.string.isRequired,

  /**
   * The new value is available first arg 'searchValue' and evt object if needed is on second arg.
   * i.e.
   * const handleChange = (searchValue, evt) => {
   * console.log("searchValue", searchValue); // a string
   * console.log("evt", evt); // the whole event object
   * }
   */
  onChange: PropTypes.func,

  /**
   * Provide an optional function to be called when the up/down button is clicked
   */
  onClick: PropTypes.func
};
Search.defaultProps = {
  disabled: false
};

var _excluded$_ = ["children", "className", "href", "inline"];
var prefix$12 = settings$1.prefix;
/** Links are used as navigational elements. They may appear on their own, within a sentence or paragraph, or directly following the content. */

var Link = function Link(_ref) {
  var _classnames;

  var children = _ref.children,
      className = _ref.className,
      href = _ref.href,
      inline = _ref.inline,
      other = _objectWithoutProperties(_ref, _excluded$_);

  var classNames = classnames$1((_classnames = {}, _defineProperty(_classnames, "".concat(prefix$12, "--link"), true), _defineProperty(_classnames, "".concat(prefix$12, "--link--inline"), inline), _classnames), className);
  return /*#__PURE__*/React.createElement("a", _extends({
    href: href,
    className: classNames
  }, other), children);
};
Link.propTypes = {
  /**
   * Provide the content for the Link
   */
  children: PropTypes.node,

  /**
   * Provide a custom className to be applied to the containing <a> node
   */
  className: PropTypes.string,

  /**
   * Provide the `href` attribute for the <a> node
   */
  href: PropTypes.string,

  /**
   * Inline links are used within a sentence or paragraph and are styled with an underline. They should not be paired with an icon.
   */
  inline: PropTypes.bool
};
var Link$1 = Link;

var _excluded$Z = ["searchOnChange", "search"];
var linkList = [{
  name: 'WFPgo',
  link: 'https://go.wfp.org/'
}, {
  name: 'Communities',
  link: 'https://communities.wfp.org/'
}, {
  name: 'Manuals',
  link: 'https://manuals.wfp.org/'
}, {
  name: 'GoDocs',
  link: 'https://godocs.wfp.org/'
}, {
  name: 'WeLearn',
  link: 'https://welearn.wfp.org/'
}, {
  name: 'Dashboard',
  link: 'https://dashboard.wfp.org/'
}, {
  name: 'OPweb',
  link: 'https://opweb.wfp.org/'
}, {
  name: 'Self-Service',
  link: 'https://selfservice.go.wfp.org/'
}, {
  name: 'UN Booking Hub',
  link: 'https://humanitarianbooking.wfp.org/'
}, {
  name: 'WFP.org',
  link: 'https://wfp.org/'
}];

var BannerNavigationWithContent = function BannerNavigationWithContent(_ref) {
  _ref.searchOnChange;
      _ref.search;
      var other = _objectWithoutProperties(_ref, _excluded$Z);

  return /*#__PURE__*/React.createElement(BannerNavigation, other, linkList.map(function (e) {
    return /*#__PURE__*/React.createElement(BannerNavigationItem, null, /*#__PURE__*/React.createElement(Link$1, {
      href: e.link,
      target: "_blank"
    }, e.name));
  }));
};

BannerNavigationWithContent.propTypes = {
  /**
   * The CSS class name to be placed on the wrapping element.
   */
  className: PropTypes.string,

  /**
   * Specify the max-width on desktop devices (same as \`Wrapper\` component)
   */
  pageWidth: PropTypes.oneOf(['sm', 'md', 'lg', 'full']),

  /**
   * Allows to disable the search input
   */
  search: PropTypes.bool,

  /**
   * A onChange Function for the search
   */
  searchOnChange: PropTypes.func
};
BannerNavigationWithContent.defaultProps = {
  search: false,
  searchOnChange: function searchOnChange() {}
};

var prefix$11 = settings$1.prefix;
var iconLookup = {
  warning: {
    icon: iconWarning
  },
  error: {
    icon: iconWarningSolid
  },
  info: {
    icon: iconInfoSolid
  },
  success: {
    icon: iconCheckmark
  }
};
/**
 *  The Blockquote element indicates that the enclosed text is an extended quotation or information. It is rendered visually by a surrounding box. */

var Blockquote = /*#__PURE__*/function (_React$Component) {
  _inherits(Blockquote, _React$Component);

  var _super = _createSuper(Blockquote);

  function Blockquote(props) {
    var _this;

    _classCallCheck(this, Blockquote);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "toggleBlockquote", function () {
      if (_this.props.toggleable) _this.setState({
        open: !_this.state.open
      });
    });

    _this.state = {
      open: false
    };
    return _this;
  }

  _createClass(Blockquote, [{
    key: "render",
    value:
    /*showInnerHtml = content => {
      return { __html: content };
    };*/
    function render() {
      var _classNames;

      var _this$props = this.props,
          actionButtons = _this$props.actionButtons,
          className = _this$props.className,
          contentClassName = _this$props.contentClassName,
          children = _this$props.children,
          error = _this$props.error,
          style = _this$props.style,
          title = _this$props.title,
          toggleable = _this$props.toggleable,
          icon = _this$props.icon,
          light = _this$props.light,
          code = _this$props.code,
          warning = _this$props.warning,
          withIcon = _this$props.withIcon,
          info = _this$props.info,
          kind = _this$props.kind;
      var blockquoteClass = classnames$1((_classNames = {}, _defineProperty(_classNames, "".concat(prefix$11, "--blockquote"), true), _defineProperty(_classNames, "".concat(prefix$11, "--blockquote--toggleable"), toggleable), _defineProperty(_classNames, "".concat(prefix$11, "--blockquote--light"), light), _defineProperty(_classNames, "".concat(prefix$11, "--blockquote--code"), code), _defineProperty(_classNames, "".concat(prefix$11, "--blockquote--no-content"), !children), _defineProperty(_classNames, "".concat(prefix$11, "--blockquote--error"), kind === 'error' || error), _defineProperty(_classNames, "".concat(prefix$11, "--blockquote--warning"), kind === 'warning' || warning), _defineProperty(_classNames, "".concat(prefix$11, "--blockquote--success"), kind === 'success'), _defineProperty(_classNames, "".concat(prefix$11, "--blockquote--info"), kind === 'info' || info), _defineProperty(_classNames, "".concat(prefix$11, "--blockquote--with-icon"), withIcon || icon), _defineProperty(_classNames, "".concat(prefix$11, "--blockquote--toggle--open"), this.state.open), _defineProperty(_classNames, "".concat(className), className), _classNames));
      var blockquoteContentClass = classnames$1("".concat(prefix$11, "--blockquote__content"), _defineProperty({}, "".concat(className), contentClassName)); // @deprecated Only kind is allowed

      var lookup = warning || kind === 'warning' ? iconLookup['warning'] : error || kind === 'error' ? iconLookup['error'] : kind === 'success' ? iconLookup['success'] : iconLookup['info'];
      var iconElement = /*#__PURE__*/React.isValidElement(icon) ? /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefix$11, "--blockquote__icon ").concat(prefix$11, "--blockquote__icon--custom")
      }, icon) : withIcon || icon ? /*#__PURE__*/React.createElement(Icon$1, {
        icon: icon ? icon : lookup.icon,
        width: 48,
        height: 48,
        description: "Blockquote Icon",
        className: "".concat(prefix$11, "--blockquote__icon")
      }) : null;
      return /*#__PURE__*/React.createElement("div", {
        className: blockquoteClass
      }, iconElement && /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefix$11, "--blockquote__icon-wrapper")
      }, iconElement), /*#__PURE__*/React.createElement("div", {
        className: blockquoteContentClass,
        style: style
      }, (title || toggleable) && /*#__PURE__*/React.createElement("div", {
        onClick: this.toggleBlockquote,
        onKeyDown: this.toggleBlockquote,
        className: "".concat(prefix$11, "--blockquote__title"),
        role: "button",
        tabIndex: 0
      }, title ? title : this.state.open ? 'Hide content' : 'Show content'), /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefix$11, "--blockquote__inside")
      }, children)), actionButtons && /*#__PURE__*/React.createElement("div", {
        className: "wfp--blockquote__action-buttons"
      }, actionButtons));
    }
  }]);

  return Blockquote;
}(React.Component);

Blockquote.propTypes = {
  /**
   * Specify a className of your `Blockquote`
   */
  className: PropTypes.string,

  /**
   * Specify the content of your `Blockquote`
   */
  children: PropTypes.node,

  /**
   * Show content formated as code
   */
  code: PropTypes.bool,

  /**
   * Display light version of Blockquote
   */
  light: PropTypes.bool,

  /**
   * Show options to show and hide the Blockquote when title is clicked
   */
  toggleable: PropTypes.bool,

  /**
   * Show title for Blockquote
   */
  title: PropTypes.node,

  /**
   * Specify the type of your Blockquote Options are `info` `error` `warning` `info`
   */
  kind: PropTypes.oneOf(['info', 'warning', 'error', 'success']),

  /**
   * Specify if an Icon should be displayed
   */
  withIcon: PropTypes.bool,

  /**
   * Specify a custom icon. Can be either a `Icon` object or React component
   */
  icon: PropTypes.oneOfType([PropTypes.node, PropTypes.object])
};
var Blockquote$1 = Blockquote;

var _excluded$Y = ["children", "className"];
var prefix$10 = settings$1.prefix;
/**
 * The breadcrumb is a secondary navigation pattern that helps a user understand the hierarchy among levels and navigate back through them. */

var Breadcrumb = function Breadcrumb(_ref) {
  var _classnames;

  var children = _ref.children,
      className = _ref.className,
      other = _objectWithoutProperties(_ref, _excluded$Y);

  var classNames = classnames$1(className, (_classnames = {}, _defineProperty(_classnames, "".concat(prefix$10, "--breadcrumb"), true), _defineProperty(_classnames, "".concat(prefix$10, "--breadcrumb--no-trailing-slash"), true), _classnames));
  return /*#__PURE__*/React.createElement("div", _extends({
    className: classNames
  }, other), children);
};

Breadcrumb.propTypes = {
  /**
   * Pass in the BreadcrumbItem's for your Breadcrumb
   */
  children: PropTypes.node,

  /**
   * Specify an optional className to be applied to the container node
   */
  className: PropTypes.string
};
var Breadcrumb$1 = Breadcrumb;

var _excluded$X = ["children", "className", "disableLink", "href"];
var prefix$$ = settings$1.prefix;

var newChild = function newChild(children, disableLink, href) {
  if (disableLink === true) {
    return /*#__PURE__*/React.createElement("span", null, children);
  } else if (typeof children === 'string' && !(href === undefined)) {
    return /*#__PURE__*/React.createElement(Link$1, {
      href: href
    }, children);
  } else {
    return /*#__PURE__*/React.cloneElement(React.Children.only(children), {
      className: "".concat(prefix$$, "--link")
    });
  }
};

var BreadcrumbItem = function BreadcrumbItem(_ref) {
  var children = _ref.children,
      className = _ref.className,
      disableLink = _ref.disableLink,
      href = _ref.href,
      other = _objectWithoutProperties(_ref, _excluded$X);

  var classNames = classnames$1("".concat(prefix$$, "--breadcrumb-item"), className);
  return /*#__PURE__*/React.createElement("div", _extends({
    className: classNames
  }, other), newChild(children, disableLink, href));
};

BreadcrumbItem.propTypes = {
  /**
   * The children elements, usually a link
   */
  children: PropTypes.node,

  /**
   * Specify an optional className to be added to the `BreadcrumbItem` Icon
   */
  className: PropTypes.string,

  /**
   * Specify an link for the `BreadcrumbItem`
   */
  href: PropTypes.string,

  /**
   * Specify `BreadcrumbItem` to be interactive/enabled or non-interactive/disabled
   */
  disableLink: PropTypes.bool
};
var BreadcrumbItem$1 = BreadcrumbItem;

var _excluded$W = ["className", "hometext"];
var prefix$_ = settings$1.prefix;

var BreadcrumbHome = function BreadcrumbHome(_ref) {
  var className = _ref.className,
      hometext = _ref.hometext,
      other = _objectWithoutProperties(_ref, _excluded$W);

  var classNames = classnames$1("".concat(prefix$_, "--breadcrumb-home"), className);
  return /*#__PURE__*/React.createElement(Icon$1, _extends({
    icon: iconHome,
    fill: "#0b77c2",
    width: "14",
    height: "14",
    description: hometext,
    className: classNames
  }, other));
};

BreadcrumbHome.propTypes = {
  /**
   * Specify an optional className to be added to the `Home` Icon
   */
  className: PropTypes.string,

  /**
   * Specify an optional text for the `Home` Icon
   */
  hometext: PropTypes.string
};
var BreadcrumbHome$1 = BreadcrumbHome;

var _excluded$V = ["children", "className", "disabled", "small", "large", "kind", "href", "iconReverse", "tabIndex", "type", "useFlexbox", "icon", "iconDescription", "onClick"];
var prefix$Z = settings$1.prefix;
/**
 * Buttons express what action will occur when the user clicks or touches it. Buttons are used to initialize an action, either in the background or foreground of an experience. */

var Button = function Button(_ref) {
  var _classNames;

  var children = _ref.children,
      className = _ref.className,
      disabled = _ref.disabled,
      small = _ref.small,
      large = _ref.large,
      kind = _ref.kind,
      href = _ref.href,
      iconReverse = _ref.iconReverse,
      tabIndex = _ref.tabIndex,
      type = _ref.type,
      useFlexbox = _ref.useFlexbox,
      icon = _ref.icon,
      iconDescription = _ref.iconDescription,
      onClick = _ref.onClick,
      other = _objectWithoutProperties(_ref, _excluded$V);

  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      count = _useState2[0],
      setCount = _useState2[1];

  useEffect(function () {
    var timer = setTimeout(function () {
      return endAnimation();
    }, 500);
    return function () {
      clearTimeout(timer);
    };
  }, [count]);
  var buttonClasses = classnames$1(className, (_classNames = {}, _defineProperty(_classNames, "".concat(prefix$Z, "--btn"), true), _defineProperty(_classNames, "".concat(prefix$Z, "--btn--sm"), small), _defineProperty(_classNames, "".concat(prefix$Z, "--btn--lg"), large), _defineProperty(_classNames, "".concat(prefix$Z, "--btn--icon-reverse"), iconReverse), _defineProperty(_classNames, "".concat(prefix$Z, "--btn--flexbox"), useFlexbox), _defineProperty(_classNames, "".concat(prefix$Z, "--btn--icon-only"), icon && children === undefined), _defineProperty(_classNames, "".concat(prefix$Z, "--btn--primary"), kind === 'primary'), _defineProperty(_classNames, "".concat(prefix$Z, "--btn--danger"), kind === 'danger'), _defineProperty(_classNames, "".concat(prefix$Z, "--btn--accent"), kind === 'accent'), _defineProperty(_classNames, "".concat(prefix$Z, "--btn--secondary"), kind === 'secondary'), _defineProperty(_classNames, "".concat(prefix$Z, "--btn--navigation"), kind === 'navigation'), _defineProperty(_classNames, "".concat(prefix$Z, "--btn--ghost"), kind === 'ghost'), _defineProperty(_classNames, "".concat(prefix$Z, "--btn--inverse--primary"), kind === 'inverse--primary'), _defineProperty(_classNames, "".concat(prefix$Z, "--btn--inverse"), kind === 'inverse'), _defineProperty(_classNames, "".concat(prefix$Z, "--btn--danger--primary"), kind === 'danger--primary'), _defineProperty(_classNames, "".concat(prefix$Z, "--btn--danger--secondary"), kind === 'danger--secondary'), _defineProperty(_classNames, "".concat(prefix$Z, "--btn--tertiary"), kind === 'tertiary'), _defineProperty(_classNames, "".concat(prefix$Z, "--btn--animating"), count), _classNames));
  var commonProps = {
    tabIndex: tabIndex,
    className: buttonClasses
  };
  var buttonImage = icon ? /*#__PURE__*/React.createElement(Icon$1, {
    icon: Object(icon) === icon ? icon : undefined,
    name: Object(icon) !== icon ? icon : undefined,
    description: iconDescription,
    className: "".concat(prefix$Z, "--btn__icon")
  }) : null;

  var endAnimation = function endAnimation() {
    setCount(false);
  };

  var onClickAnimation = function onClickAnimation(e) {
    if (onClick) {
      onClick(e);
    }

    setCount(true);
  };

  var button = /*#__PURE__*/React.createElement("button", _extends({}, other, commonProps, {
    disabled: disabled,
    type: type,
    onClick: onClickAnimation,
    ref: other.inputRef
  }), iconReverse && buttonImage, children, !iconReverse && buttonImage);
  var anchor = /*#__PURE__*/React.createElement("a", _extends({}, other, commonProps, {
    href: href,
    role: "button",
    onClick: onClickAnimation,
    ref: other.inputRef
  }), children, buttonImage);
  return href ? anchor : button;
};

Button.propTypes = {
  /**
   * Specify the content of your Button
   */
  children: PropTypes.node,

  /**
   * Specify an optional className to be added to your Button
   */
  className: PropTypes.string,

  /**
   * Specify whether the Button should be disabled, or not
   */
  disabled: PropTypes.bool,

  /**
   * FOR DESIGNERS
   * Specify whether the Button should be a small variant
   */
  small: PropTypes.bool,

  /**
   * FOR DESIGNERS
   * Specify whether the Button should be a large variant
   */
  large: PropTypes.bool,

  /**
   * FOR DESIGNERS
   * Specify the kind of Button you want to create
   */
  kind: PropTypes.oneOf(['primary', 'secondary', 'accent', 'danger', 'ghost', 'inverse--primary', 'inverse', 'danger--primary', 'tertiary', 'navigation']),
  //ButtonTypes.buttonKind.isRequired,

  /**
   * Optionally specify an href for your Button to become an <a> element
   */
  href: PropTypes.string,

  /**
   * Optional prop to specify the tabIndex of the Button
   */
  tabIndex: PropTypes.number,

  /**
   * Optional prop to specify the type of the Button
   */
  type: PropTypes.oneOf(['button', 'reset', 'submit']),

  /**
   * Optional prop to specify the role of the Button
   */
  role: PropTypes.string,

  /**
   * Specify an `icon` to include in the Button through an object representing the SVG data of the icon, similar to the `Icon` component
   */
  icon: PropTypes.shape({
    width: PropTypes.string,
    height: PropTypes.string,
    viewBox: PropTypes.string.isRequired,
    svgData: PropTypes.object.isRequired
  }),

  /**
   * If specifying the `icon` prop, provide a description for that icon that can
   * be read by screen readers
   */
  iconDescription: function iconDescription(props) {
    if (props.icon && !props.iconDescription) {
      return new Error('icon property specified without also providing an iconDescription property.');
    }

    return undefined;
  },

  /**
   * Optionally specify an href for your Button to become an <a> element
   */
  iconReverse: PropTypes.bool
};
Button.defaultProps = {
  iconReverse: false,
  iconDescription: 'Provide icon description if icon is used',
  tabIndex: 0,
  type: 'button',
  disabled: false,
  small: false,
  kind: 'primary'
};
var Button$1 = Button;

var _excluded$U = ["button", "children", "className", "href", "icon", "title", "kind"];
var prefix$Y = settings$1.prefix;
/** The Empty component can be used whenever a section should indicate that there is no content available. This can be the case for a empty list table or search results. */

var Empty = function Empty(_ref) {
  var _classnames;

  var button = _ref.button,
      children = _ref.children,
      className = _ref.className;
      _ref.href;
      var icon = _ref.icon,
      title = _ref.title,
      _ref$kind = _ref.kind,
      kind = _ref$kind === void 0 ? 'large' : _ref$kind,
      other = _objectWithoutProperties(_ref, _excluded$U);

  var classNames = classnames$1((_classnames = {}, _defineProperty(_classnames, "".concat(prefix$Y, "--empty"), true), _defineProperty(_classnames, "".concat(prefix$Y, "--empty--").concat(kind), kind), _classnames), className);
  return /*#__PURE__*/React.createElement("div", _extends({
    className: classNames
  }, other), /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefix$Y, "--empty__icon")
  }, icon), /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefix$Y, "--empty__text")
  }, title && /*#__PURE__*/React.createElement("h2", null, title), /*#__PURE__*/React.createElement("p", null, children)), /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefix$Y, "--empty__button")
  }, button));
};
Empty.propTypes = {
  /**
   * Provide the description for the Empty content
   */
  children: PropTypes.node,

  /**
   * Provide the title for the Empty contet
   */
  title: PropTypes.node,

  /**
   * Provide the icon for the Empty content
   */
  icon: PropTypes.node,

  /**
   * Provide one or multiple buttons
   */
  button: PropTypes.node,

  /**
   * Provide a custom className to be applied to the containing <a> node
   */
  className: PropTypes.string,

  /**
   * Provide a kind to use different appearances.
   */
  kind: PropTypes.oneOf(['undefined', 'large'])
};
var Empty$1 = Empty;

var _excluded$T = ["children", "className", "image", "isExternal", "isLink", "metadata", "more", "subTitle", "title", "kind", "url"];
var prefix$X = settings$1.prefix;
/**
 * Hero are a convenient means of displaying content composed of different types of objects. It is a multi usage component which creates boxes that are usually teasing some kind of content. */

var Hero = function Hero(_ref) {
  var _classNames;

  var children = _ref.children,
      className = _ref.className,
      image = _ref.image,
      isExternal = _ref.isExternal,
      isLink = _ref.isLink,
      metadata = _ref.metadata,
      more = _ref.more,
      subTitle = _ref.subTitle,
      title = _ref.title,
      kind = _ref.kind,
      url = _ref.url,
      other = _objectWithoutProperties(_ref, _excluded$T);

  var style = kind !== 'related' ? {
    backgroundImage: "url(".concat(image, ")")
  } : {};
  var wrapperClasses = classnames$1("".concat(prefix$X, "--photo-card"), (_classNames = {}, _defineProperty(_classNames, "".concat(prefix$X, "--photo-card--").concat(kind), kind), _defineProperty(_classNames, "".concat(prefix$X, "--photo-card--no-background"), !image), _defineProperty(_classNames, "".concat(prefix$X, "--photo-card--link"), isLink), _defineProperty(_classNames, "".concat(className), className), _classNames));
  var content = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefix$X, "--photo-card__background"),
    style: style
  }), image && kind === 'related' && /*#__PURE__*/React.createElement("img", {
    src: image,
    alt: title
  }), /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefix$X, "--photo-card__info")
  }, /*#__PURE__*/React.createElement("div", null, (kind === 'landscape' || kind === 'hero') && /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefix$X, "--photo-card__info__background"),
    style: style
  }), metadata && /*#__PURE__*/React.createElement("p", {
    className: "".concat(prefix$X, "--photo-card__info__metadata")
  }, metadata), title && (kind === 'hero' || kind === 'page-splash') && /*#__PURE__*/React.createElement("h2", {
    className: "".concat(prefix$X, "--photo-card__info__title")
  }, title), title && kind !== 'hero' && kind !== 'page-splash' && /*#__PURE__*/React.createElement("h3", {
    className: "".concat(prefix$X, "--photo-card__info__title")
  }, title), subTitle && /*#__PURE__*/React.createElement("p", {
    className: "".concat(prefix$X, "--photo-card__info__subtitle")
  }, subTitle)), kind === 'hero' || kind === 'splash-image' || kind === 'splash-compact' && /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefix$X, "--photo-card__info__more")
  }, more)), children);
  return isLink ? /*#__PURE__*/React.createElement("a", _extends({
    href: url,
    target: isExternal ? '_blank' : '',
    className: wrapperClasses
  }, other), content) : /*#__PURE__*/React.createElement("div", _extends({
    className: wrapperClasses
  }, other), content);
};

Hero.propTypes = {
  /**
   Additional className which will be added
  */
  className: PropTypes.string,

  /**
   The links target
  */
  href: PropTypes.string,

  /**
   An optimized photograph
  */
  image: PropTypes.string,

  /**
  External link flag
  */
  isExternal: PropTypes.bool,

  /**
  Render the Hero as link
  */
  isLink: PropTypes.bool,

  /**
  A short sentence to explain the content of the node (max 180 characters) 
  */
  subTitle: PropTypes.node,

  /**
   A search-friendly title (ideally 50 characters, max 100) 
  */
  title: PropTypes.node,

  /**
  Additional metadatas
  */
  metadata: PropTypes.string,

  /**
  Additional more content
  */
  more: PropTypes.node,

  /**
  Kind of Hero
  */
  kind: PropTypes.oneOf(['landscape', 'landscape-light', 'emergencies', 'split', 'hero', 'splash', 'splash-image', 'splash-compact', 'related']).isRequired,

  /**
  The URL where the content uploaded is located.
  */
  url: PropTypes.string
};
Hero.defaultProps = {
  isLink: true
};
var Hero$1 = Hero;

var _excluded$S = ["children", "className", "image", "isExternal", "isLink", "metadata", "subTitle", "title", "kind", "url", "cardWidth", "cardHeight"];
var prefix$W = settings$1.prefix;
/**
 * Cards are a convenient means of displaying content composed of different types of objects. It is a multi usage component which creates boxes that are usually teasing some kind of content. */

var Card = function Card(_ref) {
  var _classNames;

  var children = _ref.children,
      className = _ref.className,
      image = _ref.image,
      isExternal = _ref.isExternal,
      isLink = _ref.isLink,
      metadata = _ref.metadata,
      subTitle = _ref.subTitle,
      title = _ref.title,
      kind = _ref.kind,
      url = _ref.url,
      cardWidth = _ref.cardWidth,
      cardHeight = _ref.cardHeight,
      other = _objectWithoutProperties(_ref, _excluded$S);

  var style = kind == 'overlay' ? {
    backgroundImage: "url(".concat(image, ")")
  } : {};
  var pagewidth = cardWidth ? cardWidth : '300px';
  var pageheight = cardHeight ? cardHeight : '260px';
  var wrapperClasses = classnames$1(["".concat(prefix$W, "--card-box")], (_classNames = {}, _defineProperty(_classNames, "".concat(prefix$W, "--photo-cardnew--").concat(kind), kind), _defineProperty(_classNames, "".concat(prefix$W, "--photo-cardnew--link"), isLink), _defineProperty(_classNames, "".concat(className), className), _classNames));
  var content = /*#__PURE__*/React.createElement(React.Fragment, null, kind === 'overlay' ? /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefix$W, "--photo-cardnew__background"),
    style: style
  }) : null, image && kind === 'simple-card' ? /*#__PURE__*/React.createElement("img", {
    src: image,
    alt: title,
    className: "".concat(prefix$W, "--header-photo")
  }) : null, /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefix$W, "--photo-cardnew__info")
  }, /*#__PURE__*/React.createElement("div", null, kind === 'overlay' && /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefix$W, "--photo-cardnew__info__background"),
    style: style
  }), metadata && /*#__PURE__*/React.createElement("p", {
    className: "".concat(prefix$W, "--photo-cardnew__info__metadata")
  }, metadata), title && /*#__PURE__*/React.createElement("h3", {
    className: "".concat(prefix$W, "--photo-cardnew__info__title")
  }, title), subTitle && /*#__PURE__*/React.createElement("p", {
    className: "".concat(prefix$W, "--photo-cardnew__info__subtitle")
  }, subTitle))), children);
  return isLink ? /*#__PURE__*/React.createElement("div", {
    className: wrapperClasses,
    style: {
      width: pagewidth,
      minHeight: pageheight
    }
  }, /*#__PURE__*/React.createElement("a", _extends({
    href: url,
    target: isExternal ? '_blank' : '',
    style: {
      width: pagewidth,
      minHeight: pageheight
    }
  }, other), content)) : /*#__PURE__*/React.createElement("div", _extends({
    className: wrapperClasses
  }, other, {
    style: {
      width: pagewidth,
      minHeight: pageheight
    }
  }), content);
};

Card.propTypes = {
  /**
   Additional className which will be added
  */
  className: PropTypes.string,

  /**
   An optimized photograph
  */
  image: PropTypes.string,

  /**
  isExternal if true, opens link in a different window
  */
  isExternal: PropTypes.bool,

  /**
  Render the Card as link
  */
  isLink: PropTypes.bool,

  /**
  A short sentence to explain the content of the node (max 180 characters) 
  */
  subTitle: PropTypes.node,

  /**
   A search-friendly title (ideally 50 characters, max 100) 
  */
  title: PropTypes.node,

  /**
  Additional metadatas
  */
  metadata: PropTypes.string,

  /**
  Kind of Card
  */
  kind: PropTypes.oneOf(['simple-card', 'overlay']).isRequired,

  /**
  The URL where the content uploaded is located.
  */
  url: PropTypes.string,

  /**
   * override default card width with preferred width
   */
  cardWidth: PropTypes.string,

  /**
   * override default card width with preferred width
   */
  cardHeight: PropTypes.string
};
Card.defaultProps = {
  isLink: true
};
var Card$1 = Card;

var _excluded$R = ["className", "id", "labelText", "onChange", "indeterminate", "hideLabel", "wrapperClassName", "inputRef", "title"];
var prefix$V = settings$1.prefix;
/**
 * Checkboxes are used for a list of options where the user may select multiple options, including all or none. */

var Checkbox = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var className = props.className,
      id = props.id,
      labelText = props.labelText,
      _onChange = props.onChange,
      indeterminate = props.indeterminate,
      hideLabel = props.hideLabel,
      wrapperClassName = props.wrapperClassName,
      _props$inputRef = props.inputRef,
      inputRef = _props$inputRef === void 0 ? ref : _props$inputRef,
      _props$title = props.title,
      title = _props$title === void 0 ? '' : _props$title,
      other = _objectWithoutProperties(props, _excluded$R);

  var customId = id ? id : other.name;
  var labelClasses = classnames$1("".concat(prefix$V, "--checkbox-label"), className);
  var innerLabelClasses = classnames$1(_defineProperty({}, "".concat(prefix$V, "--visually-hidden"), hideLabel));
  var wrapperClasses = classnames$1("".concat(prefix$V, "--form-item"), "".concat(prefix$V, "--checkbox-wrapper"), wrapperClassName);
  return /*#__PURE__*/React.createElement("div", {
    className: wrapperClasses
  }, /*#__PURE__*/React.createElement("input", _extends({}, other, {
    type: "checkbox",
    onChange: function onChange(evt) {
      _onChange(evt, evt.target.checked, customId);
    },
    className: "wfp--checkbox",
    id: customId,
    ref: function ref(el) {
      if (el) {
        el.indeterminate = indeterminate;
      }

      if (typeof inputRef === 'function') {
        inputRef(el);
      } else if (Object(inputRef) === inputRef) {
        inputRef.current = el;
      }
    }
  })), /*#__PURE__*/React.createElement("label", {
    htmlFor: customId,
    className: labelClasses,
    title: title || null
  }, /*#__PURE__*/React.createElement("span", {
    className: innerLabelClasses
  }, labelText)));
});
Checkbox.propTypes = {
  /**
   * Specify whether the underlying input should be checked
   */
  checked: PropTypes.bool,

  /**
   * Specify whether the underlying input should be checked by default
   */
  defaultChecked: PropTypes.bool,

  /**
   * Specify whether the Checkbox is in an indeterminate state
   */
  indeterminate: PropTypes.bool,

  /**
   * Specify an optional className to be applied to the <label> node
   */
  className: PropTypes.string,

  /**
   * Specify whether the Checkbox should be disabled
   */
  disabled: PropTypes.bool,

  /**
   * Provide an `id` to uniquely identify the Checkbox input
   */
  id: PropTypes.string.isRequired,

  /**
   * Provide a label to provide a description of the Checkbox input that you are
   * exposing to the user
   */
  labelText: PropTypes.node.isRequired,

  /**
   * Specify whether the label should be hidden, or not
   */
  hideLabel: PropTypes.bool,

  /**
   * Receives three arguments: the dom event, true/false and the checkbox's id.
   */
  onChange: PropTypes.func,

  /**
   * Specify a title for the <label> node for the Checkbox
   */
  title: PropTypes.string,

  /**
   * The CSS class name to be placed on the wrapping element
   */
  wrapperClassName: PropTypes.string
};
Checkbox.defaultProps = {
  onChange: function onChange() {},
  indeterminate: false
};
var Checkbox$1 = Checkbox;

var _excluded$Q = ["children", "className", "info"];
var prefix$U = settings$1.prefix;
/** Credits are mostly used when a photo need a source attribution. */

var Credits = function Credits(_ref) {
  var children = _ref.children,
      className = _ref.className,
      info = _ref.info,
      other = _objectWithoutProperties(_ref, _excluded$Q);

  var classNames = classnames$1("".concat(prefix$U, "--credits"), className);
  return /*#__PURE__*/React.createElement("div", _extends({
    className: classNames
  }, other), /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefix$U, "--credits__info")
  }, info), children);
};

Credits.propTypes = {
  /**
  Specify the image or content
  */
  children: PropTypes.node,

  /**
  Additional className which will be added
  */
  className: PropTypes.string,

  /**
  Specifiy the info content
  */
  info: PropTypes.string
};
var Credits$1 = Credits;

var _excluded$P = ["children", "className", "selectedIndex", "small", "onChange"];
var prefix$T = settings$1.prefix;
/** ContentSwitcher manipulates the content shown following an exclusive or “either/or” pattern. It is used to toggle between two or more content sections within the same space on screen. Only one section can be shown at a time.
 */

function ContentSwitcher(_ref) {
  var children = _ref.children,
      className = _ref.className,
      selectedIndex = _ref.selectedIndex,
      small = _ref.small,
      onChange = _ref.onChange,
      other = _objectWithoutProperties(_ref, _excluded$P);

  var _useState = useState(selectedIndex),
      _useState2 = _slicedToArray(_useState, 2),
      selectedIdx = _useState2[0],
      setSelectedIndex = _useState2[1];

  var getChildren = function getChildren(children) {
    return React.Children.map(children, function (child, index) {
      return /*#__PURE__*/React.cloneElement(child, {
        index: index,
        onClick: handleChildChange,
        onKeyDown: handleChildChange,
        selected: index === selectedIdx
      });
    });
  };

  var handleChildChange = function handleChildChange(data) {
    var index = data.index;

    if (selectedIdx !== index) {
      setSelectedIndex(index);
      onChange(data);
    }
  };

  var classes = classnames$1("".concat(prefix$T, "--content-switcher"), className, _defineProperty({}, "".concat(prefix$T, "--content-switcher--sm"), small));
  return /*#__PURE__*/React.createElement("div", _extends({}, other, {
    className: classes
  }), getChildren(children));
}
ContentSwitcher.propTypes = {
  /** Specify the content of your ContentSwitcher */
  children: PropTypes.node,

  /** Specify an optional className to be added to your ContentSwitcher */
  className: PropTypes.string,

  /** Specify an `onChange` handler that is called whenever the ContentSwitcher changes which item is selected */
  onChange: PropTypes.func.isRequired,

  /** Specify a selected index for the initially selected content */
  selectedIndex: PropTypes.number
};
ContentSwitcher.defaultProps = {
  selectedIndex: 0
};

var _excluded$O = ["className", "dark", "noPadding", "children", "content", "trigger", "modifiers", "placement", "createRefWrapper", "closeOnOutsideClick", "closeOnTriggerHidden", "defaultVisible", "delayHide", "delayShow", "followCursor", "interactive", "mutationObserverOptions", "offset", "onVisibleChange"];
var prefix$S = settings$1.prefix;
var tooltipStyle = {
  duration: 100,
  animation: 'fade',
  theme: 'light',
  arrow: true
};
var tooltipStyleDark = {
  duration: 100,
  animation: 'fade',
  theme: 'dark',
  arrow: true
};
/** Tooltips display additional information upon click, hover, or focus. The information should be contextual, useful, and nonessential. */

var Tooltip = function Tooltip(_ref) {
  var _classnames, _children$props;

  var className = _ref.className,
      dark = _ref.dark,
      noPadding = _ref.noPadding,
      children = _ref.children,
      content = _ref.content,
      _ref$trigger = _ref.trigger,
      trigger = _ref$trigger === void 0 ? 'hover' : _ref$trigger;
      _ref.modifiers;
      var _ref$placement = _ref.placement,
      placement = _ref$placement === void 0 ? 'top' : _ref$placement,
      createRefWrapper = _ref.createRefWrapper,
      closeOnOutsideClick = _ref.closeOnOutsideClick,
      closeOnTriggerHidden = _ref.closeOnTriggerHidden,
      defaultVisible = _ref.defaultVisible,
      delayHide = _ref.delayHide,
      delayShow = _ref.delayShow,
      followCursor = _ref.followCursor,
      interactive = _ref.interactive,
      mutationObserverOptions = _ref.mutationObserverOptions,
      offset = _ref.offset,
      onVisibleChange = _ref.onVisibleChange;
      _objectWithoutProperties(_ref, _excluded$O);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      visibility = _useState2[0],
      setVisibility = _useState2[1];

  var classNames = classnames$1(className, (_classnames = {}, _defineProperty(_classnames, "".concat(prefix$S, "--tooltip"), true), _defineProperty(_classnames, "".concat(prefix$S, "--tooltip--disable-padding"), noPadding), _defineProperty(_classnames, "".concat(prefix$S, "--tooltip--visible"), visibility), _defineProperty(_classnames, "".concat(prefix$S, "--tooltip--").concat(trigger), trigger), _defineProperty(_classnames, "".concat(prefix$S, "--tooltip--dark"), dark), _classnames));

  var _usePopperTooltip = usePopperTooltip({
    closeOnOutsideClick: closeOnOutsideClick,
    closeOnTriggerHidden: closeOnTriggerHidden,
    defaultVisible: defaultVisible,
    delayHide: delayHide,
    delayShow: delayShow,
    followCursor: followCursor,
    interactive: interactive,
    mutationObserverOptions: mutationObserverOptions,
    offset: offset,
    onVisibleChange: onVisibleChange,
    placement: placement,
    trigger: trigger
  }),
      getArrowProps = _usePopperTooltip.getArrowProps,
      getTooltipProps = _usePopperTooltip.getTooltipProps,
      setTooltipRef = _usePopperTooltip.setTooltipRef,
      setTriggerRef = _usePopperTooltip.setTriggerRef,
      visible = _usePopperTooltip.visible;

  var elementClassNames = classnames$1(children === null || children === void 0 ? void 0 : (_children$props = children.props) === null || _children$props === void 0 ? void 0 : _children$props.className, _defineProperty({}, "".concat(prefix$S, "--tooltip--trigger"), true));
  var wrapperClassNames = classnames$1(className, _defineProperty({}, "".concat(prefix$S, "--tooltip--trigger"), true));
  var triggerElement = !createRefWrapper && typeof children !== 'string' ? /*#__PURE__*/React.cloneElement(children, {
    ref: setTriggerRef,
    className: elementClassNames
  }) : /*#__PURE__*/React.createElement("span", {
    ref: setTriggerRef,
    className: wrapperClassNames
  }, children);

  var visibilityChange = function visibilityChange(e) {
    setVisibility(e);
    if (onVisibilityChange) onVisibilityChange(e);
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, triggerElement, visible && /*#__PURE__*/React.createElement("div", _extends({
    ref: setTooltipRef
  }, getTooltipProps({
    className: classNames
  })), typeof content === 'function' ? content({
    setVisibility: setVisibility,
    visibilityChange: visibilityChange
  }) : content, /*#__PURE__*/React.createElement("div", getArrowProps({
    className: "".concat(prefix$S, "--tooltip__arrow")
  }))));
};

Tooltip.propTypes = {
  /**
   * Provide the children on which the tooltip will show on
   */
  children: PropTypes.node,

  /**
   * Provide the content for the tooltip
   */
  content: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),

  /**
   * Provide a dark styled tooltip
   */
  dark: PropTypes.bool,

  /**
   * Disable the default inner padding of the tooltip
   */
  noPadding: PropTypes.bool,

  /**
   * Provide the placement of the tooltip
   */
  placement: PropTypes.oneOf(['top', 'top-start', 'top-end', 'right', 'right-start', 'right-end', 'bottom', 'bottom-start', 'bottom-end', 'left', 'left-start', 'left-end']),

  /**
   * Provide the placement of the tooltip
   */
  trigger: PropTypes.oneOf(['hover', 'click']),

  /**
   * Provide additional modifiers as an object https://popper.js.org/docs/v2/modifiers/
   */
  modifiers: PropTypes.array,

  /**
   * Whether to use React.createPortal for creating tooltip.
   */
  usePortal: PropTypes.bool,

  /**
   * Use a wrapper html element around the trigger. Useful for components without `forwardRef` support.
   */
  createRefWrapper: PropTypes.bool
};
var Tooltip$1 = Tooltip;

var _excluded$N = ["children", "className", "content", "href", "inline", "trigger"],
    _excluded2$4 = ["className"],
    _excluded3$4 = ["className"];
var prefix$R = settings$1.prefix;
/** Context menu are used as navigational elements. They should contain commands that apply to the target object. */

var ContextMenu = function ContextMenu(_ref) {
  var children = _ref.children,
      className = _ref.className,
      content = _ref.content;
      _ref.href;
      _ref.inline;
      _ref.trigger;
      _objectWithoutProperties(_ref, _excluded$N);

  var classNames = classnames$1(_defineProperty({}, "".concat(prefix$R, "--context-menu"), true), className);
  return /*#__PURE__*/React.createElement(Tooltip$1, {
    className: classNames,
    content: content,
    noPadding: true,
    trigger: "click"
  }, children);
};
function ContextMenuGroup(_ref2) {
  var className = _ref2.className,
      other = _objectWithoutProperties(_ref2, _excluded2$4);

  var classNames = classnames$1(_defineProperty({}, "".concat(prefix$R, "--context-menu__group"), true), className);
  return /*#__PURE__*/React.createElement("div", _extends({
    className: classNames
  }, other));
}
ContextMenuGroup.propTypes = {
  /**
   * Provide the content for the ContentMenu
   */
  children: PropTypes.node,

  /**
   * Provide a custom className
   */
  className: PropTypes.string
};
function ContextMenuItem(_ref3) {
  var className = _ref3.className,
      other = _objectWithoutProperties(_ref3, _excluded3$4);

  var classNames = classnames$1(_defineProperty({}, "".concat(prefix$R, "--context-menu__item"), true), className);
  return /*#__PURE__*/React.createElement("div", _extends({
    className: classNames
  }, other));
}
ContextMenu.propTypes = {
  /**
   * Provide the content for the ContentMenu
   */
  children: PropTypes.node,

  /**
   * Provide a custom className
   */
  className: PropTypes.string,

  /**
   * Provide content to display when contextMenu is clicked
   */
  content: PropTypes.node,

  /**
   * Inline links are used within a sentence or paragraph and are styled with an underline. They should not be paired with an icon.
   */
  inline: PropTypes.bool
};
var ContextMenu$1 = ContextMenu;

var _excluded$M = ["controlled", "datePicker", "labelText", "className", "id", "placeholder", "type", "onChange", "onClick", "hideLabel", "invalid", "invalidText", "helperText", "active", "value", "name", "onFocus", "onBlur", "onDragStart", "onDrop", "showClearDate", "isDirty", "isTouched", "error", "date"];
var prefix$Q = settings$1.prefix;
var SingleDatePickerInput = /*#__PURE__*/function (_PureComponent) {
  _inherits(SingleDatePickerInput, _PureComponent);

  var _super = _createSuper(SingleDatePickerInput);

  function SingleDatePickerInput() {
    var _this;

    _classCallCheck(this, SingleDatePickerInput);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      controlledValue: _this.props.value ? _this.props.value : null,
      focusedInput: null
    });

    _defineProperty(_assertThisInitialized(_this), "handleFocusChange", function (focusedInput) {
      if (!focusedInput && typeof _this.props.onBlur === 'function') {
        _this.props.onBlur();
      }

      _this.setState({
        focusedInput: focusedInput
      });
    });

    return _this;
  }

  _createClass(SingleDatePickerInput, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props;
          _this$props.controlled;
          var datePicker = _this$props.datePicker,
          labelText = _this$props.labelText;
          _this$props.className;
          var id = _this$props.id;
          _this$props.placeholder;
          _this$props.type;
          var onChange = _this$props.onChange;
          _this$props.onClick;
          var hideLabel = _this$props.hideLabel,
          invalid = _this$props.invalid,
          invalidText = _this$props.invalidText,
          helperText = _this$props.helperText;
          _this$props.active;
          var value = _this$props.value;
          _this$props.name;
          var onFocus = _this$props.onFocus,
          onBlur = _this$props.onBlur;
          _this$props.onDragStart;
          _this$props.onDrop;
          _this$props.showClearDate;
          _this$props.isDirty;
          _this$props.isTouched;
          _this$props.error;
          _this$props.date;
          var other = _objectWithoutProperties(_this$props, _excluded$M);

      var _this$state = this.state,
          controlledValue = _this$state.controlledValue,
          focused = _this$state.focused;
      var SingleDatePicker = datePicker;
      var labelClasses = classnames$1("".concat(prefix$Q, "--label"), _defineProperty({}, "".concat(prefix$Q, "--visually-hidden"), hideLabel));
      var label = labelText ? /*#__PURE__*/React.createElement("label", {
        htmlFor: id,
        className: labelClasses
      }, labelText) : null;
      var errorMessage = invalid ? /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefix$Q, "--form-requirement invalid")
      }, invalidText) : null;
      var helper = helperText ? /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefix$Q, "--form__helper-text")
      }, helperText) : null;
      return /*#__PURE__*/React.createElement("div", {
        className: "wfp--form-item"
      }, label, helper, /*#__PURE__*/React.createElement(SingleDatePicker, _extends({
        date: onChange && value ? value : controlledValue,
        focused: focused,
        hideKeyboardShortcutsPanel: true,
        onDateChange: function onDateChange(value) {
          if (onChange) {
            onChange(value);
          }

          _this2.setState({
            controlledValue: value
          }, function () {});
        },
        onFocusChange: function onFocusChange(_ref) {
          var focused = _ref.focused;

          _this2.setState({
            focused: focused
          });

          focused ? onFocus(true) : onBlur(true);
        }
      }, other)), errorMessage);
    }
  }]);

  return SingleDatePickerInput;
}(PureComponent);
SingleDatePickerInput.defaultProps = {
  onFocus: function onFocus() {},
  onBlur: function onBlur() {},
  onChange: function onChange() {}
};
SingleDatePickerInput.propTypes = {
  /**
   * Provide the SingleDatePicker as a component
   */
  datePicker: PropTypes.oneOfType([PropTypes.node, PropTypes.func, PropTypes.object]),
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,

  /**
   * Provide a custom className that is applied directly to the underlying
   * node
   */
  className: PropTypes.string,

  /**
   * Specify whether the control is disabled
   */
  disabled: PropTypes.bool,

  /**
   * Provide a unique identifier for the control
   */
  id: PropTypes.string,

  /**
   * Provide the text that will be read by a screen reader when visiting this
   * control
   */
  labelText: PropTypes.node.isRequired,

  /**
   * Optionally provide an `onChange` handler that is called whenever date
   * is updated
   */
  onChange: PropTypes.func,

  /**
   * Optionally provide an `onClick` handler that is called whenever the
   * date is clicked
   */
  onClick: PropTypes.func,

  /**
   * Specify the placeholder attribute for the datepicker
   */
  placeholder: PropTypes.string,

  /**
   * Specify whether to clear selected date or not
   */
  showClearDate: PropTypes.bool,

  /**
   * Specify whether you want to show the calendar icon. It is true by default.
   */
  showDefaultInputIcon: PropTypes.bool,

  /**
   * Specify whether the control is currently invalid.
   * Either a boolean in combination with `invalidText` or an `object`( eg. { message: "Message", …otherErrorProperties }) can be passed.
   */
  invalid: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),

  /**
   * Provide the text that is displayed when the control is in an invalid state
   */
  invalidText: PropTypes.string,

  /**
   * Provide text that is used alongside the control label for additional help
   */
  helperText: PropTypes.node,

  /**
   * Specify whether you want the underlying label to be visually hidden
   */
  hideLabel: PropTypes.bool
};

var _excluded$L = ["controlled", "datePicker", "labelText", "className", "id", "placeholder", "type", "onChange", "onClick", "hideLabel", "invalid", "invalidText", "helperText", "value", "startDateId", "startDatePlaceholderText", "endDateId", "endDatePlaceholderText", "name", "onBlur", "onDragStart", "onDrop", "onFocus", "showClearDate", "isDirty", "isTouched", "error", "date"];
var prefix$P = settings$1.prefix;
var DateRangePickerInput = /*#__PURE__*/function (_PureComponent) {
  _inherits(DateRangePickerInput, _PureComponent);

  var _super = _createSuper(DateRangePickerInput);

  function DateRangePickerInput() {
    var _this;

    _classCallCheck(this, DateRangePickerInput);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      focusedInput: null,
      startDate: _this.props.startDate ? _this.props.startDate : null,
      endDate: _this.props.endDate ? _this.props.endDate : null
    });

    _defineProperty(_assertThisInitialized(_this), "handleFocusChange", function (focusedInput) {
      if (!focusedInput && typeof _this.props.onBlur === 'function') {
        _this.props.onBlur();
      }

      _this.setState({
        focusedInput: focusedInput
      });
    });

    return _this;
  }

  _createClass(DateRangePickerInput, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props;
          _this$props.controlled;
          var datePicker = _this$props.datePicker,
          labelText = _this$props.labelText;
          _this$props.className;
          var id = _this$props.id;
          _this$props.placeholder;
          _this$props.type;
          var onChange = _this$props.onChange;
          _this$props.onClick;
          var hideLabel = _this$props.hideLabel,
          invalid = _this$props.invalid,
          invalidText = _this$props.invalidText,
          helperText = _this$props.helperText,
          value = _this$props.value,
          startDateId = _this$props.startDateId,
          startDatePlaceholderText = _this$props.startDatePlaceholderText,
          endDateId = _this$props.endDateId,
          endDatePlaceholderText = _this$props.endDatePlaceholderText;
          _this$props.name;
          _this$props.onBlur;
          _this$props.onDragStart;
          _this$props.onDrop;
          _this$props.onFocus;
          _this$props.showClearDate;
          _this$props.isDirty;
          _this$props.isTouched;
          _this$props.error;
          _this$props.date;
          var other = _objectWithoutProperties(_this$props, _excluded$L);

      var _this$state = this.state,
          focusedInput = _this$state.focusedInput,
          startDate = _this$state.startDate,
          endDate = _this$state.endDate;
      var DateRangePicker = datePicker;
      var labelClasses = classnames$1("".concat(prefix$P, "--label"), _defineProperty({}, "".concat(prefix$P, "--visually-hidden"), hideLabel));
      var label = labelText ? /*#__PURE__*/React.createElement("label", {
        htmlFor: id,
        className: labelClasses
      }, labelText) : null;
      var errorMessage = invalid ? /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefix$P, "--form-requirement invalid")
      }, invalidText) : null;
      var helper = helperText ? /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefix$P, "--form__helper-text")
      }, helperText) : null;
      return /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefix$P, "--form-item")
      }, label, helper, /*#__PURE__*/React.createElement(DateRangePicker, _extends({
        endDateId: endDateId,
        endDate: onChange && value ? value.endDate : endDate,
        endDatePlaceholderText: endDatePlaceholderText,
        focusedInput: focusedInput,
        hideKeyboardShortcutsPanel: true,
        onDatesChange: function onDatesChange(_ref) {
          var startDate = _ref.startDate,
              endDate = _ref.endDate;

          if (onChange) {
            onChange({
              startDate: startDate,
              endDate: endDate
            });
          }

          _this2.setState({
            startDate: startDate,
            endDate: endDate
          });
        },
        onFocusChange: this.handleFocusChange,
        startDateId: startDateId,
        startDate: onChange && value ? value.startDate : startDate,
        startDatePlaceholderText: startDatePlaceholderText
      }, other)), errorMessage);
    }
  }]);

  return DateRangePickerInput;
}(PureComponent);
DateRangePickerInput.defaultProps = {
  startDateId: 'startDate',
  endDateId: 'endDate',
  startDatePlaceholderText: 'Start Date',
  endDatePlaceholderText: 'End Date'
};
DateRangePickerInput.propTypes = {
  /**
   * Provide the SingleDatePicker as a component
   */
  datePicker: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),

  /**
   * Provide the placeholder for the start input
   */
  startDatePlaceholderText: PropTypes.string,

  /**
   * Provide the placeholder for the end input
   */
  endDatePlaceholderText: PropTypes.string
};

/**
 * Next gen of Carbon component design.
 */
var componentsX = false;

var _excluded$K = ["active", "className", "withOverlay", "small"];
var prefix$O = settings$1.prefix;
/** Loading spinners are used when retrieving data or performing slow computations, and help to notify users that loading is underway. */

var Loading = /*#__PURE__*/function (_React$Component) {
  _inherits(Loading, _React$Component);

  var _super = _createSuper(Loading);

  function Loading() {
    _classCallCheck(this, Loading);

    return _super.apply(this, arguments);
  }

  _createClass(Loading, [{
    key: "render",
    value: function render() {
      var _classNames;

      var _this$props = this.props,
          active = _this$props.active,
          className = _this$props.className,
          withOverlay = _this$props.withOverlay,
          small = _this$props.small,
          other = _objectWithoutProperties(_this$props, _excluded$K);

      var loadingClasses = classnames$1("".concat(prefix$O, "--loading"), className, (_classNames = {}, _defineProperty(_classNames, "".concat(prefix$O, "--loading--small"), small), _defineProperty(_classNames, "".concat(prefix$O, "--loading--stop"), !active), _classNames));
      var overlayClasses = classnames$1("".concat(prefix$O, "--loading-overlay"), _defineProperty({}, "".concat(prefix$O, "--loading-overlay--stop"), !active));
      var loading = /*#__PURE__*/React.createElement("div", _extends({}, other, {
        "aria-live": active ? 'assertive' : 'off',
        className: loadingClasses
      }), /*#__PURE__*/React.createElement("svg", {
        className: "".concat(prefix$O, "--loading__svg"),
        viewBox: "-75 -75 150 150"
      }, /*#__PURE__*/React.createElement("title", null, "Loading"), componentsX && small ? /*#__PURE__*/React.createElement("circle", {
        className: "".concat(prefix$O, "--loading__background"),
        cx: "0",
        cy: "0",
        r: "37.5"
      }) : null, /*#__PURE__*/React.createElement("circle", {
        className: componentsX ? "".concat(prefix$O, "--loading__stroke") : null,
        cx: "0",
        cy: "0",
        r: "37.5"
      })));
      return withOverlay ? /*#__PURE__*/React.createElement("div", {
        className: overlayClasses
      }, loading) : loading;
    }
  }]);

  return Loading;
}(React.Component);

_defineProperty(Loading, "propTypes", {
  /**
   * Specify whether you want the loading indicator to be spinning or not
   */
  active: PropTypes.bool,

  /**
   * Provide an optional className to be applied to the containing node
   */
  className: PropTypes.string,

  /**
   * Specify whether you want the loader to be applied with an overlay
   */
  withOverlay: PropTypes.bool,

  /**
   * Specify whether you would like the small variant of <Loading>
   */
  small: PropTypes.bool
});

_defineProperty(Loading, "defaultProps", {
  active: true,
  withOverlay: true,
  small: false
});

var lastId = 0;
function uniqueId() {
  var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'id';
  lastId++;
  return "".concat(prefix).concat(lastId);
}

var ButtonTypes = {
  buttonKind: oneOf(['primary', 'secondary', 'accent', 'danger', 'ghost', 'inverse--primary', 'inverse', 'danger--primary', 'tertiary', 'navigation'])
};

var _excluded$J = ["className", "disableLabelChanges", "labelText", "multiple", "role", "tabIndex", "buttonKind", "accept", "name", "disabled"],
    _excluded2$3 = ["iconDescription", "status", "invalid"],
    _excluded3$3 = ["iconDescription", "buttonLabel", "buttonKind", "filenameStatus", "labelDescription", "labelTitle", "className", "multiple", "accept", "name"];
var prefix$N = settings$1.prefix;
var FileUploaderButton = /*#__PURE__*/function (_Component) {
  _inherits(FileUploaderButton, _Component);

  var _super = _createSuper(FileUploaderButton);

  function FileUploaderButton() {
    var _this;

    _classCallCheck(this, FileUploaderButton);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {});

    _defineProperty(_assertThisInitialized(_this), "handleChange", function (evt) {
      var files = evt.target.files;
      var length = evt.target.files.length;

      if (files && !_this.props.disableLabelChanges) {
        if (length > 1) {
          _this.setState({
            labelText: "".concat(length, " files")
          });
        } else if (length === 1) {
          _this.setState({
            labelText: files[0].name
          });
        }
      }

      _this.props.onChange(evt);
    });

    return _this;
  }

  _createClass(FileUploaderButton, [{
    key: "render",
    value: function render() {
      var _classNames,
          _this2 = this;

      var _this$props = this.props,
          className = _this$props.className;
          _this$props.disableLabelChanges;
          _this$props.labelText;
          var multiple = _this$props.multiple,
          role = _this$props.role,
          tabIndex = _this$props.tabIndex,
          buttonKind = _this$props.buttonKind,
          accept = _this$props.accept,
          name = _this$props.name,
          disabled = _this$props.disabled,
          other = _objectWithoutProperties(_this$props, _excluded$J);

      var classes = classnames$1("".concat(prefix$N, "--btn"), className, (_classNames = {}, _defineProperty(_classNames, "".concat(prefix$N, "--btn--").concat(buttonKind), buttonKind), _defineProperty(_classNames, "".concat(prefix$N, "--btn--disabled"), disabled), _classNames));
      this.uid = this.props.id || uniqueId();
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("label", _extends({
        tabIndex: disabled ? -1 : tabIndex || 0,
        "aria-disabled": disabled,
        className: classes,
        onKeyDown: function onKeyDown(evt) {
          if (evt.which === 13 || evt.which === 32) {
            _this2.input.click();
          }
        },
        htmlFor: this.uid
      }, other), /*#__PURE__*/React.createElement("span", {
        role: role
      }, this.state.labelText)), /*#__PURE__*/React.createElement("input", {
        className: "".concat(prefix$N, "--visually-hidden"),
        ref: function ref(input) {
          return _this2.input = input;
        },
        id: this.uid,
        disabled: disabled,
        type: "file",
        tabIndex: "-1",
        multiple: multiple,
        accept: accept,
        name: name,
        onChange: this.handleChange,
        onClick: function onClick(evt) {
          evt.target.value = null;
        }
      }));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(_ref, state) {
      var labelText = _ref.labelText;
      var prevLabelText = state.prevLabelText;
      return prevLabelText === labelText ? null : {
        labelText: labelText,
        prevLabelText: labelText
      };
    }
  }]);

  return FileUploaderButton;
}(Component);

_defineProperty(FileUploaderButton, "propTypes", {
  /**
   * Provide a custom className to be applied to the container node
   */
  className: PropTypes.string,

  /**
   * Specify whether you want to disable any updates to the FileUploaderButton
   * label
   */
  disableLabelChanges: PropTypes.bool,

  /**
   * Provide a unique id for the underlying <input> node
   */
  id: PropTypes.string,

  /**
   * Provide the label text to be read by screen readers when interacting with
   * this control
   */
  labelText: PropTypes.node,

  /**
   * Specify whether you want the component to list the files that have been
   * submitted to be uploaded
   */
  listFiles: PropTypes.bool,

  /**
   * Specify if the component should accept multiple files to upload
   */
  multiple: PropTypes.bool,

  /**
   * Provide a name for the underlying <input> node
   */
  name: PropTypes.string,

  /**
   * Provide an optional `onChange` hook that is called each time the <input>
   * value changes
   */
  onChange: PropTypes.func,

  /**
   * Provide an optional `onClick` hook that is called each time the button is
   * clicked
   */
  onClick: PropTypes.func,

  /**
   * Provide an accessibility role for the <FileUploaderButton>
   */
  role: PropTypes.string,

  /**
   * Provide a custom tabIndex value for the <FileUploaderButton>
   */
  tabIndex: PropTypes.number,

  /**
   * Specify the type of underlying button
   */
  buttonKind: ButtonTypes.buttonKind,

  /**
   * Specify the types of files that this input should be able to receive
   */
  accept: PropTypes.arrayOf(PropTypes.string),

  /**
   * Specify whether file input is disabled
   */
  disabled: PropTypes.bool
});

_defineProperty(FileUploaderButton, "defaultProps", {
  tabIndex: 0,
  disableLabelChanges: false,
  labelText: 'Add file',
  buttonKind: 'primary',
  multiple: false,
  onChange: function onChange() {},
  onClick: function onClick() {},
  accept: [],
  disabled: false,
  role: 'button'
});

function Filename(_ref2) {
  var iconDescription = _ref2.iconDescription,
      status = _ref2.status,
      invalid = _ref2.invalid,
      other = _objectWithoutProperties(_ref2, _excluded2$3);

  switch (status) {
    case 'uploading':
      return /*#__PURE__*/React.createElement(Loading, {
        description: iconDescription,
        withOverlay: false,
        small: true
      });

    case 'edit':
      return /*#__PURE__*/React.createElement(React.Fragment, null, invalid && /*#__PURE__*/React.createElement(Icon$1, {
        icon: iconWarningGlyph,
        className: "".concat(prefix$N, "--file-invalid")
      }), /*#__PURE__*/React.createElement(Icon$1, _extends({
        icon: iconCloseGlyph,
        className: "".concat(prefix$N, "--file-close"),
        "aria-label": iconDescription
      }, other)));

    case 'complete':
      return /*#__PURE__*/React.createElement(Icon$1, _extends({
        icon: iconCheckmarkGlyph,
        className: "".concat(prefix$N, "--file-complete"),
        "aria-label": iconDescription
      }, other));

    default:
      return null;
  }
}
Filename.propTypes = {
  /**
   * Provide a description of the SVG icon to denote file upload status
   */
  iconDescription: PropTypes.string,

  /**
   * Status of the file upload
   */
  status: PropTypes.oneOf(['edit', 'complete', 'uploading']),

  /**
   * Provide a custom tabIndex value for the <Filename>
   */
  tabIndex: PropTypes.string
};
Filename.defaultProps = {
  iconDescription: 'Uploading file',
  status: 'uploading',
  tabIndex: '0'
};

var FileUploader = /*#__PURE__*/function (_Component2) {
  _inherits(FileUploader, _Component2);

  var _super2 = _createSuper(FileUploader);

  function FileUploader() {
    var _this3;

    _classCallCheck(this, FileUploader);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this3 = _super2.call.apply(_super2, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this3), "state", {
      filenames: []
    });

    _defineProperty(_assertThisInitialized(_this3), "nodes", []);

    _defineProperty(_assertThisInitialized(_this3), "handleChange", function (evt) {
      evt.stopPropagation();

      _this3.setState({
        filenames: _this3.state.filenames.concat(Array.prototype.map.call(evt.target.files, function (file) {
          return file.name;
        }))
      });

      if (_this3.props.onChange) {
        _this3.props.onChange(evt);
      }
    });

    _defineProperty(_assertThisInitialized(_this3), "handleClick", function (evt, index) {
      var filteredArray = _this3.state.filenames.filter(function (filename) {
        return filename !== _this3.nodes[index].innerText.trim();
      });

      _this3.setState({
        filenames: filteredArray
      });

      _this3.props.onClick(evt);
    });

    _defineProperty(_assertThisInitialized(_this3), "clearFiles", function () {
      // A clearFiles function that resets filenames and can be referenced using a ref by the parent.
      _this3.setState({
        filenames: []
      });
    });

    return _this3;
  }

  _createClass(FileUploader, [{
    key: "render",
    value: function render() {
      var _classNames2,
          _this4 = this;

      var _this$props2 = this.props,
          iconDescription = _this$props2.iconDescription,
          buttonLabel = _this$props2.buttonLabel,
          buttonKind = _this$props2.buttonKind,
          filenameStatus = _this$props2.filenameStatus,
          labelDescription = _this$props2.labelDescription,
          labelTitle = _this$props2.labelTitle,
          className = _this$props2.className,
          multiple = _this$props2.multiple,
          accept = _this$props2.accept,
          name = _this$props2.name,
          other = _objectWithoutProperties(_this$props2, _excluded3$3);

      var classes = classnames$1((_classNames2 = {}, _defineProperty(_classNames2, "".concat(prefix$N, "--form-item"), true), _defineProperty(_classNames2, className, className), _classNames2));
      return /*#__PURE__*/React.createElement("div", _extends({
        className: classes
      }, other), /*#__PURE__*/React.createElement("strong", {
        className: "".concat(prefix$N, "--file--label")
      }, labelTitle), /*#__PURE__*/React.createElement("p", {
        className: "".concat(prefix$N, "--label-description")
      }, labelDescription), /*#__PURE__*/React.createElement(FileUploaderButton, {
        labelText: buttonLabel,
        multiple: multiple,
        buttonKind: buttonKind,
        onChange: this.handleChange,
        disableLabelChanges: true,
        accept: accept,
        name: name
      }), /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefix$N, "--file-container")
      }, this.state.filenames.length === 0 ? null : this.state.filenames.map(function (name, index) {
        return /*#__PURE__*/React.createElement("span", _extends({
          key: index,
          className: "".concat(prefix$N, "--file__selected-file"),
          ref: function ref(node) {
            return _this4.nodes[index] = node;
          } // eslint-disable-line

        }, other), /*#__PURE__*/React.createElement("p", {
          className: "".concat(prefix$N, "--file-filename")
        }, name), /*#__PURE__*/React.createElement("span", {
          className: "".concat(prefix$N, "--file__state-container")
        }, /*#__PURE__*/React.createElement(Filename, {
          iconDescription: iconDescription,
          status: filenameStatus,
          onKeyDown: function onKeyDown(evt) {
            if (evt.which === 13 || evt.which === 32) {
              _this4.handleClick(evt, index);
            }
          },
          onClick: function onClick(evt) {
            if (filenameStatus === 'edit') {
              _this4.handleClick(evt, index);
            }
          }
        })));
      })));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(_ref3, state) {
      var filenameStatus = _ref3.filenameStatus;
      var prevFilenameStatus = state.prevFilenameStatus;
      return prevFilenameStatus === filenameStatus ? null : {
        filenameStatus: filenameStatus,
        prevFilenameStatus: filenameStatus
      };
    }
  }]);

  return FileUploader;
}(Component);

_defineProperty(FileUploader, "propTypes", {
  /**
   * Provide a description for the complete/close icon that can be read by screen readers
   */
  iconDescription: PropTypes.string,

  /**
   * Provide the label text to be read by screen readers when interacting with
   * the <FileUploaderButton>
   */
  buttonLabel: PropTypes.string,

  /**
   * Specify the type of the <FileUploaderButton>
   */
  //buttonKind: PropTypes.oneOf(buttonKinds),

  /**
   * Specify the status of the File Upload
   */
  //filenameStatus: PropTypes.oneOf(['edit', 'complete', 'uploading'])
  //  .isRequired,

  /**
   * Specify the description text of this <FileUploader>
   */
  labelDescription: PropTypes.string,

  /**
   * Specify the title text of this <FileUploader>
   */
  labelTitle: PropTypes.string,

  /**
   * Specify if the component should accept multiple files to upload
   */
  multiple: PropTypes.bool,

  /**
   * Provide a name for the underlying <input> node
   */
  name: PropTypes.string,

  /**
   * Provide an optional `onChange` hook that is called each time the input is
   * changed
   */
  onChange: PropTypes.func,

  /**
   * Provide an optional `onClick` hook that is called each time the button is
   * clicked
   */
  onClick: PropTypes.func,

  /**
   * Provide a custom className to be applied to the container node
   */
  className: PropTypes.string
  /**
   * Specify the types of files that this input should be able to receive
   */
  //accept: PropTypes.arrayOf(PropTypes.string),

});

_defineProperty(FileUploader, "defaultProps", {
  iconDescription: 'Provide icon description',
  filenameStatus: 'uploading',
  buttonLabel: '',
  buttonKind: 'primary',
  multiple: false,
  onClick: function onClick() {},
  accept: []
});

var _excluded$I = ["uuid", "name", "status", "iconDescription", "onDelete", "invalid", "errorSubject", "errorBody"];
var prefix$M = settings$1.prefix;
function FileUploaderItem(_ref) {
  var uuid = _ref.uuid,
      name = _ref.name,
      status = _ref.status,
      iconDescription = _ref.iconDescription,
      onDelete = _ref.onDelete,
      invalid = _ref.invalid,
      errorSubject = _ref.errorSubject,
      errorBody = _ref.errorBody,
      other = _objectWithoutProperties(_ref, _excluded$I);

  var classes = classnames$1("".concat(prefix$M, "--file__selected-file"), _defineProperty({}, "".concat(prefix$M, "--file__selected-file--invalid"), invalid));
  return /*#__PURE__*/React.createElement("span", _extends({
    className: classes
  }, other), /*#__PURE__*/React.createElement("p", {
    className: "".concat(prefix$M, "--file-filename")
  }, name), /*#__PURE__*/React.createElement("span", {
    className: "".concat(prefix$M, "--file__state-container")
  }, /*#__PURE__*/React.createElement(Filename, {
    iconDescription: iconDescription,
    status: status,
    invalid: invalid,
    onKeyDown: function onKeyDown(evt) {
      /*
      if (matches(evt, [keys.Enter, keys.Space])) {
        if (status === 'edit') {
          onDelete(evt, { uuid });
        }
      }
      }*/
    },
    onClick: function onClick(evt) {
      if (status === 'edit') {
        onDelete(evt, {
          uuid: uuid
        });
      }
    }
  })), invalid && errorSubject && /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefix$M, "--form-requirement")
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefix$M, "--form-requirement__title")
  }, errorSubject), errorBody && /*#__PURE__*/React.createElement("p", {
    className: "".concat(prefix$M, "--form-requirement__supplement")
  }, errorBody)));
}
FileUploaderItem.propTypes = {
  /**
   * Unique identifier for the file object
   */
  uuid: PropTypes.string.isRequired,

  /**
   * Name of the uploaded file
   */
  name: PropTypes.string,

  /**
   * Status of the file upload
   */
  status: PropTypes.oneOf(['uploading', 'edit', 'complete']),

  /**
   * Description of status icon (displayed in native tooltip)
   */
  iconDescription: PropTypes.string,

  /**
   * Specify whether the control is currently invalid.
   * Either a boolean in combination with `invalidText` or an `object`( eg. { message: "Message", …otherErrorProperties }) can be passed.
   */
  invalid: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),

  /**
   * Event handler that is called after removing a file from the file uploader
   * The event handler signature looks like `onDelete(evt, { uuid })`
   */
  onDelete: PropTypes.func,

  /**
   * Error message subject for an invalid file upload
   */
  errorSubject: PropTypes.string,

  /**
   * Error message body for an invalid file upload
   */
  errorBody: PropTypes.string
};
FileUploaderItem.defaultProps = {
  uuid: uniqueId(),
  status: 'uploading',
  onDelete: function onDelete() {}
};

var _excluded$H = ["accept", "className", "id", "disabled", "labelText", "multiple", "name", "onAddFiles", "role", "tabIndex"];
var prefix$L = settings$1.prefix;
function FileUploaderDropContainer(props) {
  var _classNames2;

  var inputRef = useRef();

  var accept = props.accept,
      className = props.className,
      id = props.id,
      disabled = props.disabled,
      labelText = props.labelText,
      multiple = props.multiple,
      name = props.name,
      onAddFiles = props.onAddFiles,
      role = props.role,
      tabIndex = props.tabIndex,
      other = _objectWithoutProperties(props, _excluded$H);

  var uid = useRef(uniqueId());

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isActive = _useState2[0],
      setActive = _useState2[1];

  var labelClasses = classnames$1("".concat(prefix$L, "--file-browse-btn"), _defineProperty({}, "".concat(prefix$L, "--file-browse-btn--disabled"), disabled));
  var dropareaClasses = classnames$1("".concat(prefix$L, "--file__drop-container"), (_classNames2 = {}, _defineProperty(_classNames2, "".concat(prefix$L, "--file__drop-container--drag-over"), isActive), _defineProperty(_classNames2, className, className), _classNames2));
  /**
   * Filters the array of added files based on file type restrictions
   * @param {Event} evt - Event object, used to get the list of files added
   */

  var validateFiles = function validateFiles(evt) {
    if (evt.type === 'drop') {
      var transferredFiles = _toConsumableArray(evt.dataTransfer.files);

      if (!accept.length) {
        return transferredFiles;
      }

      var acceptedTypes = new Set(accept);
      return transferredFiles.filter(function (_ref) {
        var name = _ref.name,
            _ref$type = _ref.type,
            mimeType = _ref$type === void 0 ? '' : _ref$type;
        var fileExtensionRegExp = new RegExp(/\.[0-9a-z]+$/, 'i');
        var hasFileExtension = fileExtensionRegExp.test(name);

        if (!hasFileExtension) {
          return false;
        }

        var _name$match = name.match(fileExtensionRegExp),
            _name$match2 = _slicedToArray(_name$match, 1),
            fileExtension = _name$match2[0];

        return acceptedTypes.has(mimeType) || acceptedTypes.has(fileExtension);
      });
    }

    return _toConsumableArray(evt.target.files);
  };

  var handleChange = function handleChange(evt) {
    var addedFiles = validateFiles(evt);
    return onAddFiles(evt, {
      addedFiles: addedFiles
    });
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefix$L, "--file"),
    onDragOver: function onDragOver(evt) {
      evt.stopPropagation();
      evt.preventDefault();

      if (disabled) {
        return;
      }

      setActive(true);
      evt.dataTransfer.dropEffect = 'copy';
    },
    onDragLeave: function onDragLeave(evt) {
      evt.stopPropagation();
      evt.preventDefault();

      if (disabled) {
        return;
      }

      setActive(false);
      evt.dataTransfer.dropEffect = 'move';
    },
    onDrop: function onDrop(evt) {
      evt.stopPropagation();
      evt.preventDefault();

      if (disabled) {
        return;
      }

      setActive(false);
      handleChange(evt);
    }
  }, /*#__PURE__*/React.createElement("label", _extends({
    className: labelClasses,
    htmlFor: id || uid.current,
    tabIndex: tabIndex || 0,
    onKeyDown: function onKeyDown(evt) {
      /*if (matches(evt, [keys.Enter, keys.Space])) {
        inputRef.current.click();
      }*/
    }
  }, other), /*#__PURE__*/React.createElement("div", {
    className: dropareaClasses,
    role: role || 'button'
  }, labelText, /*#__PURE__*/React.createElement("input", {
    type: "file",
    id: id || uid.current,
    className: "".concat(prefix$L, "--file-input"),
    ref: inputRef,
    tabIndex: "-1",
    disabled: disabled,
    accept: accept,
    name: name,
    multiple: multiple,
    onChange: handleChange,
    onClick: function onClick(evt) {
      evt.target.value = null;
    }
  }))));
}
FileUploaderDropContainer.propTypes = {
  /**
   * Provide a custom className to be applied to the container node
   */
  className: PropTypes.string,

  /**
   * Provide a unique id for the underlying <input> node
   */
  id: PropTypes.string,

  /**
   * Provide the label text to be read by screen readers when interacting with
   * this control
   */
  labelText: PropTypes.string.isRequired,

  /**
   * Specify if the component should accept multiple files to upload
   */
  multiple: PropTypes.bool,

  /**
   * Provide a name for the underlying <input> node
   */
  name: PropTypes.string,

  /**
   * Provide an accessibility role for the <FileUploaderButton>
   */
  role: PropTypes.string,

  /**
   * Provide a custom tabIndex value for the <FileUploaderButton>
   */
  tabIndex: PropTypes.number,

  /**
   * Specify whether file input is disabled
   */
  disabled: PropTypes.bool,

  /**
   * Specify the types of files that this input should be able to receive
   */
  accept: PropTypes.arrayOf(PropTypes.string),

  /**
   * Event handler that is called after files are added to the uploader
   * The event handler signature looks like `onAddFiles(evt, { addedFiles })`
   */
  onAddFiles: PropTypes.func
};
FileUploaderDropContainer.defaultProps = {
  tabIndex: 0,
  labelText: 'Add file',
  multiple: false,
  onAddFiles: function onAddFiles() {},
  accept: []
};

var _excluded$G = ["buttonText", "className", "children", "external", "labelOne", "linkTextOne", "linkHrefOne", "labelTwo", "linkTextTwo", "linkHrefTwo", "logo", "logoExtended", "metaContent", "metaLinks", "secondary", "sdgLogo", "pageWidth"];
var prefix$K = settings$1.prefix;
/** A Footer is a section at the bottom of each page. It typically contains basic site information, copyright data or links to related pages. */

var Footer = function Footer(_ref) {
  _ref.buttonText;
      var className = _ref.className,
      children = _ref.children,
      external = _ref.external,
      labelOne = _ref.labelOne,
      linkTextOne = _ref.linkTextOne,
      linkHrefOne = _ref.linkHrefOne,
      labelTwo = _ref.labelTwo,
      linkTextTwo = _ref.linkTextTwo,
      linkHrefTwo = _ref.linkHrefTwo,
      logo = _ref.logo,
      logoExtended = _ref.logoExtended,
      metaContent = _ref.metaContent,
      metaLinks = _ref.metaLinks,
      secondary = _ref.secondary;
      _ref.sdgLogo;
      var pageWidth = _ref.pageWidth;
      _objectWithoutProperties(_ref, _excluded$G);

  var classNames = classnames$1("".concat(prefix$K, "--footer"), _defineProperty({}, "".concat(prefix$K, "--footer--external"), external), className);
  var footer = /*#__PURE__*/React.createElement("footer", {
    className: classNames
  }, /*#__PURE__*/React.createElement(Wrapper$1, {
    pageWidth: pageWidth
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefix$K, "--footer__content")
  }, children ? /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefix$K, "--footer__info")
  }, children) : /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefix$K, "--footer__info")
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefix$K, "--footer__info__item")
  }, /*#__PURE__*/React.createElement("p", {
    className: "".concat(prefix$K, "--footer__label")
  }, labelOne), /*#__PURE__*/React.createElement("ul", {
    className: "".concat(prefix$K, "--footer__list")
  }, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(Link$1, {
    href: linkHrefOne
  }, linkTextOne)))), /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefix$K, "--footer__info__item")
  }, /*#__PURE__*/React.createElement("p", {
    className: "".concat(prefix$K, "--footer__label")
  }, labelTwo), /*#__PURE__*/React.createElement("ul", {
    className: "".concat(prefix$K, "--footer__list")
  }, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(Link$1, {
    href: linkHrefTwo
  }, linkTextTwo))))), /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefix$K, "--footer__cta")
  }, logoExtended && typeof logoExtended === 'string' ? /*#__PURE__*/React.createElement("img", {
    className: "".concat(prefix$K, "--footer__cta-logo"),
    src: logoExtended,
    alt: "World Food Programme Logo"
  }) : logoExtended ? logoExtended : /*#__PURE__*/React.createElement(Icon$1, {
    className: "".concat(prefix$K, "--footer__cta-logo"),
    icon: iconWfpLogoStandardBlackEn,
    alt: "WFP"
  }), logo && typeof logo === 'string' ? /*#__PURE__*/React.createElement("img", {
    className: "".concat(prefix$K, "--footer__cta-logo-small"),
    src: logo,
    alt: "World Food Programme Logo"
  }) : logo ? logo : /*#__PURE__*/React.createElement(Icon$1, {
    icon: iconWfpLogoVerticalEn,
    description: "WFP",
    className: "".concat(prefix$K, "--footer__cta-logo-small")
  }), secondary && /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefix$K, "--footer__secondary")
  }, secondary)))), /*#__PURE__*/React.createElement(Wrapper$1, {
    className: "".concat(prefix$K, "--footer__meta"),
    pageWidth: pageWidth
  }, metaLinks && /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefix$K, "--footer__meta__links")
  }, metaLinks), metaContent && /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefix$K, "--footer__meta__content")
  }, metaContent)));
  return footer;
};

Footer.propTypes = {
  /**
   The content of the footer containing relevant links
  */
  children: PropTypes.node,

  /**
   Additional className which will be added
  */
  className: PropTypes.string,

  /** 
   When external is set to true, the logo will be left and description will right on the footer. It is false by default.
  */
  external: PropTypes.bool,

  /** 
   Meta content, usually the copyright notice
  */
  metaContent: PropTypes.node,

  /**
   Optional WFP logo for mobile devices, can be used if the Logo should be provided by the CDN
  */
  logo: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),

  /**
   Optional WFP logo for desktop devices, can be used if the Logo should be provided by the CDN
  */
  logoExtended: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),

  /**
   * Specify the max-width on desktop devices (same as \`Wrapper\` component)
   */
  pageWidth: PropTypes.oneOf(['sm', 'md', 'lg', 'full']),

  /**
   Override the SDG icon
  */
  sdgLogo: PropTypes.node,

  /**
   The WFP logo, can be used if the SDG logo should be provided in a different way
  */
  subTitle: PropTypes.node
};
Footer.defaultProps = {
  pageWidth: 'lg'
};
var Footer$1 = Footer;

var _excluded$F = ["className", "children", "longForm"];
var prefix$J = settings$1.prefix;
/** A form is a group of related input controls that allows users to provide data or configure options. */

var Form = function Form(_ref) {
  var className = _ref.className,
      children = _ref.children,
      longForm = _ref.longForm,
      other = _objectWithoutProperties(_ref, _excluded$F);

  var classNames = classnames$1("".concat(prefix$J, "--form"), _defineProperty({}, "".concat(prefix$J, "--form-long"), longForm === true), className);
  return /*#__PURE__*/React.createElement("form", _extends({
    className: classNames
  }, other), children);
};

Form.propTypes = {
  /**
   * Provide children to be rendered inside of the <form> element
   */
  children: PropTypes.node,

  /**
   * Provide a custom className to be applied on the containing <form> node
   */
  className: PropTypes.string,

  /**
   * Default margin is added to each form input
   */
  longForm: PropTypes.bool
};
Form.defaultProps = {
  longForm: true
};
var Form$1 = Form;

var prefix$I = settings$1.prefix;

var FormControls = /*#__PURE__*/function (_React$Component) {
  _inherits(FormControls, _React$Component);

  var _super = _createSuper(FormControls);

  function FormControls() {
    _classCallCheck(this, FormControls);

    return _super.apply(this, arguments);
  }

  _createClass(FormControls, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          onNextClick = _this$props.onNextClick,
          nextDisabled = _this$props.nextDisabled,
          nextIcon = _this$props.nextIcon,
          nextHidden = _this$props.nextHidden,
          nextText = _this$props.nextText,
          onPreviousClick = _this$props.onPreviousClick,
          previousDisabled = _this$props.previousDisabled,
          previousIcon = _this$props.previousIcon,
          previousHidden = _this$props.previousHidden,
          previousText = _this$props.previousText,
          onSubmitClick = _this$props.onSubmitClick,
          submitDisabled = _this$props.submitDisabled,
          submitIcon = _this$props.submitIcon,
          submitHidden = _this$props.submitHidden,
          submitText = _this$props.submitText;
      var formControlsClasses = classnames$1("".concat(prefix$I, "--form-controls"), className);
      return /*#__PURE__*/React.createElement("div", {
        className: formControlsClasses
      }, /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefix$I, "--form-controls__steps")
      }, !previousHidden && /*#__PURE__*/React.createElement(Button$1, {
        disabled: previousDisabled,
        kind: "secondary",
        className: "".concat(prefix$I, "--form-controls__prev"),
        icon: previousIcon,
        onClick: onPreviousClick
      }, previousText)), /*#__PURE__*/React.createElement("div", null, !nextHidden && /*#__PURE__*/React.createElement(Button$1, {
        disabled: nextDisabled,
        kind: "secondary",
        className: "".concat(prefix$I, "--form-controls__next"),
        icon: nextIcon,
        type: "submit",
        onClick: onNextClick
      }, nextText), !submitHidden && /*#__PURE__*/React.createElement(Button$1, {
        disabled: submitDisabled,
        type: "submit",
        className: "next",
        icon: submitIcon,
        onClick: onSubmitClick
      }, submitText)));
    }
  }]);

  return FormControls;
}(React.Component);

_defineProperty(FormControls, "propTypes", {
  /**
   * Specify the text to be read by screen-readers when visiting the <Tabs>
   * component
   */
  className: PropTypes.string,
  onNextClick: PropTypes.func,
  nextDisabled: PropTypes.bool,
  nextIcon: PropTypes.object,
  nextHidden: PropTypes.bool,
  nextText: PropTypes.node,
  onPreviousClick: PropTypes.func,
  previousDisabled: PropTypes.bool,
  previousIcon: PropTypes.object,
  previousHidden: PropTypes.bool,
  previousText: PropTypes.node,
  onSubmitClick: PropTypes.func,
  submitDisabled: PropTypes.bool,
  submitIcon: PropTypes.object,
  submitHidden: PropTypes.bool,
  submitText: PropTypes.node
});

_defineProperty(FormControls, "defaultProps", {
  nextIcon: iconArrowRight,
  nextText: 'Next',
  previousIcon: iconArrowLeft,
  previousText: 'Previous',
  submitText: 'Submit'
});

var prefix$H = settings$1.prefix;

var FormError = function FormError(_ref) {
  var className = _ref.className,
      message = _ref.message,
      submitFailed = _ref.submitFailed;

  if (message && submitFailed === true) {
    return /*#__PURE__*/React.createElement(Blockquote$1, {
      className: className,
      warning: true,
      withIcon: false
    }, /*#__PURE__*/React.createElement("h4", {
      className: "".concat(prefix$H, "--form-error__title")
    }, message.generic), message.fields && /*#__PURE__*/React.createElement("ul", {
      className: "".concat(prefix$H, "--form-error__list")
    }, message.fields.map(function (field, i) {
      return /*#__PURE__*/React.createElement("li", {
        key: i
      }, /*#__PURE__*/React.createElement("label", {
        htmlFor: field.key
      }, field.message));
    })));
  } else {
    return null;
  }
};

FormError.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  info: PropTypes.string
};
var FormError$1 = FormError;

var _excluded$E = ["align", "breakpoint", "legendText", "inline", "invalid", "children", "className", "inputSpacing", "message", "messageText"];
var prefix$G = settings$1.prefix;
/** A FormGroup element is used to group several controls as well as labels  within a web form. It uses  `<fieldset>` */

var FormGroup = function FormGroup(_ref) {
  var _classnames;

  var align = _ref.align,
      breakpoint = _ref.breakpoint,
      legendText = _ref.legendText,
      inline = _ref.inline,
      invalid = _ref.invalid,
      children = _ref.children,
      className = _ref.className,
      inputSpacing = _ref.inputSpacing,
      message = _ref.message,
      messageText = _ref.messageText,
      other = _objectWithoutProperties(_ref, _excluded$E);

  var classNamesLegend = classnames$1("".concat(prefix$G, "--form-group__title"), className);
  var classNamesFieldset = classnames$1("".concat(prefix$G, "--fieldset"), (_classnames = {}, _defineProperty(_classnames, "".concat(prefix$G, "--fieldset__inline"), inline), _defineProperty(_classnames, "".concat(prefix$G, "--fieldset__align-").concat(align), align), _defineProperty(_classnames, "".concat(prefix$G, "--fieldset__breakpoint-").concat(breakpoint), breakpoint), _defineProperty(_classnames, "".concat(prefix$G, "--fieldset__input-spacing-").concat(inputSpacing), inputSpacing), _classnames), className);
  return /*#__PURE__*/React.createElement("div", _extends({}, invalid && {
    'data-invalid': ''
  }, {
    className: classNamesFieldset
  }, other), /*#__PURE__*/React.createElement("legend", {
    className: classNamesLegend
  }, legendText), /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefix$G, "--fieldset__content")
  }, children), message ? /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefix$G, "--form__requirements")
  }, messageText) : null);
};

FormGroup.propTypes = {
  /**
   * Specify the contained form elements
   */
  children: PropTypes.node,

  /**
   * Specify a breakpoint to show containing inputs vertically on mobile devices
   */
  breakpoint: PropTypes.oneOf(['none', 'sm', 'md', 'lg']),

  /**
   * Specify a title for the `FormGroup`
   */
  legendText: PropTypes.string,

  /**
   * Specify an optional className to be applied to the wrapper node
   */
  className: PropTypes.string,

  /**
   * Specify whether the control is currently invalid.
   * Either a boolean in combination with `invalidText` or an `object`( eg. { message: "Message", …otherErrorProperties }) can be passed.
   */
  invalid: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),

  /**
   * Specify if a message is shown for the `fieldset`
   */
  message: PropTypes.bool,

  /**
   * Specify a message for the `fieldset`
   */
  messageText: PropTypes.string,

  /**
   * Specify a message for the `fieldset`
   */
  align: PropTypes.oneOf(['vertical', 'horizontal']),

  /**
   * Specify the spacing between horizontaly aligned inputs
   */
  inputSpacing: PropTypes.oneOf(['none', 'md', 'lg'])
};
FormGroup.defaultProps = {
  align: 'vertical',
  invalid: false,
  inputSpacing: 'lg',
  breakpoint: 'md',
  message: false,
  messageText: ''
};
var FormGroup$1 = FormGroup;

var _excluded$D = ["className", "children", "description", "icon"];
var prefix$F = settings$1.prefix;
/** FormHint allows you to add a longer explanation to an input element. */

var FormHint = function FormHint(_ref) {
  var className = _ref.className,
      children = _ref.children;
      _ref.description;
      _ref.icon;
      _objectWithoutProperties(_ref, _excluded$D);

  var formHintClasses = classnames$1("".concat(prefix$F, "--form-hint"), className);
  return /*#__PURE__*/React.createElement(Tooltip$1, {
    content: children
  }, /*#__PURE__*/React.createElement("div", {
    className: formHintClasses
  }, /*#__PURE__*/React.createElement(Icon$1, {
    icon: iconInfoSolid,
    width: "15",
    height: "15",
    description: children
  })));
};

FormHint.propTypes = {
  /**
   * Specify an optional className to be applied to the wrapper node
   */
  className: PropTypes.string,

  /**
   * The tooltips content can be a string or an component
   */
  children: PropTypes.node,

  /**
   * Specify a custom icon for the hint
   */
  icon: PropTypes.object
};
FormHint.defaultProps = {
  icon: iconInfoSolid
};
var FormHint$1 = FormHint;

var _excluded$C = ["className", "children", "id"];
var prefix$E = settings$1.prefix;
/** Form Label can be used whenever it is needed to show a label detached from a regular input. */

var FormLabel = function FormLabel(_ref) {
  var className = _ref.className,
      children = _ref.children,
      id = _ref.id,
      other = _objectWithoutProperties(_ref, _excluded$C);

  var classNames = classnames$1("".concat(prefix$E, "--label"), className);
  return /*#__PURE__*/React.createElement("label", _extends({
    htmlFor: id,
    className: classNames
  }, other), children);
};

FormLabel.propTypes = {
  /**
   * The content of the label
   */
  children: PropTypes.node,

  /**
   * Additional `class` attributes
   */
  className: PropTypes.string,

  /**
   * The ID of the related input which will be used as `htmlFor`
   */
  id: PropTypes.string
};
var FormLabel$1 = FormLabel;

var _excluded$B = ["dark", "light", "centered", "children", "className", "margin", "fullHeight", "noMargin", "withHover"];
var prefix$D = settings$1.prefix;
/** A Module is identifiable as a single, contained unit. */

var Module = function Module(_ref) {
  var _classnames;

  var dark = _ref.dark,
      light = _ref.light;
      _ref.centered;
      var children = _ref.children,
      className = _ref.className,
      margin = _ref.margin,
      fullHeight = _ref.fullHeight,
      noMargin = _ref.noMargin,
      withHover = _ref.withHover,
      other = _objectWithoutProperties(_ref, _excluded$B);

  var wrapperClasses = classnames$1((_classnames = {}, _defineProperty(_classnames, "".concat(prefix$D, "--module--dark"), dark), _defineProperty(_classnames, "".concat(prefix$D, "--module--no-margin"), noMargin), _defineProperty(_classnames, "".concat(prefix$D, "--module--full-height"), fullHeight), _defineProperty(_classnames, "".concat(prefix$D, "--module--margin-x"), margin === 'xs'), _defineProperty(_classnames, "".concat(prefix$D, "--module--margin-md"), margin === 'md'), _defineProperty(_classnames, "".concat(prefix$D, "--module--margin-lg"), margin === 'lg'), _defineProperty(_classnames, "".concat(prefix$D, "--module--light"), light), _defineProperty(_classnames, "".concat(prefix$D, "--module--with-hover"), withHover), _classnames), className, ["".concat(prefix$D, "--module")]);
  return /*#__PURE__*/React.createElement("div", _extends({
    className: wrapperClasses
  }, other), /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefix$D, "--module__inner")
  }, children));
};

Module.propTypes = {
  /**
   * * Specify the content of the `Module`, usually a `ModuleHeader` `ModuleBody` and `ModuleFooter`component.
   */
  children: PropTypes.node,

  /**
   * The CSS class name for the slider.
   */
  className: PropTypes.string,

  /**
   * Disables the default margin
   */
  noMargin: PropTypes.bool,

  /**
   * Use 100% height of parent container
   */
  fullHeight: PropTypes.bool,

  /**
   * Light appearance (for white backgrounds)
   */
  light: PropTypes.bool,

  /**
   * Dark appearance
   */
  dark: PropTypes.bool,

  /**
   * Additional hover styling
   */
  withHover: PropTypes.bool
};
var Module$1 = Module;

var _excluded$A = ["children", "className", "centered", "noPadding"];

var ModuleBody = function ModuleBody(_ref) {
  var children = _ref.children,
      className = _ref.className,
      centered = _ref.centered,
      noPadding = _ref.noPadding,
      other = _objectWithoutProperties(_ref, _excluded$A);

  var wrapperClasses = classnames$1('wfp--module__content', className, {
    'wfp--module__content--centered': centered,
    'wfp--module__content--no-padding': noPadding
  });
  return /*#__PURE__*/React.createElement("div", _extends({
    className: wrapperClasses
  }, other), children);
};

ModuleBody.propTypes = {
  /**
   * Specify the content of the `ModuleBody`
   */
  children: PropTypes.node,

  /**
   * Specify wheater the content should be centered.
   */
  centered: PropTypes.bool,

  /**
   * Specify wheater the body should have no padding.
   */
  noPadding: PropTypes.bool,

  /**
   * The CSS class name for the `ModuleBody`.
   */
  className: PropTypes.string
};
ModuleBody.defaultProps = {};
var ModuleBody$1 = ModuleBody;

var _excluded$z = ["filter", "children", "className"];

var ModuleHeader = function ModuleHeader(_ref) {
  var filter = _ref.filter,
      children = _ref.children,
      className = _ref.className,
      other = _objectWithoutProperties(_ref, _excluded$z);

  var wrapperClasses = classnames$1('wfp--module__header', className);
  return /*#__PURE__*/React.createElement("div", _extends({
    className: wrapperClasses
  }, other), /*#__PURE__*/React.createElement("h1", {
    className: "wfp--module__title"
  }, children), filter && /*#__PURE__*/React.createElement("div", {
    className: "wfp--module__filter"
  }, filter));
};

ModuleHeader.propTypes = {
  /**
   * Specify the content of the `ModuleHeaders`
   */
  children: PropTypes.node,

  /**
   * The CSS class name for the `ModuleHeaders`.
   */
  className: PropTypes.string
};
var ModuleHeader$1 = ModuleHeader;

var _excluded$y = ["centered", "children", "className"];

var ModuleFooter = function ModuleFooter(_ref) {
  _ref.centered;
      var children = _ref.children,
      className = _ref.className,
      other = _objectWithoutProperties(_ref, _excluded$y);

  var wrapperClasses = classnames$1('wfp--module__footer', className);
  return /*#__PURE__*/React.createElement("div", _extends({
    className: wrapperClasses
  }, other), children);
};

ModuleFooter.propTypes = {
  /**
   * Specify the content of the `ModuleFooter`
   */
  children: PropTypes.node,

  /**
   * The CSS class name for the `ModuleFooter`.
   */
  className: PropTypes.string
};
var ModuleFooter$1 = ModuleFooter;

var prefix$C = settings$1.prefix;
/** The FormWizard is a wrapper for creating Wizard forms. */

var FormWizard = function FormWizard(_ref) {
  var className = _ref.className,
      children = _ref.children,
      formHeader = _ref.formHeader,
      formControls = _ref.formControls,
      sidebar = _ref.sidebar,
      stickySidebar = _ref.stickySidebar;
  var classes = {
    formControls: classnames$1("".concat(prefix$C, "--form-wizard"), _defineProperty({}, "".concat(prefix$C, "--form-wizard--sticky"), stickySidebar), className)
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classes.formControls
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefix$C, "--form-wizard__sidebar")
  }, sidebar), /*#__PURE__*/React.createElement(Module$1, {
    className: "".concat(prefix$C, "--form-wizard__content"),
    noMargin: true
  }, formHeader && /*#__PURE__*/React.createElement(ModuleHeader$1, null, formHeader), /*#__PURE__*/React.createElement(ModuleBody$1, null, children), formControls && /*#__PURE__*/React.createElement(ModuleFooter$1, null, formControls)));
};

FormWizard.propTypes = {
  /**
   * Specify a custom css class
   * which is added to the container
   */
  className: PropTypes.string,

  /**
   * Specify the custom
   * main content component
   */
  children: PropTypes.node.isRequired,

  /**
   * Specify the custom
   * sidebar component
   */
  sidebar: PropTypes.node.isRequired,

  /**
   * Sticky sidebar
   */
  stickySidebar: PropTypes.bool
};
FormWizard.defaultProps = {};
var FormWizard$1 = FormWizard;

var prefix$B = settings$1.prefix;
/** The InfoBar shows very important information on top of the page. */

var InfoBar = function InfoBar(_ref) {
  var children = _ref.children,
      className = _ref.className,
      id = _ref.id,
      pageWidth = _ref.pageWidth;
  var wrapperClasses = classnames$1("".concat(prefix$B, "--info-bar"), className);
  return /*#__PURE__*/React.createElement("div", {
    id: id,
    className: wrapperClasses
  }, /*#__PURE__*/React.createElement(Wrapper$1, {
    pageWidth: pageWidth
  }, children));
};

InfoBar.propTypes = {
  children: PropTypes.node.isRequired,

  /**
   * The CSS class name to be placed on the wrapping element.
   */
  className: PropTypes.string,

  /**
   * Additional `id` provided to the wrapping element
   */
  id: PropTypes.string,

  /**
   *  `pageWidth` for the `<Wrapper />` component
   */
  pageWidth: PropTypes.oneOf(['sm', 'md', 'lg', 'full']),

  /**
   * Additional `className` for the `<Wrapper />` component
   */
  wrapperClassName: PropTypes.string
};
InfoBar.defaultProps = {
  pageWidth: 'lg'
};
var InfoBar$1 = InfoBar;

var _excluded$x = ["className", "success", "description", "onSuccess", "successDelay"];
var prefix$A = settings$1.prefix;

var InlineLoading = /*#__PURE__*/function (_React$Component) {
  _inherits(InlineLoading, _React$Component);

  var _super = _createSuper(InlineLoading);

  function InlineLoading() {
    _classCallCheck(this, InlineLoading);

    return _super.apply(this, arguments);
  }

  _createClass(InlineLoading, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          success = _this$props.success,
          description = _this$props.description,
          onSuccess = _this$props.onSuccess,
          successDelay = _this$props.successDelay,
          other = _objectWithoutProperties(_this$props, _excluded$x);

      var loadingClasses = classnames$1("".concat(prefix$A, "--inline-loading"), className);

      var getLoading = function getLoading() {
        if (success) {
          setTimeout(function () {
            if (onSuccess) {
              onSuccess();
            }
          }, successDelay);
          return /*#__PURE__*/React.createElement("svg", {
            className: "".concat(prefix$A, "--inline-loading__checkmark-container ").concat(prefix$A, "--inline-loading__svg"),
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 10 10"
          }, /*#__PURE__*/React.createElement("polyline", {
            className: "".concat(prefix$A, "--inline-loading__checkmark"),
            points: "0.74 3.4 3.67 6.34 9.24 0.74"
          }));
        }

        return /*#__PURE__*/React.createElement(Loading, {
          small: true,
          withOverlay: false
        });
      };

      var loadingText = /*#__PURE__*/React.createElement("p", {
        className: "".concat(prefix$A, "--inline-loading__text")
      }, description);
      return /*#__PURE__*/React.createElement("div", _extends({
        className: loadingClasses
      }, other), /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefix$A, "--inline-loading__animation")
      }, getLoading()), description && loadingText);
    }
  }]);

  return InlineLoading;
}(React.Component);

_defineProperty(InlineLoading, "propTypes", {
  /**
   * Specify a custom className to be applied to the container node
   */
  className: PropTypes.string,

  /**
   * Specify whether the load was successful
   */
  success: PropTypes.bool,

  /**
   * Specify the description for the inline loading text
   */
  description: PropTypes.string,

  /**
   * Provide an optional handler to be invoked when <InlineLoading> is
   * successful
   */
  onSuccess: PropTypes.func,

  /**
   * Provide a delay for the `setTimeout` for success
   */
  successDelay: PropTypes.number
});

_defineProperty(InlineLoading, "defaultProps", {
  success: false,
  successDelay: 1500
});

var _excluded$w = ["children", "className", "colon", "kind", "small"];
var prefix$z = settings$1.prefix;
/** List component show a number of connected items written consecutively, typically one below the other. */

var List = function List(_ref) {
  var _classnames;

  var children = _ref.children,
      className = _ref.className,
      colon = _ref.colon,
      kind = _ref.kind,
      small = _ref.small,
      other = _objectWithoutProperties(_ref, _excluded$w);

  var classNames = classnames$1("".concat(prefix$z, "--list"), className, (_classnames = {}, _defineProperty(_classnames, "".concat(prefix$z, "--list--").concat(kind), kind), _defineProperty(_classnames, "".concat(prefix$z, "--list--small"), small), _defineProperty(_classnames, "".concat(prefix$z, "--list--colon"), colon), _classnames));
  return /*#__PURE__*/React.createElement(React.Fragment, null, kind == 'ordered' ? /*#__PURE__*/React.createElement("ol", _extends({
    className: classNames
  }, other), children) : /*#__PURE__*/React.createElement("ul", _extends({
    className: classNames
  }, other), children));
};
List.propTypes = {
  /**
   * Provide multiple `ListItem` components
   */
  children: PropTypes.node,

  /**
   * Specify a custom className
   */
  className: PropTypes.string,

  /**
   * Specify if colons should be used
   */
  colon: PropTypes.bool,

  /**
   * Specify a kind.
   */
  kind: PropTypes.oneOf(['unstyled', 'simple-inline', 'details', 'unordered', 'ordered', 'tooltip']),

  /**
   * Specify if the List should be small
   */
  small: PropTypes.bool
};
List.defaultProps = {
  kind: 'unstyled',
  colon: false,
  small: false
};

var _excluded$v = ["children", "className", "title", "kind"];
var ListItem = function ListItem(_ref) {
  var children = _ref.children,
      className = _ref.className,
      title = _ref.title,
      kind = _ref.kind,
      other = _objectWithoutProperties(_ref, _excluded$v);

  var classNames = classnames$1('wfp--list__element', className, {
    'wfp--list-item--checkmark': kind === 'checkmark',
    'wfp--list-item--cross': kind === 'cross'
  });
  return /*#__PURE__*/React.createElement("li", _extends({
    className: classNames
  }, other), kind === 'cross' && /*#__PURE__*/React.createElement(Icon$1, {
    className: "wfp--list-item__icon",
    icon: {
      styles: '',
      viewBox: '0 0 320 512',
      width: '15',
      height: '15',
      svgData: {
        circles: '',
        ellipses: '',
        paths: [{
          fill: 'currentColor',
          d: 'M207.6 256l107.72-107.72c6.23-6.23 6.23-16.34 0-22.58l-25.03-25.03c-6.23-6.23-16.34-6.23-22.58 0L160 208.4 52.28 100.68c-6.23-6.23-16.34-6.23-22.58 0L4.68 125.7c-6.23 6.23-6.23 16.34 0 22.58L112.4 256 4.68 363.72c-6.23 6.23-6.23 16.34 0 22.58l25.03 25.03c6.23 6.23 16.34 6.23 22.58 0L160 303.6l107.72 107.72c6.23 6.23 16.34 6.23 22.58 0l25.03-25.03c6.23-6.23 6.23-16.34 0-22.58L207.6 256z'
        }],
        polygons: '',
        polylines: '',
        rects: ''
      }
    }
  }), kind === 'checkmark' && /*#__PURE__*/React.createElement(Icon$1, {
    className: "wfp--list-item__icon",
    icon: {
      styles: '',
      viewBox: '0 0 512 512',
      width: '13',
      height: '13',
      svgData: {
        circles: '',
        ellipses: '',
        paths: [{
          fill: 'currentColor',
          d: 'M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z'
        }],
        polygons: '',
        polylines: '',
        rects: ''
      }
    }
  }), title && /*#__PURE__*/React.createElement("span", {
    className: "wfp--list__element__title"
  }, title), /*#__PURE__*/React.createElement("span", {
    className: "wfp--list__element__content"
  }, children));
};
ListItem.propTypes = {
  /**
   * Provide multiple `ListItem` components
   */
  children: PropTypes.node,

  /**
   * Specify a custom className
   */
  className: PropTypes.string,

  /**
   * Specify a kind.
   */
  kind: PropTypes.oneOf(['checkmark', 'cross']),

  /**
   * Specify if the List should be small
   */
  small: PropTypes.bool
};

var prefix$y = settings$1.prefix;
/** The Main Navigation is a Horizontal Menu which consists of multiple clickable items placed at the top of the page. The navigation stays unchanged when browswing through the site and is present on every page. The currently selected item is usually highlighted. */

var MainNavigation = /*#__PURE__*/function (_Component) {
  _inherits(MainNavigation, _Component);

  var _super = _createSuper(MainNavigation);

  function MainNavigation(props) {
    var _this;

    _classCallCheck(this, MainNavigation);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "onChangeSub", function (action, i, e) {
      if (e) {
        e.preventDefault();
      }

      if (action === 'close') {
        _this.setState({
          activeMenuItem: undefined
        });
      } else if (action === 'toggle') {
        var newI = _this.state.activeMenuItem === undefined || _this.state.activeMenuItem !== i ? i : undefined;

        _this.setState({
          activeMenuItem: newI
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "toggleMenu", function () {
      _this.setState({
        openMobile: !_this.state.openMobile
      });
    });

    _defineProperty(_assertThisInitialized(_this), "triggerSubNavigation", function () {
      _this.setState({
        activeMenuItem: undefined
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleClickOutside", function () {
      _this.setState({
        activeMenuItem: undefined
      });
    });

    _this.state = {
      openMobile: false,
      activeMenuItem: undefined
    };
    return _this;
  }

  _createClass(MainNavigation, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          children = _this$props.children,
          className = _this$props.className,
          id = _this$props.id,
          logo = _this$props.logo,
          mobilePageWidth = _this$props.mobilePageWidth,
          pageWidth = _this$props.pageWidth;
      var wrapperClasses = classnames$1("".concat(prefix$y, "--main-navigation"), className);
      var listClasses = classnames$1("".concat(prefix$y, "--main-navigation__list"), _defineProperty({}, "".concat(prefix$y, "--main-navigation__list--open"), this.state.openMobile));
      var parentProps = {
        onChangeSub: this.onChangeSub,
        toggleMenu: this.toggleMenu
      };
      var childrenSelect = typeof children === 'function' ? children(parentProps).props.children : children;
      return /*#__PURE__*/React.createElement("div", {
        id: id,
        className: wrapperClasses
      }, /*#__PURE__*/React.createElement(Wrapper$1, {
        pageWidth: pageWidth,
        mobilePageWidth: mobilePageWidth,
        className: "".concat(prefix$y, "--main-navigation__wrapper")
      }, /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefix$y, "--main-navigation__logo-wrapper")
      }, /*#__PURE__*/React.createElement(Button$1, {
        className: "".concat(prefix$y, "--main-navigation__button"),
        onClick: this.toggleMenu
      }, "Menu"), /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefix$y, "--main-navigation__logo")
      }, logo)), /*#__PURE__*/React.createElement("ul", {
        className: listClasses
      }, React.Children.map(childrenSelect, function (child, i) {
        if (child) {
          return /*#__PURE__*/React.cloneElement(child, {
            activeMenuItem: _this2.state.activeMenuItem,
            menuItem: i,
            onChangeSub: _this2.onChangeSub
          });
        } else return null;
      }))));
    }
  }]);

  return MainNavigation;
}(Component);

MainNavigation.propTypes = {
  /**
   * Usually multiple `MainNavigationItem` elements
   */
  children: PropTypes.oneOfType([PropTypes.node.isRequired, PropTypes.func.isRequired]),

  /**
   * The CSS class name to be placed on the wrapping element.
   */
  className: PropTypes.string,

  /**
   * Defines an ID for the component.
   */
  id: PropTypes.string,

  /**
   * The Logo can be either a string or a component
   */
  logo: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),

  /**
   * Specify the max-width on desktop devices (same as \`Wrapper\` component)
   */
  pageWidth: PropTypes.oneOf(['sm', 'md', 'lg', 'full']),

  /**
   * Specify the max-width on mobile devices (same as \`Wrapper\` component)
   */
  mobilePageWidth: PropTypes.string,

  /**
   * Additional className for the `Wrapper`
   */
  wrapperClassName: PropTypes.string
};
MainNavigation.defaultProps = {
  pageWidth: 'lg',
  mobilePageWidth: 'full',
  logo: 'WFP'
};
var MainNavigation$1 = MainNavigation;

var prefix$x = settings$1.prefix;

var MainNavigationItem = /*#__PURE__*/function (_Component) {
  _inherits(MainNavigationItem, _Component);

  var _super = _createSuper(MainNavigationItem);

  function MainNavigationItem() {
    var _this;

    _classCallCheck(this, MainNavigationItem);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "UNSAFE_componentWillReceiveProps", function (nextProps) {
      if (nextProps.menuItem === nextProps.activeMenuItem) {
        document.addEventListener('mousedown', _this.handleClickOutside);
      } else {
        document.removeEventListener('mousedown', _this.handleClickOutside);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "setWrapperRef", function (node) {
      _this.wrapperRef = node;
    });

    _defineProperty(_assertThisInitialized(_this), "handleClickOutside", function (e) {
      if (_this.wrapperRef && !_this.wrapperRef.contains(e.target)) {
        _this.props.onChangeSub('close');
      }
    });

    return _this;
  }

  _createClass(MainNavigationItem, [{
    key: "render",
    value: function render() {
      var _classNames, _classNames2, _classNames3;

      var _this$props = this.props,
          activeMenuItem = _this$props.activeMenuItem,
          className = _this$props.className,
          children = _this$props.children,
          menuItem = _this$props.menuItem,
          onChangeSub = _this$props.onChangeSub,
          subNavigation = _this$props.subNavigation,
          subNavWideAsContent = _this$props.subNavWideAsContent;
      var wrapperClasses = classnames$1(className, (_classNames = {}, _defineProperty(_classNames, "".concat(prefix$x, "--main-navigation__item"), true), _defineProperty(_classNames, "".concat(prefix$x, "--main-navigation__item--open"), menuItem === activeMenuItem), _defineProperty(_classNames, "".concat(prefix$x, "--content-width"), subNavigation && subNavWideAsContent), _classNames));
      var triggerClasses = classnames$1((_classNames2 = {}, _defineProperty(_classNames2, "".concat(prefix$x, "--main-navigation__trigger"), true), _defineProperty(_classNames2, "".concat(prefix$x, "--main-navigation__trigger--has-sub"), subNavigation), _defineProperty(_classNames2, "".concat(prefix$x, "--main-navigation__trigger--open"), menuItem === activeMenuItem), _classNames2));
      var childrenWithProps = subNavigation ? /*#__PURE__*/React.cloneElement(children, {
        children: /*#__PURE__*/React.createElement(React.Fragment, null, children.props.children, /*#__PURE__*/React.createElement(Icon$1, {
          className: "".concat(prefix$x, "--main-navigation__trigger__icon"),
          icon: menuItem === activeMenuItem ? iconClose : iconCaretDown,
          fill: "#FFFFFF",
          description: "expand icon"
        })),
        onClick: function onClick(e) {
          return onChangeSub('toggle', menuItem, e);
        }
      }) : children;
      var subClasses = classnames$1((_classNames3 = {}, _defineProperty(_classNames3, "".concat(prefix$x, "--main-navigation__sub"), true), _defineProperty(_classNames3, "".concat(prefix$x, "--main-navigation__sub--open"), menuItem === activeMenuItem), _classNames3));
      return /*#__PURE__*/React.createElement("li", {
        className: wrapperClasses,
        ref: this.setWrapperRef
      }, /*#__PURE__*/React.createElement("div", {
        className: triggerClasses
      }, childrenWithProps), subNavigation && /*#__PURE__*/React.createElement("div", {
        className: subClasses,
        open: menuItem === activeMenuItem ? true : false
      }, subNavigation));
    }
  }]);

  return MainNavigationItem;
}(Component);

MainNavigationItem.defaultProps = {
  onChangeSub: function onChangeSub() {}
};
MainNavigationItem.propTypes = {
  /**
   * The CSS class name to be placed on the wrapping element.
   */
  className: PropTypes.string,
  children: PropTypes.element.isRequired,

  /**
   * If defined the `MainNaviationItem` will have a toggleable
   * SubNavigation. See the `SubNavigation` component for details on usage
   */
  subNavigation: PropTypes.node
};
var MainNavigationItem$1 = MainNavigationItem;

var _excluded$u = ["children"],
    _excluded2$2 = ["children", "className"],
    _excluded3$2 = ["children", "className"],
    _excluded4$2 = ["children", "className"],
    _excluded5$2 = ["children", "className"],
    _excluded6$1 = ["children", "className"],
    _excluded7 = ["children", "className"],
    _excluded8 = ["children", "className"],
    _excluded9 = ["children", "columns", "className", "title"];
var prefix$w = settings$1.prefix;
/** The SubNavigation is a toogleable part of the MainNavigation */

var SubNavigation = function SubNavigation(_ref) {
  var children = _ref.children,
      other = _objectWithoutProperties(_ref, _excluded$u);

  return /*#__PURE__*/React.createElement("div", other, children);
};

SubNavigation.propTypes = {
  children: PropTypes.node.isRequired
};

var SubNavigationItem = function SubNavigationItem(_ref2) {
  var children = _ref2.children,
      className = _ref2.className,
      other = _objectWithoutProperties(_ref2, _excluded2$2);

  var classes = classnames$1("".concat(prefix$w, "--sub-navigation__item"), className);
  return /*#__PURE__*/React.createElement("div", _extends({
    className: classes
  }, other), children);
};

SubNavigationItem.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
};

var SubNavigationHeader = function SubNavigationHeader(_ref3) {
  var children = _ref3.children,
      className = _ref3.className,
      other = _objectWithoutProperties(_ref3, _excluded3$2);

  var classes = classnames$1("".concat(prefix$w, "--sub-navigation__header"), className);
  return /*#__PURE__*/React.createElement("div", _extends({
    className: classes
  }, other), children);
};

SubNavigationHeader.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
};

var SubNavigationFilter = function SubNavigationFilter(_ref4) {
  var children = _ref4.children,
      className = _ref4.className,
      other = _objectWithoutProperties(_ref4, _excluded4$2);

  var classes = classnames$1("".concat(prefix$w, "--sub-navigation__filter"), className);
  return /*#__PURE__*/React.createElement("div", _extends({
    className: classes
  }, other), children);
};

SubNavigationFilter.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
};

var SubNavigationList = function SubNavigationList(_ref5) {
  var children = _ref5.children,
      className = _ref5.className,
      other = _objectWithoutProperties(_ref5, _excluded5$2);

  var classes = classnames$1("".concat(prefix$w, "--sub-navigation__list"), className);
  return /*#__PURE__*/React.createElement("div", _extends({
    className: classes
  }, other), children);
};

SubNavigationList.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
};

var SubNavigationContent = function SubNavigationContent(_ref6) {
  var children = _ref6.children,
      className = _ref6.className,
      other = _objectWithoutProperties(_ref6, _excluded6$1);

  var classes = classnames$1("".concat(prefix$w, "--sub-navigation__content"), className);
  return /*#__PURE__*/React.createElement("div", _extends({
    className: classes
  }, other), children);
};

SubNavigationContent.propTypes = {
  /**
   * Provide the content of link
   */
  children: PropTypes.node,
  className: PropTypes.string
};

var SubNavigationTitle = function SubNavigationTitle(_ref7) {
  var children = _ref7.children,
      className = _ref7.className,
      other = _objectWithoutProperties(_ref7, _excluded7);

  var classes = classnames$1("".concat(prefix$w, "--sub-navigation__title"), className);
  return /*#__PURE__*/React.createElement("div", _extends({
    className: classes
  }, other), children);
};

SubNavigationTitle.propTypes = {
  /**
   * Provide the content of link
   */
  children: PropTypes.string,
  className: PropTypes.string
};

var SubNavigationLink = function SubNavigationLink(_ref8) {
  var children = _ref8.children,
      className = _ref8.className,
      other = _objectWithoutProperties(_ref8, _excluded8);

  var classes = classnames$1("".concat(prefix$w, "--sub-navigation__link"), className);
  return /*#__PURE__*/React.createElement("div", _extends({
    className: classes
  }, other), children);
};

SubNavigationLink.propTypes = {
  /**
   * Provide the content of link
   */
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.string, PropTypes.object]),
  className: PropTypes.string
};

var SubNavigationGroup = function SubNavigationGroup(_ref9) {
  var children = _ref9.children,
      columns = _ref9.columns,
      className = _ref9.className,
      title = _ref9.title,
      other = _objectWithoutProperties(_ref9, _excluded9);

  var classes = classnames$1("".concat(prefix$w, "--sub-navigation__group"), {
    className: className
  }, _defineProperty({}, "".concat(prefix$w, "--sub-navigation__group--columns"), columns));
  return /*#__PURE__*/React.createElement("div", _extends({
    className: classes
  }, other), title && /*#__PURE__*/React.createElement("h3", {
    className: "".concat(prefix$w, "--sub-navigation__group__title")
  }, title), /*#__PURE__*/React.createElement("div", null, children));
};

SubNavigationGroup.propTypes = {
  /**
   * Provide amount of columns shown
   */
  columns: PropTypes.number,

  /**
   * Provide a title for the group
   */
  title: PropTypes.node,

  /**
   * Provide content to be rendered inside of a <Tag>
   */
  image: PropTypes.string
};

var prefix$v = settings$1.prefix;
/** The Story component adds a default style, formatting and spacing for a longer text with main focus on readability. */

var Story = function Story(_ref) {
  var _classnames;

  var children = _ref.children,
      className = _ref.className,
      spacing = _ref.spacing;
  var classNames = classnames$1((_classnames = {}, _defineProperty(_classnames, "".concat(prefix$v, "--story"), true), _defineProperty(_classnames, "".concat(className), className), _classnames));
  return /*#__PURE__*/React.createElement("div", {
    className: classNames,
    spacing: spacing
  }, children);
};

Story.propTypes = {
  /**
    The Story content
  */
  children: PropTypes.node,

  /**
    Additional className for Story
  */
  className: PropTypes.string
};
var Story$1 = Story;

/** Links are used as navigational elements. They may appear on their own, within a sentence or paragraph, or directly following the content. */

var wrapper = function wrapper(props) {
  return /*#__PURE__*/React.createElement(Story$1, props);
};

var li = function li(props) {
  var kind = typeof props.children === 'string' ? props.children.substring(0, 1) : '';
  if (kind === '✓' || kind === '✗') return /*#__PURE__*/React.createElement(ListItem, _extends({
    kind: kind === '✓' ? 'checkmark' : 'cross'
  }, props), props.children.substring(1, props.children.length));
  return /*#__PURE__*/React.createElement("li", props, props.children);
};

var ul = function ul(props) {
  return /*#__PURE__*/React.createElement(List, _extends({}, props, {
    kind: "unordered"
  }), props.children);
};

var ol = function ol(props) {
  return /*#__PURE__*/React.createElement(List, _extends({}, props, {
    kind: "ordered"
  }), props.children);
};

var blockquote = function blockquote(props) {
  if (Array.isArray(props.children) && props.children.length >= 2 && props.children[0].props) return /*#__PURE__*/React.createElement(Blockquote$1, _extends({}, props, {
    title: props.children[0].props.children
  }), props.children.map(function (e, i) {
    if (i > 0) return e;
  }));
  return /*#__PURE__*/React.createElement(Blockquote$1, props, props.children);
};
/*const code = ({ children, className, ...other }) => {
    const language = className && className.split('-');
    return (
      <PureSource
        format={false}
        dark
        language={(language && language[1]) || 'plaintext'}
        code={children as string}
        {...other}
      />
    );
  };
  */


var MdxComponents = {
  wrapper: wrapper,
  li: li,
  ul: ul,
  ol: ol,
  blockquote: blockquote
};
var MdxComponents$1 = MdxComponents;

var _excluded$t = ["modalHeading", "modalLabel", "modalFooter", "modalSecondaryAction", "modalAriaLabel", "passiveModal", "secondaryButtonText", "primaryButtonText", "backgroundImage", "open", "lazyLoad", "onRequestClose", "onRequestSubmit", "onSecondarySubmit", "iconDescription", "inPortal", "primaryButtonDisabled", "secondaryButtonDisabled", "danger", "hideClose", "wide", "type", "selectorPrimaryFocus", "selectorsFloatingMenus", "shouldSubmitOnEnter"];
var prefix$u = settings$1.prefix;
var matchesFuncName = typeof Element !== 'undefined' && ['matches', 'webkitMatchesSelector', 'msMatchesSelector'].filter(function (name) {
  return typeof Element.prototype[name] === 'function';
})[0];
var modalRoot = typeof document !== 'undefined' ? document.body : undefined;
/** Modals focus the user’s attention exclusively on one task or piece of information via a window that sits on top of the page content. */

var Modal = /*#__PURE__*/function (_Component) {
  _inherits(Modal, _Component);

  var _super = _createSuper(Modal);

  function Modal(props) {
    var _this;

    _classCallCheck(this, Modal);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "button", /*#__PURE__*/React.createRef());

    _defineProperty(_assertThisInitialized(_this), "outerModal", /*#__PURE__*/React.createRef());

    _defineProperty(_assertThisInitialized(_this), "innerModal", /*#__PURE__*/React.createRef());

    _defineProperty(_assertThisInitialized(_this), "elementOrParentIsFloatingMenu", function (target) {
      var _this$props$selectors = _this.props.selectorsFloatingMenus,
          selectorsFloatingMenus = _this$props$selectors === void 0 ? [".".concat(prefix$u, "--overflow-menu-options"), ".".concat(prefix$u, "--tooltip"), '.flatpickr-calendar'] : _this$props$selectors;

      if (target && typeof target.closest === 'function') {
        return selectorsFloatingMenus.some(function (selector) {
          return target.closest(selector);
        });
      } else {
        // Alternative if closest does not exist.
        while (target) {
          if (typeof target[matchesFuncName] === 'function') {
            if ( // eslint-disable-next-line no-loop-func
            selectorsFloatingMenus.some(function (selector) {
              return target[matchesFuncName](selector);
            })) {
              return true;
            }
          }

          target = target.parentNode;
        }

        return false;
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleKeyDown", function (evt) {
      if (evt.which === 27) {
        _this.props.onRequestClose(evt, 'key');
      }

      if (evt.which === 13 && _this.props.shouldSubmitOnEnter) {
        _this.props.onRequestSubmit(evt, 'key');
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleClick", function (evt) {
      if (_this.innerModal.current && !_this.innerModal.current.contains(evt.target) && !_this.elementOrParentIsFloatingMenu(evt.target)) {
        _this.props.onRequestClose(evt, 'background');
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleCloseButton", function (evt) {
      _this.props.onRequestClose(evt, 'button');
    });

    _defineProperty(_assertThisInitialized(_this), "focusModal", function () {
      if (_this.outerModal.current) {
        _this.outerModal.current.focus();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleBlur", function (evt) {
      // Keyboard trap
      if (_this.innerModal.current && _this.props.open && evt.relatedTarget && !_this.innerModal.current.contains(evt.relatedTarget) && !_this.elementOrParentIsFloatingMenu(evt.relatedTarget)) {
        _this.focusModal();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "focusButton", function (focusContainerElement) {
      if (_this.props.selectorPrimaryFocus === false) {
        return;
      }

      var primaryFocusElement = focusContainerElement.querySelector(_this.props.selectorPrimaryFocus);

      if (primaryFocusElement) {
        primaryFocusElement.focus();
        return;
      }

      if (_this.button && _this.button.current) {
        _this.button.current.focus();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleTransitionEnd", function (evt) {
      if (_this.outerModal.current.offsetWidth && _this.outerModal.current.offsetHeight && _this.beingOpen) {
        _this.focusButton(evt.currentTarget);

        _this.beingOpen = false;
      }
    });

    _this.el = document.createElement('div');
    return _this;
  }

  _createClass(Modal, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (!prevProps.open && this.props.open) {
        this.beingOpen = true;
      } else if (prevProps.open && !this.props.open) {
        this.beingOpen = false;
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      modalRoot.appendChild(this.el);

      if (!this.props.open) {
        return;
      }

      this.focusButton(this.innerModal.current);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      modalRoot.removeChild(this.el);
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames;

      var _this$props = this.props,
          modalHeading = _this$props.modalHeading,
          modalLabel = _this$props.modalLabel,
          modalFooter = _this$props.modalFooter,
          modalSecondaryAction = _this$props.modalSecondaryAction,
          modalAriaLabel = _this$props.modalAriaLabel,
          passiveModal = _this$props.passiveModal,
          secondaryButtonText = _this$props.secondaryButtonText,
          primaryButtonText = _this$props.primaryButtonText,
          backgroundImage = _this$props.backgroundImage,
          open = _this$props.open,
          lazyLoad = _this$props.lazyLoad,
          onRequestClose = _this$props.onRequestClose,
          onRequestSubmit = _this$props.onRequestSubmit,
          onSecondarySubmit = _this$props.onSecondarySubmit,
          iconDescription = _this$props.iconDescription,
          inPortal = _this$props.inPortal,
          primaryButtonDisabled = _this$props.primaryButtonDisabled,
          secondaryButtonDisabled = _this$props.secondaryButtonDisabled,
          danger = _this$props.danger,
          hideClose = _this$props.hideClose,
          wide = _this$props.wide,
          type = _this$props.type;
          _this$props.selectorPrimaryFocus;
          _this$props.selectorsFloatingMenus;
          _this$props.shouldSubmitOnEnter;
          var other = _objectWithoutProperties(_this$props, _excluded$t);

      if (open === false && lazyLoad) {
        return null;
      }

      var onSecondaryButtonClick = onSecondarySubmit ? onSecondarySubmit : onRequestClose;
      var modalClasses = classnames$1((_classNames = {}, _defineProperty(_classNames, "".concat(prefix$u, "--modal"), true), _defineProperty(_classNames, "".concat(prefix$u, "--modal--wide"), wide), _defineProperty(_classNames, "".concat(prefix$u, "--modal--tall"), !passiveModal), _defineProperty(_classNames, "".concat(prefix$u, "--modal--background-image"), backgroundImage), _defineProperty(_classNames, 'is-visible', open), _defineProperty(_classNames, "".concat(prefix$u, "--modal--warning"), type === 'warning' || this.props.warning), _defineProperty(_classNames, "".concat(prefix$u, "--modal--danger"), type === 'danger' || this.props.danger), _defineProperty(_classNames, this.props.className, this.props.className), _classNames));
      var modalButton = !hideClose ? /*#__PURE__*/React.createElement("button", {
        className: "".concat(prefix$u, "--modal-close"),
        type: "button",
        onClick: this.handleCloseButton,
        ref: this.button
      }, /*#__PURE__*/React.createElement(Icon$1, {
        icon: iconClose,
        className: "".concat(prefix$u, "--modal-close__icon"),
        description: iconDescription
      })) : null;
      var modalBody = /*#__PURE__*/React.createElement("div", {
        ref: this.innerModal,
        role: "dialog",
        className: "".concat(prefix$u, "--modal-container"),
        "aria-label": modalAriaLabel
      }, /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefix$u, "--modal-header")
      }, passiveModal && modalButton, /*#__PURE__*/React.createElement("div", null, modalLabel && /*#__PURE__*/React.createElement("h4", {
        className: "".concat(prefix$u, "--modal-header__label")
      }, modalLabel), /*#__PURE__*/React.createElement("h2", {
        className: "".concat(prefix$u, "--modal-header__heading")
      }, modalHeading)), modalSecondaryAction && /*#__PURE__*/React.createElement(React.Fragment, null, modalSecondaryAction), !passiveModal && modalButton), /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefix$u, "--modal-content")
      }, this.props.children), !passiveModal && /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefix$u, "--modal-footer")
      }, !modalFooter ? /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefix$u, "--modal__buttons-container")
      }, secondaryButtonText && /*#__PURE__*/React.createElement(Button$1, {
        kind: danger ? 'tertiary' : 'secondary',
        disabled: secondaryButtonDisabled,
        onClick: onSecondaryButtonClick
      }, secondaryButtonText), /*#__PURE__*/React.createElement(Button$1, {
        kind: danger ? 'danger--primary' : 'primary',
        disabled: primaryButtonDisabled,
        onClick: onRequestSubmit,
        inputRef: this.button
      }, primaryButtonText)) : /*#__PURE__*/React.createElement("div", null, modalFooter(this.props))));
      var modal = /*#__PURE__*/React.createElement("div", _extends({}, other, {
        onKeyDown: this.handleKeyDown // onClick={this.handleClick}
        //using onMouseDown instead of onClick to prevent modal from closing when releasing mouse on background
        ,
        onMouseDown: this.handleClick,
        onBlur: this.handleBlur,
        className: modalClasses,
        style: backgroundImage ? {
          backgroundImage: "url(".concat(backgroundImage, ")")
        } : undefined,
        role: "presentation",
        tabIndex: -1,
        onTransitionEnd: this.props.open ? this.handleTransitionEnd : undefined,
        ref: this.outerModal
      }), /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefix$u, "--modal-inner")
      }, modalBody));

      if (inPortal) {
        return /*#__PURE__*/ReactDOM.createPortal(modal, this.el);
      } else {
        return modal;
      }
    }
  }]);

  return Modal;
}(Component);

_defineProperty(Modal, "propTypes", {
  /**
   * Provide the contents of your Modal
   */
  children: PropTypes.node,

  /**
   * Specify an optional className to be applied to the modal root node
   */
  className: PropTypes.string,

  /**
   * Specify whether the modals content should be only loaded when the `Modal` is `open`
   */
  lazyLoad: PropTypes.bool,

  /**
   * Specify whether the modal should be button-less
   */
  passiveModal: PropTypes.bool,

  /**
   * Specify a handler for closing modal.
   * The handler should care of closing modal, e.g. changing `open` prop.
   */
  onRequestClose: PropTypes.func,

  /**
   * Specify the DOM element ID of the top-level node.
   */
  id: PropTypes.string,

  /**
   * Specify the content of the modal header title.
   */
  modalHeading: PropTypes.string,

  /**
   * Specify the content of the modal header label.
   */
  modalLabel: PropTypes.node,

  /**
   * Specify the content which renders on ther right side of modalLabel.
   */
  modalSecondaryAction: PropTypes.node,

  /**
   * Specify the a function which renders a custom ModalFooter.
   */
  modalFooter: PropTypes.func,

  /**
   * Specify a label to be read by screen readers on the modal root node
   */
  modalAriaLabel: PropTypes.string,

  /**
   * Specify the text for the secondary button
   */
  secondaryButtonText: PropTypes.string,

  /**
   * Specify the text for the primary button
   */
  primaryButtonText: PropTypes.string,

  /**
   * Specify the background image(url) for your modal
   */
  backgroundImage: PropTypes.string,

  /**
   * Specify whether the Modal is currently open
   */
  open: PropTypes.bool,

  /**
   * Specify a handler for "submitting" modal.
   * The handler should care of closing modal, e.g. changing `open` prop, if necessary.
   */
  onRequestSubmit: PropTypes.func,

  /**
   * Specify a handler for a key press modal
   */
  onKeyDown: PropTypes.func,

  /**
   * Provide a description for "close" icon that can be read by screen readers
   */
  iconDescription: PropTypes.string,

  /**
   * Specify whether the Button should be disabled, or not
   */
  primaryButtonDisabled: PropTypes.bool,

  /**
   * Specify whether the secondary Button should be disabled, or not
   */
  secondaryButtonDisabled: PropTypes.bool,

  /**
   * Specify a handler for the secondary button.
   * Useful if separate handler from `onRequestClose` is desirable
   */
  onSecondarySubmit: PropTypes.func,

  /**
   * Specify whether the Modal is for dangerous actions
   */
  danger: PropTypes.bool,

  /**
   * Specify whether the Modal close button should be hidden or not
   */
  hideClose: PropTypes.bool,

  /**
   * Specify if Enter key should be used as "submit" action
   */
  shouldSubmitOnEnter: PropTypes.bool,

  /**
   * Specify CSS selectors that match DOM elements working as floating menus.
   * Focusing on those elements won't trigger "focus-wrap" behavior
   */
  selectorsFloatingMenus: PropTypes.arrayOf(PropTypes.string),

  /**
   * Specify a CSS selector that matches the DOM element that should
   * be focused when the Modal opens. If "false" no selector will be triggered
   */
  selectorPrimaryFocus: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),

  /**
   *  Different styling options are available `info`, `warning`, `danger`
   */
  type: PropTypes.oneOf(['info', 'warning', 'danger']),

  /**
   * If true the Modal will be rendered inside a portal at the end of the
   * body element, otherwise at the position it is placed.
   */
  inPortal: PropTypes.bool,

  /**
   * If true the Modal will be wider then the regular Modal
   */
  wide: PropTypes.bool
});

_defineProperty(Modal, "defaultProps", {
  onRequestClose: function onRequestClose() {},
  onRequestSubmit: function onRequestSubmit() {},
  primaryButtonDisabled: false,
  secondaryButtonDisabled: false,
  onKeyDown: function onKeyDown() {},
  passiveModal: false,
  iconDescription: 'close the modal',
  inPortal: true,
  lazyLoad: false,
  modalHeading: '',
  modalLabel: '',
  selectorPrimaryFocus: '[data-modal-primary-focus]'
});

var _excluded$s = ["children", "customButton", "id", "onKeyDown", "buttonTriggerText", "buttonTriggerClassName", "triggerButtonKind", "disabled", "handleSubmit", "shouldCloseAfterSubmit"];
/** Modal Wrapper component to encapsulate your Modal within a button. */

var ModalWrapper = /*#__PURE__*/function (_React$Component) {
  _inherits(ModalWrapper, _React$Component);

  var _super = _createSuper(ModalWrapper);

  function ModalWrapper(props) {
    var _this;

    _classCallCheck(this, ModalWrapper);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "state", {
      isOpen: false
    });

    _defineProperty(_assertThisInitialized(_this), "handleOpen", function () {
      _this.setState({
        isOpen: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleClose", function () {
      _this.setState({
        isOpen: false
      }, function () {
        _this.triggerButton.current && _this.triggerButton.current.focus();
        if (_this.props.handleClose) _this.props.handleClose();
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnRequestSubmit", function () {
      var _this$props = _this.props,
          handleSubmit = _this$props.handleSubmit,
          shouldCloseAfterSubmit = _this$props.shouldCloseAfterSubmit;

      if (handleSubmit && handleSubmit()) {
        if (shouldCloseAfterSubmit) {
          _this.handleClose();
        }
      }
    });

    _this.triggerButton = /*#__PURE__*/React.createRef();
    return _this;
  }

  _createClass(ModalWrapper, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          children = _this$props2.children,
          customButton = _this$props2.customButton,
          id = _this$props2.id,
          _onKeyDown = _this$props2.onKeyDown,
          buttonTriggerText = _this$props2.buttonTriggerText,
          buttonTriggerClassName = _this$props2.buttonTriggerClassName,
          triggerButtonKind = _this$props2.triggerButtonKind,
          disabled = _this$props2.disabled;
          _this$props2.handleSubmit;
          _this$props2.shouldCloseAfterSubmit;
          var other = _objectWithoutProperties(_this$props2, _excluded$s);

      var props = {
        open: this.state.isOpen,
        onRequestClose: this.handleClose,
        onRequestSubmit: this.handleOnRequestSubmit
      };
      var customButtonEl = customButton ? /*#__PURE__*/React.cloneElement(customButton, {
        disabled: disabled,
        onClick: this.handleOpen,
        inputRef: this.triggerButton
      }) : undefined;
      return /*#__PURE__*/React.createElement("div", {
        role: "presentation",
        className: "wfp--modal__wrapper",
        onKeyDown: function onKeyDown(evt) {
          if (evt.which === 27) {
            _this2.handleClose();

            _onKeyDown(evt);
          }
        }
      }, customButton ? /*#__PURE__*/React.createElement(React.Fragment, null, customButtonEl) : /*#__PURE__*/React.createElement(Button$1, {
        id: id,
        className: buttonTriggerClassName,
        disabled: disabled,
        kind: triggerButtonKind,
        onClick: this.handleOpen,
        inputRef: this.triggerButton
      }, buttonTriggerText), /*#__PURE__*/React.createElement(Modal, _extends({}, props, other), children));
    }
  }]);

  return ModalWrapper;
}(React.Component);

_defineProperty(ModalWrapper, "propTypes", {
  status: PropTypes.string,

  /**
   * Specify a function to open the Modal.
   */
  handleOpen: PropTypes.func,
  children: PropTypes.node,

  /**
   * Specify a custom trigger `Button`.
   */
  customButton: PropTypes.element,
  id: PropTypes.string,

  /**
   * Specify the text for the trigger `Button`.
   */
  buttonTriggerText: PropTypes.node,

  /**
   * Specify a `class` for the trigger `Button`.
   */
  buttonTriggerClassName: PropTypes.string,
  modalLabel: PropTypes.string,
  modalHeading: PropTypes.string,
  modalText: PropTypes.string,
  passiveModal: PropTypes.bool,
  withHeader: PropTypes.bool,
  modalBeforeContent: PropTypes.bool,
  primaryButtonText: PropTypes.string,
  secondaryButtonText: PropTypes.string,

  /**
   * Specify a `function` which is triggered when submitting the `Modal`.
   */
  handleSubmit: PropTypes.func,
  handleClose: PropTypes.func,
  disabled: PropTypes.bool,
  triggerButtonKind: ButtonTypes.buttonKind,

  /**
   * Specify if `Modal` should be closed after submitting.
   */
  shouldCloseAfterSubmit: PropTypes.bool
});

_defineProperty(ModalWrapper, "defaultProps", {
  primaryButtonText: 'Save',
  secondaryButtonText: 'Cancel',
  triggerButtonKind: 'primary',
  disabled: false,
  onKeyDown: function onKeyDown() {}
});

/** dkjnslknkjfndn */

var CloseButton = function CloseButton(_ref) {
  _ref.YouCanPassAnyProps;
      var closeToast = _ref.closeToast;
  return /*#__PURE__*/React.createElement("button", {
    ariaLabel: "close",
    className: "Toastify__close-button",
    onClick: closeToast
  }, /*#__PURE__*/React.createElement("span", null));
};
/** huyhuyghu */


var notificationStyle = {
  position: 'bottom-right',
  closeButton: /*#__PURE__*/React.createElement(CloseButton, {
    YouCanPassAnyProps: "foo"
  })
};
var notificationStyle$1 = notificationStyle;

var _excluded$r = ["children", "className", "onClick"],
    _excluded2$1 = ["ariaLabel", "className", "iconDescription", "type", "renderIcon", "name", "notificationType"],
    _excluded3$1 = ["title", "subtitle", "caption", "notificationType", "children"],
    _excluded4$1 = ["role", "notificationType", "onCloseButtonClick", "iconDescription", "statusIconDescription", "className", "caption", "subtitle", "title", "kind", "lowContrast", "hideCloseButton", "children", "timeout"],
    _excluded5$1 = ["actions", "role", "notificationType", "onCloseButtonClick", "iconDescription", "statusIconDescription", "className", "subtitle", "title", "kind", "lowContrast", "hideCloseButton", "children"];
var prefix$t = settings$1.prefix;
/** Notifications are messages that communicate information to the user. The two main types of notifications are toast notifications and inline notifications. */

function NotificationActionButton(_ref) {
  var children = _ref.children,
      customClassName = _ref.className,
      onClick = _ref.onClick,
      other = _objectWithoutProperties(_ref, _excluded$r);

  var className = classnames$1(customClassName, "".concat(prefix$t, "--inline-notification__action-button"));
  return /*#__PURE__*/React.createElement(Button$1, _extends({
    className: className,
    kind: "ghost",
    onClick: onClick,
    size: "small"
  }, other), children);
}
NotificationActionButton.propTypes = {
  /**
   * Specify the content of the notification action button.
   */
  children: PropTypes.node,

  /**
   * Specify an optional className to be applied to the notification action button
   */
  className: PropTypes.string,

  /**
   * Optionally specify a click handler for the notification action button.
   */
  onClick: PropTypes.func
};
function NotificationButton(_ref2) {
  var ariaLabel = _ref2.ariaLabel,
      className = _ref2.className,
      iconDescription = _ref2.iconDescription,
      type = _ref2.type,
      renderIcon = _ref2.renderIcon,
      name = _ref2.name,
      notificationType = _ref2.notificationType,
      other = _objectWithoutProperties(_ref2, _excluded2$1);

  var buttonClassName = classnames$1(className, _defineProperty({}, "".concat(prefix$t, "--").concat(notificationType, "-notification__close-button"), notificationType));
  var iconClassName = classnames$1(_defineProperty({}, "".concat(prefix$t, "--").concat(notificationType, "-notification__close-icon"), notificationType));
  return (
    /*#__PURE__*/
    // eslint-disable-next-line react/button-has-type
    React.createElement("button", _extends({}, other, {
      type: type,
      "aria-label": iconDescription,
      title: iconDescription,
      className: buttonClassName
    }), renderIcon && /*#__PURE__*/React.createElement(Icon$1, {
      icon: renderIcon,
      "aria-label": ariaLabel,
      className: iconClassName,
      name: name
    }))
  );
}
NotificationButton.propTypes = {
  /**
   * Specify a label to be read by screen readers on the notification button
   */
  ariaLabel: PropTypes.string,

  /**
   * Specify an optional className to be applied to the notification button
   */
  className: PropTypes.string,

  /**
   * Provide a description for "close" icon that can be read by screen readers
   */
  iconDescription: PropTypes.string,

  /**
   * Specify an optional icon for the Button through a string,
   * if something but regular "close" icon is desirable
   */
  name: PropTypes.string,

  /**
   * Specify the notification type
   */
  notificationType: PropTypes.oneOf(['toast', 'inline']),

  /**
   * Optional prop to allow overriding the icon rendering.
   * Can be a React component class
   */
  renderIcon: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),

  /**
   * Optional prop to specify the type of the Button
   */
  type: PropTypes.string
};
NotificationButton.defaultProps = {
  ariaLabel: 'close notification',
  // TODO: deprecate this prop
  notificationType: 'toast',
  type: 'button',
  iconDescription: 'close icon',
  renderIcon: iconClose
};
function NotificationTextDetails(_ref3) {
  var title = _ref3.title,
      subtitle = _ref3.subtitle,
      caption = _ref3.caption,
      notificationType = _ref3.notificationType,
      children = _ref3.children,
      other = _objectWithoutProperties(_ref3, _excluded3$1);

  if (notificationType === 'toast') {
    return /*#__PURE__*/React.createElement("div", _extends({}, other, {
      className: "".concat(prefix$t, "--toast-notification__details")
    }), /*#__PURE__*/React.createElement("h3", {
      className: "".concat(prefix$t, "--toast-notification__title")
    }, title), /*#__PURE__*/React.createElement("div", {
      className: "".concat(prefix$t, "--toast-notification__subtitle")
    }, subtitle), /*#__PURE__*/React.createElement("div", {
      className: "".concat(prefix$t, "--toast-notification__caption")
    }, caption), children);
  }

  if (notificationType === 'inline') {
    return /*#__PURE__*/React.createElement("div", _extends({}, other, {
      className: "".concat(prefix$t, "--inline-notification__text-wrapper")
    }), /*#__PURE__*/React.createElement("p", {
      className: "".concat(prefix$t, "--inline-notification__title")
    }, title), /*#__PURE__*/React.createElement("div", {
      className: "".concat(prefix$t, "--inline-notification__subtitle")
    }, subtitle), children);
  }
}
NotificationTextDetails.propTypes = {
  /**
   * Specify the caption
   */
  caption: PropTypes.node,

  /**
   * Pass in the children that will be rendered in NotificationTextDetails
   */
  children: PropTypes.node,

  /**
   * Specify the notification type
   */
  notificationType: PropTypes.oneOf(['toast', 'inline']),

  /**
   * Specify the sub-title
   */
  subtitle: PropTypes.node,

  /**
   * Specify the title
   */
  title: PropTypes.string
};
NotificationTextDetails.defaultProps = {
  title: 'title',
  caption: 'caption',
  notificationType: 'toast'
};
var iconTypes = {
  error: iconError,
  success: iconCheckmarkGlyph,
  warning: iconWarningSolid,
  //['warning-alt']: WarningAltFilled20,
  info: iconInfoGlyph //['info-square']: InformationSquareFilled20,

};

function NotificationIcon(_ref4) {
  var iconDescription = _ref4.iconDescription,
      kind = _ref4.kind,
      notificationType = _ref4.notificationType;
  var iconForKind = iconTypes[kind];

  if (!iconForKind) {
    return null;
  }

  return /*#__PURE__*/React.createElement(Icon$1, {
    icon: iconForKind,
    className: "".concat(prefix$t, "--").concat(notificationType, "-notification__icon")
  }, /*#__PURE__*/React.createElement("title", null, iconDescription));
}

NotificationIcon.propTypes = {
  iconDescription: PropTypes.string.isRequired,
  kind: PropTypes.oneOf(['error', 'success', 'warning', 'warning-alt', 'info' //'info-square',
  ]).isRequired,
  notificationType: PropTypes.oneOf(['inline', 'toast']).isRequired
};
/** sdfghjk */

function ToastNotification(_ref5) {
  var _classnames3;

  var role = _ref5.role,
      notificationType = _ref5.notificationType,
      onCloseButtonClick = _ref5.onCloseButtonClick,
      iconDescription = _ref5.iconDescription,
      statusIconDescription = _ref5.statusIconDescription,
      className = _ref5.className,
      caption = _ref5.caption,
      subtitle = _ref5.subtitle,
      title = _ref5.title,
      kind = _ref5.kind,
      lowContrast = _ref5.lowContrast,
      hideCloseButton = _ref5.hideCloseButton,
      children = _ref5.children,
      timeout = _ref5.timeout,
      other = _objectWithoutProperties(_ref5, _excluded4$1);

  var _useState = useState(true),
      _useState2 = _slicedToArray(_useState, 2),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1];

  var containerClassName = classnames$1(className, (_classnames3 = {}, _defineProperty(_classnames3, "".concat(prefix$t, "--toast-notification"), true), _defineProperty(_classnames3, "".concat(prefix$t, "--toast-notification--low-contrast"), lowContrast), _defineProperty(_classnames3, "".concat(prefix$t, "--toast-notification--").concat(kind), kind), _classnames3));

  function handleCloseButtonClick(event) {
    setIsOpen(false);
    onCloseButtonClick(event);
  }

  useEffect(function () {
    if (!timeout) {
      return;
    }

    var timeoutId = window.setTimeout(function () {
      setIsOpen(false);
      onCloseButtonClick(event);
    }, timeout);
    return function () {
      window.clearTimeout(timeoutId);
    };
  }, [onCloseButtonClick, timeout]);

  if (!isOpen) {
    return null;
  }

  return /*#__PURE__*/React.createElement("div", _extends({}, other, {
    role: role,
    kind: kind,
    className: containerClassName
  }), /*#__PURE__*/React.createElement(NotificationIcon, {
    notificationType: notificationType,
    kind: kind,
    iconDescription: statusIconDescription || "".concat(kind, " icon")
  }), /*#__PURE__*/React.createElement(NotificationTextDetails, {
    title: title,
    subtitle: subtitle,
    caption: caption,
    notificationType: notificationType
  }, children), !hideCloseButton && /*#__PURE__*/React.createElement(NotificationButton, {
    iconDescription: iconDescription,
    notificationType: notificationType,
    onClick: handleCloseButtonClick
  }));
}
ToastNotification.propTypes = {
  /**
   * Specify the caption
   */
  caption: PropTypes.node,

  /**
   * Pass in the children that will be rendered within the ToastNotification
   */
  children: PropTypes.node,

  /**
   * Specify an optional className to be applied to the notification box
   */
  className: PropTypes.string,

  /**
   * Specify the close button should be disabled, or not
   */
  hideCloseButton: PropTypes.bool,

  /**
   * Provide a description for "close" icon that can be read by screen readers
   */
  iconDescription: PropTypes.string,

  /**
   * Specify what state the notification represents
   */
  kind: PropTypes.oneOf(['error', 'info', //'info-square',
  'success', 'warning', 'warning-alt']).isRequired,

  /**
   * Specify whether you are using the low contrast variant of the ToastNotification.
   */
  lowContrast: PropTypes.bool,

  /**
   * By default, this value is "toast". You can also provide an alternate type
   * if it makes sense for the underlying `<NotificationTextDetails>` and `<NotificationButton>`
   */
  notificationType: PropTypes.string,

  /**
   * Provide a function that is called when menu is closed
   */
  onCloseButtonClick: PropTypes.func,

  /**
   * By default, this value is "alert". You can also provide an alternate
   * role if it makes sense from the accessibility-side
   */
  role: PropTypes.string.isRequired,

  /**
   * Provide a description for "status" icon that can be read by screen readers
   */
  statusIconDescription: PropTypes.string,

  /**
   * Specify the sub-title
   */
  subtitle: PropTypes.node,

  /**
   * Specify an optional duration the notification should be closed in
   */
  timeout: PropTypes.number,

  /**
   * Specify the title
   */
  title: PropTypes.string.isRequired
};
ToastNotification.defaultProps = {
  kind: 'error',
  title: 'provide a title',
  caption: 'provide a caption',
  role: 'alert',
  notificationType: 'toast',
  iconDescription: 'closes notification',
  onCloseButtonClick: function onCloseButtonClick() {},
  hideCloseButton: false,
  timeout: 0
};
function InlineNotification(_ref6) {
  var _classnames4;

  var actions = _ref6.actions,
      role = _ref6.role,
      notificationType = _ref6.notificationType,
      onCloseButtonClick = _ref6.onCloseButtonClick,
      iconDescription = _ref6.iconDescription,
      statusIconDescription = _ref6.statusIconDescription,
      className = _ref6.className,
      subtitle = _ref6.subtitle,
      title = _ref6.title,
      kind = _ref6.kind,
      lowContrast = _ref6.lowContrast,
      hideCloseButton = _ref6.hideCloseButton,
      children = _ref6.children,
      other = _objectWithoutProperties(_ref6, _excluded5$1);

  var _useState3 = useState(true),
      _useState4 = _slicedToArray(_useState3, 2),
      isOpen = _useState4[0],
      setIsOpen = _useState4[1];

  var containerClassName = classnames$1(className, (_classnames4 = {}, _defineProperty(_classnames4, "".concat(prefix$t, "--inline-notification"), true), _defineProperty(_classnames4, "".concat(prefix$t, "--inline-notification--low-contrast"), lowContrast), _defineProperty(_classnames4, "".concat(prefix$t, "--inline-notification--").concat(kind), kind), _defineProperty(_classnames4, "".concat(prefix$t, "--inline-notification--hide-close-button"), hideCloseButton), _classnames4));

  function handleCloseButtonClick(event) {
    setIsOpen(false);
    onCloseButtonClick(event);
  }

  if (!isOpen) {
    return null;
  }

  return /*#__PURE__*/React.createElement("div", _extends({}, other, {
    role: role,
    kind: kind,
    className: containerClassName
  }), /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefix$t, "--inline-notification__details")
  }, /*#__PURE__*/React.createElement(NotificationIcon, {
    notificationType: notificationType,
    kind: kind,
    iconDescription: statusIconDescription || "".concat(kind, " icon")
  }), /*#__PURE__*/React.createElement(NotificationTextDetails, {
    title: title,
    subtitle: subtitle,
    notificationType: notificationType
  }, children)), actions, !hideCloseButton && /*#__PURE__*/React.createElement(NotificationButton, {
    iconDescription: iconDescription,
    notificationType: notificationType,
    onClick: handleCloseButtonClick
  }));
}
InlineNotification.propTypes = {
  /**
   * Pass in the action nodes that will be rendered within the InlineNotification
   */
  actions: PropTypes.node,

  /**
   * Pass in the children that will be rendered within the InlineNotification
   */
  children: PropTypes.node,

  /**
   * Specify an optional className to be applied to the notification box
   */
  className: PropTypes.string,

  /**
   * Specify the close button should be disabled, or not
   */
  hideCloseButton: PropTypes.bool,

  /**
   * Provide a description for "close" icon that can be read by screen readers
   */
  iconDescription: PropTypes.string,

  /**
   * Specify what state the notification represents
   */
  kind: PropTypes.oneOf(['error', 'info', //'info-square',
  'success', 'warning', 'warning-alt']).isRequired,

  /**
   * Specify whether you are using the low contrast variant of the InlineNotification.
   */
  lowContrast: PropTypes.bool,

  /**
   * By default, this value is "inline". You can also provide an alternate type
   * if it makes sense for the underlying `<NotificationTextDetails>` and `<NotificationButton>`
   */
  notificationType: PropTypes.string,

  /**
   * Provide a function that is called when menu is closed
   */
  onCloseButtonClick: PropTypes.func,

  /**
   * By default, this value is "alert". You can also provide an alternate
   * role if it makes sense from the accessibility-side
   */
  role: PropTypes.string.isRequired,

  /**
   * Provide a description for "status" icon that can be read by screen readers
   */
  statusIconDescription: PropTypes.string,

  /**
   * Specify the sub-title
   */
  subtitle: PropTypes.node,

  /**
   * Specify the title
   */
  title: PropTypes.string.isRequired
};
InlineNotification.defaultProps = {
  role: 'alert',
  notificationType: 'inline',
  iconDescription: 'closes notification',
  onCloseButtonClick: function onCloseButtonClick() {},
  hideCloseButton: false
};

var _excluded$q = ["additional", "className", "disabled", "formItemClassName", "id", "hideLabel", "hideControls", "labelText", "max", "min", "step", "invalid", "invalidText", "onChange", "onClick", "helperText", "light", "allowEmpty", "inputRef", "pattern"];
var prefix$s = settings$1.prefix;

function PropTypeEmptyString$1(props, propName, componentName) {
  componentName = componentName || 'ANONYMOUS';

  if (props[propName]) {
    var value = props[propName];

    if (typeof value === 'string' && value !== '') {
      return new Error(propName + ' in ' + componentName + ' is not an empty string');
    }
  }

  return null;
}

var countDecimals = function countDecimals(value) {
  if (Math.floor(value) === value) return 0;
  return value.split('.')[1].length || 0;
};

var capMin = function capMin(min, value) {
  return isNaN(min) || !min && min !== 0 || isNaN(value) || !value && value !== 0 ? value : Math.max(min, value);
};

var capMax = function capMax(max, value) {
  return isNaN(max) || !max && max !== 0 || isNaN(value) || !value && value !== 0 ? value : Math.min(max, value);
};
/** The number input component is used for entering numeric values and includes controls for incrementally increasing or decreasing the value */


var NumberInput = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var _classNames;

  props.additional;
      var className = props.className,
      disabled = props.disabled;
      props.formItemClassName;
      var id = props.id,
      hideLabel = props.hideLabel,
      hideControls = props.hideControls;
      props.labelText;
      var max = props.max,
      min = props.min,
      _props$step = props.step,
      step = _props$step === void 0 ? 1 : _props$step,
      invalid = props.invalid;
      props.invalidText;
      var _props$onChange = props.onChange,
      onChange = _props$onChange === void 0 ? function () {} : _props$onChange,
      _props$onClick = props.onClick,
      onClick = _props$onClick === void 0 ? function () {} : _props$onClick,
      helperText = props.helperText,
      light = props.light;
      props.allowEmpty;
      var _props$inputRef = props.inputRef,
      inputRef = _props$inputRef === void 0 ? ref : _props$inputRef,
      _props$pattern = props.pattern,
      pattern = _props$pattern === void 0 ? '[0-9]*' : _props$pattern,
      other = _objectWithoutProperties(props, _excluded$q);

  var initialValue = capMax(max, capMin(min, props.value));

  var _useState = useState(initialValue),
      _useState2 = _slicedToArray(_useState, 2),
      value = _useState2[0],
      setValue = _useState2[1];

  useEffect(function () {
    setValue(props.value);
  }, [props.value]);
  var newInputRef = useRef(null);

  var _inputRef = inputRef ? inputRef : newInputRef;

  var handleChange = function handleChange(evt) {
    if (!disabled) {
      evt.persist();
      evt.imaginaryTarget = _inputRef;
      setValue(evt.target.value);
      onChange(evt, parseFloat(evt.target.value)); //Had to reverse the arguments passed because onChange accepts evt before the value
    }
  };

  var handleArrowClick = function handleArrowClick(evt, direction) {
    var valueState = typeof value === 'string' ? Number(value) : value;
    valueState = isNaN(valueState) ? 0 : valueState;
    var conditional = direction === 'down' ? min !== undefined && valueState > min || min === undefined : max !== undefined && valueState < max || max === undefined;
    valueState = direction === 'down' ? valueState - step : valueState + parseFloat(step);
    valueState = capMax(max, capMin(min, valueState));
    valueState = parseFloat(valueState.toFixed(countDecimals(step)));

    if (!disabled && conditional) {
      evt.persist();
      evt.imaginaryTarget = _inputRef;
      evt.target.value = parseFloat(valueState);
      onClick(evt, direction);
      setValue(valueState);
      onChange(valueState, evt, direction);
    }
  };

  var numberInputClasses = classnames$1("".concat(prefix$s, "--number"), className, (_classNames = {}, _defineProperty(_classNames, "".concat(prefix$s, "--number--light"), light), _defineProperty(_classNames, "".concat(prefix$s, "--number--helpertext"), helperText), _defineProperty(_classNames, "".concat(prefix$s, "--number--nolabel"), hideLabel), _defineProperty(_classNames, "".concat(prefix$s, "--number--nocontrols"), hideControls), _classNames));
  var innerInputClasses = classnames$1(className, _defineProperty({}, "".concat(prefix$s, "--input--invalid"), invalid));
  var newProps = {
    disabled: disabled,
    id: id,
    max: max,
    min: min,
    step: step,
    onChange: handleChange,
    value: value
  };
  var buttonProps = {
    disabled: disabled,
    type: 'button'
  };
  return /*#__PURE__*/React.createElement(Input$1, _extends({}, props, {
    formItemClassName: numberInputClasses
  }), function () {
    return /*#__PURE__*/React.createElement("div", {
      className: "".concat(prefix$s, "--number__controls")
    }, /*#__PURE__*/React.createElement("button", _extends({
      className: "".concat(prefix$s, "--number__control-btn up-icon")
    }, buttonProps, {
      onClick: function onClick(evt) {
        return handleArrowClick(evt, 'up');
      }
    }), "+"), /*#__PURE__*/React.createElement("button", _extends({
      className: "".concat(prefix$s, "--number__control-btn down-icon")
    }, buttonProps, {
      onClick: function onClick(evt) {
        return handleArrowClick(evt, 'down');
      }
    }), "\u2212"), /*#__PURE__*/React.createElement("input", _extends({
      type: "number",
      pattern: pattern
    }, other, newProps, {
      ref: _inputRef,
      className: innerInputClasses
    })));
  });
});
NumberInput.propTypes = {
  /**
   * Specify an optional className to be applied to the wrapper node
   */
  className: PropTypes.string,

  /**
   * Specify an optional className to be applied to the form-item node
   */
  formItemClassName: PropTypes.string,

  /**
   * Specify if the control should be disabled, or not
   */
  disabled: PropTypes.bool,

  /**
   * Specify whether you want the underlying label to be visually hidden
   */
  hideLabel: PropTypes.bool,

  /**
   * Specify a custom `id` for the input
   */
  id: PropTypes.string,

  /**
   * Generic `label` that will be used as the textual representation of what
   * this field is for
   */
  labelText: PropTypes.node,

  /**
   * The maximum value.
   */
  max: PropTypes.number,

  /**
   * The minimum value.
   */
  min: PropTypes.number,

  /**
   * The new value is available in 'imaginaryTarget.value'
   * i.e. to get the value: evt.imaginaryTarget.value
   */
  onChange: PropTypes.func,

  /**
   * Provide an optional function to be called when the up/down button is clicked
   */
  onClick: PropTypes.func,

  /**
   * Specify how much the valus should increase/decrease upon clicking on up/down button
   */
  step: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /**
   * Specify the value of the input, if undefined or null the value is empty
   */
  value: PropTypes.oneOfType([PropTypeEmptyString$1, PropTypes.number]),

  /**
   * Specify whether the control is currently invalid.
   * Either a boolean in combination with `invalidText` or an `object`( eg. { message: "Message", …otherErrorProperties }) can be passed.
   */
  invalid: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),

  /**
   * Provide the text that is displayed when the control is in an invalid state
   */
  invalidText: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),

  /**
   * Provide additional component that is used alongside the input for customization
   */
  additional: PropTypes.node,

  /**
   * Provide text that is used alongside the control label for additional help
   */
  helperText: PropTypes.node,

  /**
   * `true` to use the light version.
   */
  light: PropTypes.bool,

  /**
   * `true` to allow empty string.
   */
  allowEmpty: PropTypes.bool
};
var NumberInput$1 = NumberInput;

var _excluded$p = ["className", "id", "inline", "labelText", "disabled", "children", "iconDescription", "hideLabel", "small", "invalid", "invalidText", "helperText", "light", "name", "inputRef"];
var prefix$r = settings$1.prefix;
/** The select component allows users to choose one option from a list. It is used in forms for users to submit data. */

var Select = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var _classNames;

  var className = props.className,
      id = props.id,
      inline = props.inline;
      props.labelText;
      var disabled = props.disabled,
      children = props.children,
      iconDescription = props.iconDescription;
      props.hideLabel;
      var small = props.small,
      invalid = props.invalid;
      props.invalidText;
      props.helperText;
      var light = props.light,
      name = props.name,
      _props$inputRef = props.inputRef,
      inputRef = _props$inputRef === void 0 ? ref : _props$inputRef,
      other = _objectWithoutProperties(props, _excluded$p);

  var usedId = id ? id : name;
  var selectClasses = classnames$1((_classNames = {}, _defineProperty(_classNames, "".concat(prefix$r, "--select"), true), _defineProperty(_classNames, "".concat(prefix$r, "--select--inline"), inline), _defineProperty(_classNames, "".concat(prefix$r, "--select--small"), small), _defineProperty(_classNames, "".concat(prefix$r, "--select--light"), light), _defineProperty(_classNames, "".concat(prefix$r, "--select--invalid"), invalid), _defineProperty(_classNames, "".concat(prefix$r, "--select--disabled"), disabled), _defineProperty(_classNames, className, className), _classNames));
  var ariaProps = {};

  if (invalid) {
    //TODO: check if correct
    ariaProps['aria-describedby'] = usedId;
  }

  var input = function () {
    return /*#__PURE__*/React.createElement("div", {
      className: selectClasses
    }, /*#__PURE__*/React.createElement("select", _extends({}, other, ariaProps, {
      id: usedId,
      name: name,
      className: "".concat(prefix$r, "--select-input"),
      disabled: disabled || undefined,
      "data-invalid": invalid || undefined,
      "aria-invalid": invalid || undefined,
      ref: inputRef
    }), children), /*#__PURE__*/React.createElement(Icon$1, {
      icon: iconCaretDown,
      className: "".concat(prefix$r, "--select__arrow"),
      description: iconDescription
    }));
  }();

  return /*#__PURE__*/React.createElement(Input$1, props, function () {
    return input;
  });
});
Select.propTypes = {
  /**
   * Provide the contents of your Select
   */
  children: PropTypes.node,

  /**
   * Specify an optional className to be applied to the node containing the label and the select box
   */
  className: PropTypes.string,

  /**
   * Specify a custom `id` for the `<select>`
   */
  id: PropTypes.string,

  /**
   * Specify whether you want the inline version of this control
   */
  inline: PropTypes.bool,

  /**
   * Provide label text to be read by screen readers when interacting with the
   * control
   */
  labelText: PropTypes.node,

  /**
   * Provide an optional `onChange` hook that is called each time the value of
   * the underlying `<input>` changes
   */
  onChange: PropTypes.func,

  /**
   * Specify whether the control is disabled
   */
  disabled: PropTypes.bool,

  /**
   * Optionally provide the default value of the `<select>`
   */
  defaultValue: PropTypes.any,

  /**
   * Provide a description for the twistie icon that can be read by screen readers
   */
  iconDescription: PropTypes.string.isRequired,

  /**
   * Specify whether the label should be hidden, or not
   */
  hideLabel: PropTypes.bool,

  /**
   * Specify whether the control is currently invalid.
   * Either a boolean in combination with `invalidText` or an `object`( eg. { message: "Message", …otherErrorProperties }) can be passed.
   */
  invalid: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),

  /**
   * Message which is displayed if the value is invalid.
   */
  invalidText: PropTypes.string,

  /**
   * Provide text that is used alongside the control label for additional help
   */
  helperText: PropTypes.node,

  /**
   * Specify whether you want the light version of this control
   */
  light: PropTypes.bool,

  /**
   * Specify whether you want the small version of this control
   */
  small: PropTypes.bool
};
Select.defaultProps = {
  disabled: false,
  inline: false,
  iconDescription: 'open list of options',
  invalid: false,
  invalidText: '',
  helperText: '',
  light: false
};
var Select$1 = Select;

var _excluded$o = ["className", "value", "disabled", "hidden", "text"];
var prefix$q = settings$1.prefix;

var SelectItem = function SelectItem(_ref) {
  var _classNames;

  var className = _ref.className,
      value = _ref.value,
      disabled = _ref.disabled,
      hidden = _ref.hidden,
      text = _ref.text,
      other = _objectWithoutProperties(_ref, _excluded$o);

  var selectItemClasses = classnames$1((_classNames = {}, _defineProperty(_classNames, "".concat(prefix$q, "--select-option"), true), _defineProperty(_classNames, className, className), _classNames));
  return /*#__PURE__*/React.createElement("option", _extends({}, other, {
    className: selectItemClasses,
    value: value,
    disabled: disabled,
    hidden: hidden
  }), text);
};

SelectItem.propTypes = {
  value: PropTypes.any.isRequired,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  hidden: PropTypes.bool,
  text: PropTypes.string.isRequired
};
SelectItem.defaultProps = {
  disabled: false,
  hidden: false,
  value: '',
  text: ''
};
var SelectItem$1 = SelectItem;

function equals(arr1, arr2) {
  if (!Array.isArray(arr1) || !Array.isArray(arr2) || arr1.length !== arr2.length) {
    return false;
  }

  if (arr1 === arr2) {
    return true;
  }

  for (var i = 0; i < arr1.length; i++) {
    if (arr1[i] !== arr2[i]) {
      return false;
    }
  }

  return true;
}

var _excluded$n = ["backwardText", "className", "forwardText", "id", "itemsPerPageText", "itemsPerPageFollowsText", "itemRangeText", "pageRangeText", "pageSize", "pageSizesDisabled", "pageSizes", "itemText", "pageText", "pageNumberText", "pagesUnknown", "isLastPage", "pageInputDisabled", "totalItems", "onChange", "page"];
var instanceId = 0;
/** Pagination is used for splitting up content or data into several pages, with a control for navigating to the next or previous page. */

var Pagination = /*#__PURE__*/function (_Component) {
  _inherits(Pagination, _Component);

  var _super = _createSuper(Pagination);

  function Pagination(props) {
    var _this;

    _classCallCheck(this, Pagination);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handleSizeChange", function (evt) {
      var pageSize = Number(evt.target.value);

      _this.setState({
        pageSize: pageSize,
        page: 1
      }, function () {});

      _this.props.onChange({
        page: 1,
        pageSize: pageSize
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handlePageChange", function (evt) {
      _this.setState({
        page: evt.target.value
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handlePageInputChange", function (evt) {
      var page = Number(evt.target.value);

      if (page > 0 && page <= Math.max(Math.ceil(_this.props.totalItems / _this.state.pageSize), 1)) {
        _this.setState({
          page: page
        });

        _this.props.onChange({
          page: page,
          pageSize: _this.state.pageSize
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "incrementPage", function () {
      var page = _this.state.page + 1;

      _this.setState({
        page: page
      });

      _this.props.onChange({
        page: page,
        pageSize: _this.state.pageSize
      });
    });

    _defineProperty(_assertThisInitialized(_this), "decrementPage", function () {
      var page = _this.state.page - 1;

      _this.setState({
        page: page
      });

      _this.props.onChange({
        page: page,
        pageSize: _this.state.pageSize
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderSelectItems", function (total) {
      var counter = 1;
      var itemArr = [];

      while (counter <= total) {
        itemArr.push( /*#__PURE__*/React.createElement(SelectItem$1, {
          key: counter,
          value: counter,
          text: String(counter)
        }));
        counter++;
      }

      return itemArr;
    });

    var _this$props = _this.props,
        pageSizes = _this$props.pageSizes,
        _page = _this$props.page,
        _pageSize = _this$props.pageSize;
    _this.state = {
      page: _page,
      pageSize: pageSizes.includes(_pageSize) ? _pageSize : pageSizes[0],
      prevPageSizes: pageSizes,
      prevPage: _page,
      prevPageSize: _pageSize
    };
    _this.uniqueId = ++instanceId;
    return _this;
  }

  _createClass(Pagination, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          backwardText = _this$props2.backwardText,
          className = _this$props2.className,
          forwardText = _this$props2.forwardText,
          id = _this$props2.id,
          itemsPerPageText = _this$props2.itemsPerPageText,
          itemsPerPageFollowsText = _this$props2.itemsPerPageFollowsText,
          itemRangeText = _this$props2.itemRangeText,
          pageRangeText = _this$props2.pageRangeText;
          _this$props2.pageSize;
          var pageSizesDisabled = _this$props2.pageSizesDisabled,
          pageSizes = _this$props2.pageSizes,
          itemText = _this$props2.itemText,
          pageText = _this$props2.pageText;
          _this$props2.pageNumberText;
          var pagesUnknown = _this$props2.pagesUnknown,
          isLastPage = _this$props2.isLastPage,
          pageInputDisabled = _this$props2.pageInputDisabled,
          totalItems = _this$props2.totalItems;
          _this$props2.onChange;
          _this$props2.page;
          var other = _objectWithoutProperties(_this$props2, _excluded$n);

      var statePage = this.state.page;
      var statePageSize = this.props.pageSize ? this.props.pageSize : this.state.pageSize;
      var classNames = classnames$1('wfp--pagination', className);
      var backButtonClasses = classnames$1('wfp--pagination__button', 'wfp--pagination__button--backward', {
        'wfp--pagination__button--no-index': pageInputDisabled
      });
      var inputId = id || this.uniqueId;
      var totalPages = Math.max(Math.ceil(totalItems / statePageSize), 1);
      var selectItems = this.renderSelectItems(totalPages);
      return /*#__PURE__*/React.createElement("div", _extends({
        className: classNames
      }, other), /*#__PURE__*/React.createElement("div", {
        className: "wfp--pagination__left"
      }, !pageSizesDisabled && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
        className: "wfp--pagination__text"
      }, itemsPerPageFollowsText || itemsPerPageText), /*#__PURE__*/React.createElement(Select$1, {
        id: "wfp-pagination-select-".concat(inputId),
        labelText: itemsPerPageText,
        hideLabel: true,
        inline: true,
        onChange: this.handleSizeChange // value={statePageSize}
        ,
        value: this.state.pageSize
      }, pageSizes.map(function (size) {
        return /*#__PURE__*/React.createElement(SelectItem$1, {
          key: size,
          value: size,
          text: String(size)
        });
      })), /*#__PURE__*/React.createElement("span", {
        className: "wfp--pagination__text"
      }, "\xA0|\xA0\xA0")), /*#__PURE__*/React.createElement("span", {
        className: "wfp--pagination__text"
      }, pagesUnknown ? itemText(statePageSize * (statePage - 1) + 1, statePage * statePageSize) : itemRangeText(Math.min(this.state.pageSize * (statePage - 1) + 1, totalItems), Math.min(statePage * this.state.pageSize, totalItems), totalItems))), /*#__PURE__*/React.createElement("div", {
        className: "wfp--pagination__right wfp--pagination--inline"
      }, /*#__PURE__*/React.createElement("span", {
        className: "wfp--pagination__text"
      }, pagesUnknown ? pageText(statePage) : pageRangeText(statePage, totalPages)), /*#__PURE__*/React.createElement("button", {
        className: backButtonClasses,
        onClick: this.decrementPage,
        disabled: this.props.disabled || statePage === 1,
        type: "button"
      }, /*#__PURE__*/React.createElement(Icon$1, {
        className: "wfp--pagination__button-icon",
        icon: iconChevronLeft,
        description: backwardText
      })), pageInputDisabled ? null : /*#__PURE__*/React.createElement(Select$1, {
        id: "wfp-pagination-select-".concat(inputId + 2),
        labelText: itemsPerPageText,
        hideLabel: true,
        inline: true,
        onChange: this.handlePageInputChange,
        value: statePage
      }, selectItems), /*#__PURE__*/React.createElement("button", {
        className: "wfp--pagination__button wfp--pagination__button--forward",
        onClick: this.incrementPage,
        disabled: this.props.disabled || statePage === totalPages || isLastPage,
        type: "button"
      }, /*#__PURE__*/React.createElement(Icon$1, {
        className: "wfp--pagination__button-icon",
        icon: iconChevronRight,
        description: forwardText
      }))));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(_ref, state) {
      var pageSizes = _ref.pageSizes,
          page = _ref.page,
          pageSize = _ref.pageSize;
      var prevPageSizes = state.prevPageSizes,
          prevPage = state.prevPage,
          prevPageSize = state.prevPageSize,
          currentPage = state.page,
          currentPageSize = state.pageSize;
      var pageSizesChanged = !equals(pageSizes, prevPageSizes);
      var pageChanged = page !== prevPage;
      var pageSizeChanged = pageSize !== prevPageSize;
      return !pageSizesChanged && !pageChanged && !pageSizeChanged ? null : {
        page: pageSizesChanged ? 1 : pageChanged ? page : currentPage,
        pageSize: pageSizesChanged ? pageSizes[0] : pageSizeChanged ? pageSize : currentPageSize,
        prevPageSizes: pageSizes,
        prevPage: page,
        prevPageSize: pageSize
      };
    }
  }]);

  return Pagination;
}(Component);

_defineProperty(Pagination, "propTypes", {
  /**
   * The description for the backward icon.
   */
  backwardText: PropTypes.string,

  /**
   * The CSS class names.
   */
  className: PropTypes.string,

  /**
   * The function returning a translatable text showing where the current page is,
   * in a manner of the range of items.
   */
  itemRangeText: PropTypes.func,

  /**
   * The description for the forward icon.
   */
  forwardText: PropTypes.string,

  /**
   * The unique ID of this component instance.
   */
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  /**
   * The translatable text indicating the number of items per page.
   */
  itemsPerPageText: PropTypes.string,

  /**
   * A variant of `itemsPerPageText`, with a sign indicating that the number follows, e.g. ':'.
   */
  itemsPerPageFollowsText: PropTypes.string,

  /**
   * A variant of `itemRangeText`, used if the total number of items is unknown.
   */
  itemText: PropTypes.func,

  /**
   * The callback function called when the current page changes.
   */
  onChange: PropTypes.func,
  pageNumberText: PropTypes.string,

  /**
   * A function returning PII showing where the current page is.
   */
  pageRangeText: PropTypes.func,

  /**
   * The translatable text showing the current page.
   */
  pageText: PropTypes.func,

  /**
   * The choices for `pageSize`.
   */
  pageSizes: PropTypes.arrayOf(PropTypes.number).isRequired,

  /**
   * `true` if ture the pageSizes should be not visible.
   */
  pageSizesDisabled: PropTypes.bool,

  /**
   * The total number of items.
   */
  totalItems: PropTypes.number,

  /**
   * `true` if the backward/forward buttons should be disabled.
   */
  disabled: PropTypes.bool,

  /**
   * The current page.
   */
  page: PropTypes.number,

  /**
   * The number dictating how many items a page contains.
   */
  pageSize: PropTypes.number,

  /**
   * `true` if the total number of items is unknown.
   */
  pagesUnknown: PropTypes.bool,

  /**
   * `true` if the current page should be the last page.
   */
  isLastPage: PropTypes.bool,

  /**
   * `true` if the select box to change the page should be disabled.
   */
  pageInputDisabled: PropTypes.bool
});

_defineProperty(Pagination, "defaultProps", {
  backwardText: 'Backward',
  itemRangeText: function itemRangeText(min, max, total) {
    return "".concat(min, "-").concat(max, " of ").concat(total, " items");
  },
  forwardText: 'Forward',
  itemsPerPageText: 'Items per page:',
  pageNumberText: 'Page Number',
  pageRangeText: function pageRangeText(current, total) {
    return "".concat(current, " of ").concat(total, " pages");
  },
  disabled: false,
  page: 1,
  pagesUnknown: false,
  pageSizes: [10, 20, 50],
  isLastPage: false,
  pageInputDisabled: false,
  itemText: function itemText(min, max) {
    return "".concat(min, "-").concat(max, " items");
  },
  pageText: function pageText(page) {
    return "page ".concat(page);
  }
});

var _excluded$m = ["labelText", "inputRef"];
var prefix$p = settings$1.prefix;
/** Radio buttons represent a group of mutually exclusive choices */

var RadioButton = /*#__PURE__*/function (_React$Component) {
  _inherits(RadioButton, _React$Component);

  var _super = _createSuper(RadioButton);

  function RadioButton() {
    var _this;

    _classCallCheck(this, RadioButton);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "handleChange", function (evt) {
      _this.props.onChange(evt, _this.props.value, _this.props.name);
    });

    return _this;
  }

  _createClass(RadioButton, [{
    key: "UNSAFE_componentWillMount",
    value: function UNSAFE_componentWillMount() {
      this.uid = this.props.id || uniqueId();
    }
  }, {
    key: "render",
    value: function render() {
      var wrapperClasses = classnames$1('radioButtonWrapper', this.props.className);

      var _this$props = this.props,
          labelText = _this$props.labelText,
          inputRef = _this$props.inputRef,
          other = _objectWithoutProperties(_this$props, _excluded$m);

      var handleChange = this.props.onChange ? {
        onChange: this.handleChange
      } : {};
      return /*#__PURE__*/React.createElement("div", {
        className: wrapperClasses
      }, /*#__PURE__*/React.createElement("input", _extends({}, other, {
        ref: inputRef,
        type: "radio",
        className: "".concat(prefix$p, "--radio-button")
      }, handleChange, {
        id: this.uid
      })), /*#__PURE__*/React.createElement("label", {
        htmlFor: this.uid,
        className: "".concat(prefix$p, "--radio-button__label")
      }, /*#__PURE__*/React.createElement("span", {
        className: "".concat(prefix$p, "--radio-button__appearance")
      }), labelText));
    }
  }]);

  return RadioButton;
}(React.Component);

_defineProperty(RadioButton, "propTypes", {
  /**
   * Specify whether the <RadioButton> is currently checked
   */
  checked: PropTypes.bool,

  /**
   * Provide an optional className to be applied to the containing node
   */
  className: PropTypes.string,

  /**
   * Specify whether the <RadioButton> should be checked by default
   */
  defaultChecked: PropTypes.bool,

  /**
   * Specify whether the control is disabled
   */
  disabled: PropTypes.bool,

  /**
   * Provide a unique id for the underlying `input` node
   */
  id: PropTypes.string,

  /**
   * Provide label text to be read by screen readers when interacting with the
   * control
   */
  labelText: PropTypes.node.isRequired,

  /**
   * Provide a name for the underlying `input` node
   */
  name: PropTypes.string,

  /**
   * Provide an optional `onChange` hook that is called each time the value of
   * the underlying `input` changes
   */
  onChange: PropTypes.func,

  /**
   * Specify the value of the <RadioButton>
   */
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired
});

var RadioButton$1 = (function () {
  var forwardRef = function forwardRef(props, ref) {
    return /*#__PURE__*/React.createElement(RadioButton, _extends({}, props, {
      inputRef: ref
    }));
  };

  forwardRef.displayName = 'RadioButton';
  return /*#__PURE__*/React.forwardRef(forwardRef);
})();

var _excluded$l = ["value"];
var prefix$o = settings$1.prefix;
/**
 * InputGroup allows you to organize and arange multiple input elements.
 */

var InputGroup = /*#__PURE__*/function (_React$Component) {
  _inherits(InputGroup, _React$Component);

  var _super = _createSuper(InputGroup);

  function InputGroup() {
    var _this;

    _classCallCheck(this, InputGroup);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      selected: _this.props.valueSelected || _this.props.defaultSelected
    });

    _defineProperty(_assertThisInitialized(_this), "getRadioButtons", function () {
      var children = React.Children.map(_this.props.children, function (radioButton) {
        var _radioButton$props = radioButton.props,
            value = _radioButton$props.value,
            other = _objectWithoutProperties(_radioButton$props, _excluded$l);
        /* istanbul ignore if */


        if (radioButton.props.hasOwnProperty('checked')) {
          process.env.NODE_ENV !== "production" ? warning(false, "Instead of using the checked property on the RadioButton, set\n            the defaultSelected property or valueSelected property on the InputGroup.") : void 0;
        }

        return /*#__PURE__*/React.createElement(RadioButton$1, _extends({}, other, {
          name: _this.props.name,
          key: value,
          value: value,
          onChange: _this.handleChange,
          checked: value === _this.state.selected
        }));
      });
      return children;
    });

    _defineProperty(_assertThisInitialized(_this), "handleChange", function (newSelection, value, evt) {
      if (newSelection !== _this.state.selected) {
        _this.setState({
          selected: newSelection
        });

        _this.props.onChange(newSelection, _this.props.name, evt);
      }
    });

    return _this;
  }

  _createClass(InputGroup, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          disabled = _this$props.disabled,
          labelText = _this$props.labelText,
          helperText = _this$props.helperText,
          controlled = _this$props.controlled,
          vertical = _this$props.vertical,
          hideLabel = _this$props.hideLabel,
          _this$props$className = _this$props.className,
          className = _this$props$className === void 0 ? "".concat(prefix$o, "--input-group") : _this$props$className;
      var labelClasses = classnames$1("".concat(prefix$o, "--label"), _defineProperty({}, "".concat(prefix$o, "--visually-hidden"), hideLabel));
      var wrapperClasses = classnames$1("".concat(prefix$o, "--form-item"), _defineProperty({}, "".concat(prefix$o, "--input-group__vertical"), vertical));
      var label = labelText ? /*#__PURE__*/React.createElement("span", {
        className: labelClasses
      }, labelText) : null;
      var helper = helperText ? /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefix$o, "--form__helper-text")
      }, helperText) : null;
      return /*#__PURE__*/React.createElement("div", {
        className: wrapperClasses
      }, /*#__PURE__*/React.createElement("div", {
        className: className,
        disabled: disabled
      }, label, helper, /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefix$o, "--input-group-inside")
      }, controlled ? this.getRadioButtons() : children)));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(_ref, state) {
      var valueSelected = _ref.valueSelected,
          defaultSelected = _ref.defaultSelected;
      var prevValueSelected = state.prevValueSelected;
      return prevValueSelected === valueSelected ? null : {
        selected: valueSelected || defaultSelected,
        prevValueSelected: valueSelected
      };
    }
  }]);

  return InputGroup;
}(React.Component);

_defineProperty(InputGroup, "propTypes", {
  /**
   * Provide a collection of <RadioButton> components to render in the group
   */
  children: PropTypes.node,

  /**
   * Provide an optional className to be applied to the container node
   */
  className: PropTypes.string,

  /**
   * Specify the <RadioButton> to be selected by default
   */
  defaultSelected: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  /**
   * Specify the name of the underlying `input` nodes
   */
  name: PropTypes.string,

  /**
   * Provide an optional `onChange` hook that is called whenever the value of
   * the group changes
   */
  onChange: PropTypes.func,

  /**
   * Specify the value that is currently selected in the group
   */
  valueSelected: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  /**
   * Specify whether the elements should be displayed vertically.
   */
  vertical: PropTypes.bool,

  /**
   * Specify whether you want the underlying label to be visually hidden
   */
  hideLabel: PropTypes.bool,

  /**
   * Provide text that is used alongside the control label for additional help
   */
  helperText: PropTypes.node,

  /**
   * Provide the text that will be read by a screen reader when visiting this
   * control
   */
  labelText: PropTypes.node
});

_defineProperty(InputGroup, "defaultProps", {
  onChange:
  /* istanbul ignore next */
  function onChange() {},
  controlled: false
});

var _excluded$k = ["value"];
var prefix$n = settings$1.prefix;

var RadioButtonGroup = /*#__PURE__*/function (_React$Component) {
  _inherits(RadioButtonGroup, _React$Component);

  var _super = _createSuper(RadioButtonGroup);

  function RadioButtonGroup() {
    var _this;

    _classCallCheck(this, RadioButtonGroup);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      selected: _this.props.valueSelected || _this.props.defaultSelected
    });

    _defineProperty(_assertThisInitialized(_this), "getRadioButtons", function () {
      var children = React.Children.map(_this.props.children, function (radioButton) {
        var _radioButton$props = radioButton.props,
            value = _radioButton$props.value,
            other = _objectWithoutProperties(_radioButton$props, _excluded$k);
        /* istanbul ignore if */


        if (radioButton.props.hasOwnProperty('checked')) {
          process.env.NODE_ENV !== "production" ? warning(false, "Instead of using the checked property on the RadioButton, set\n            the defaultSelected property or valueSelected property on the RadioButtonGroup.") : void 0;
        }

        return /*#__PURE__*/React.createElement(RadioButton$1, _extends({}, other, {
          name: _this.props.name,
          key: value,
          value: value,
          onChange: _this.handleChange,
          checked: value === _this.state.selected
        }));
      });
      return children;
    });

    _defineProperty(_assertThisInitialized(_this), "handleChange", function (newSelection, value, evt) {
      if (newSelection !== _this.state.selected) {
        _this.setState({
          selected: newSelection
        });

        _this.props.onChange(newSelection, _this.props.name, evt);
      }
    });

    return _this;
  }

  _createClass(RadioButtonGroup, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          disabled = _this$props.disabled,
          labelText = _this$props.labelText,
          helperText = _this$props.helperText,
          controlled = _this$props.controlled,
          vertical = _this$props.vertical,
          hideLabel = _this$props.hideLabel,
          _this$props$className = _this$props.className,
          className = _this$props$className === void 0 ? "".concat(prefix$n, "--radio-button-group") : _this$props$className;
      var labelClasses = classnames$1("".concat(prefix$n, "--label"), _defineProperty({}, "".concat(prefix$n, "--visually-hidden"), hideLabel));
      var wrapperClasses = classnames$1("".concat(prefix$n, "--form-item"), _defineProperty({}, "".concat(prefix$n, "--radio-button-group__vertical"), vertical));
      var label = labelText ? /*#__PURE__*/React.createElement("span", {
        className: labelClasses
      }, labelText) : null;
      var helper = helperText ? /*#__PURE__*/React.createElement("div", {
        className: "wfp--form__helper-text"
      }, helperText) : null; // console.warn(
      //   'RadioButtonGroup is depreciated and will be removed in the next versions. Use InputGroup instead'
      // );

      return /*#__PURE__*/React.createElement("div", {
        className: wrapperClasses
      }, /*#__PURE__*/React.createElement("div", {
        className: className,
        disabled: disabled
      }, label, helper, /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefix$n, "--radio-button-group-inside")
      }, controlled ? this.getRadioButtons() : children)));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(_ref, state) {
      var valueSelected = _ref.valueSelected,
          defaultSelected = _ref.defaultSelected;
      var prevValueSelected = state.prevValueSelected;
      return prevValueSelected === valueSelected ? null : {
        selected: valueSelected || defaultSelected,
        prevValueSelected: valueSelected
      };
    }
  }]);

  return RadioButtonGroup;
}(React.Component);

_defineProperty(RadioButtonGroup, "propTypes", {
  /**
   * Provide a collection of <RadioButton> components to render in the group
   */
  children: PropTypes.node,

  /**
   * Provide an optional className to be applied to the container node
   */
  className: PropTypes.string,

  /**
   * Provide an optional className to be applied to the container node
   */
  controlled: PropTypes.bool,

  /**
   * Specify the <RadioButton> to be selected by default
   */
  defaultSelected: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  /**
   * Specify the name of the underlying `input` nodes
   */
  name: PropTypes.string.isRequired,

  /**
   * Specify whether the group is disabled
   */
  disabled: PropTypes.bool,

  /**
   * Provide an optional `onChange` hook that is called whenever the value of
   * the group changes
   */
  onChange: PropTypes.func,

  /**
   * Specify the value that is currently selected in the group
   */
  valueSelected: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  /**
   * Specify whether the elements should be displayed vertically.
   */
  vertical: PropTypes.bool,

  /**
   * Specify whether you want the underlying label to be visually hidden
   */
  hideLabel: PropTypes.bool,

  /**
   * Provide text that is used alongside the control label for additional help
   */
  helperText: PropTypes.node,

  /**
   * Provide the text that will be read by a screen reader when visiting this
   * control
   */
  labelText: PropTypes.node
});

_defineProperty(RadioButtonGroup, "defaultProps", {
  onChange:
  /* istanbul ignore next */
  function onChange() {},
  controlled: false
});

var prefix$m = settings$1.prefix;

var MoreLink = function MoreLink(_ref) {
  var handleToggleClick = _ref.handleToggleClick,
      link = _ref.link,
      text = _ref.text,
      showMore = _ref.showMore;

  if (link) {
    var clonedLink = /*#__PURE__*/React.cloneElement(link, {
      onClick: handleToggleClick
    });
    return clonedLink;
  } else {
    return /*#__PURE__*/React.createElement(Link$1, {
      className: "".concat(prefix$m, "--read-more__trigger"),
      small: true,
      onClick: handleToggleClick
    }, text, /*#__PURE__*/React.createElement(Icon$1, {
      icon: showMore ? iconCaretUp : iconCaretDown,
      width: "10",
      height: "10",
      description: showMore ? 'icon up' : 'icon down'
    }));
  }
};
/** ReadMore component is a simple way to keep longer content from cluttering up your page, giving you more control over how much content is displayed to visitor */


function ReadMore(_ref2) {
  var _classnames;

  var collapseLink = _ref2.collapseLink,
      collapseText = _ref2.collapseText,
      children = _ref2.children,
      collapsed = _ref2.collapsed,
      className = _ref2.className,
      disableAutoscroll = _ref2.disableAutoscroll,
      expandLink = _ref2.expandLink,
      expandText = _ref2.expandText,
      fade = _ref2.fade,
      maxHeight = _ref2.maxHeight;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      showMore = _useState2[0],
      setShowMore = _useState2[1];

  var _useState3 = useState(0),
      _useState4 = _slicedToArray(_useState3, 2),
      innerHeight = _useState4[0],
      setInnerHeight = _useState4[1];

  var readMoreRef = useRef();
  var readMoreFakeRef = useRef();

  var handleToggleClick = function handleToggleClick(e) {
    e.preventDefault();
    var innerHeight = readMoreRef.current.clientHeight;
    if (!showMore && !disableAutoscroll) setTimeout(function () {
      readMoreFakeRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'end'
      });
    }, 50);
    setShowMore(!showMore);
    setInnerHeight(innerHeight);
  };

  var classNames = classnames$1(className, (_classnames = {}, _defineProperty(_classnames, "".concat(prefix$m, "--read-more"), true), _defineProperty(_classnames, "".concat(prefix$m, "--read-more--expanded"), showMore), _defineProperty(_classnames, "".concat(prefix$m, "--read-more--fade"), fade), _defineProperty(_classnames, "".concat(prefix$m, "--read-more--max-height"), maxHeight), _classnames));
  var contentStyle = !maxHeight ? {
    undefined: undefined
  } : maxHeight && !showMore ? {
    maxHeight: maxHeight
  } : {
    maxHeight: innerHeight + 20
  };
  var collapseStyle = showMore ? {
    display: 'none'
  } : {
    display: 'block'
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classNames
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefix$m, "--read-more__content"),
    style: contentStyle
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefix$m, "--read-more__fake-height"),
    ref: readMoreFakeRef,
    style: {
      height: "".concat(innerHeight + 30, "px")
    }
  }), /*#__PURE__*/React.createElement("div", {
    ref: readMoreRef
  }, (showMore || !collapsed) && children, collapsed && /*#__PURE__*/React.createElement("div", {
    style: collapseStyle
  }, collapsed))), /*#__PURE__*/React.createElement(MoreLink, {
    handleToggleClick: handleToggleClick,
    showMore: showMore,
    link: showMore ? collapseLink : expandLink,
    text: showMore ? collapseText : expandText
  }));
}
ReadMore.propTypes = {
  /**
   * Specify an optional className to be applied to the wrapper node
   */
  className: PropTypes.string,

  /**
   * The content of the expanded element
   */
  children: PropTypes.node.isRequired,

  /**
   * The content of the collapsed content (optional)
   */
  collapsed: PropTypes.node,

  /**
   * A custom link for collapsing
   */
  collapseLink: PropTypes.node,

  /**
   * Custom text for collapsing
   */
  collapseText: PropTypes.node,

  /**
   * Disable the scroll into view on expanding
   */
  disableAutoscroll: PropTypes.bool,

  /**
   * A custom link for expanding
   */
  expandLink: PropTypes.node,

  /**
   * Custom text for expanding
   */
  expandText: PropTypes.node,

  /**
   * Enables the fade effect when the content is collapsed (optional) when enabled collapsed will be ignored
   */
  fade: PropTypes.bool,

  /**
   * The maximum height when the content is collapsed (optional)
   */
  maxHeight: PropTypes.number
};
ReadMore.defaultProps = {
  expandText: 'Read more',
  collapseText: 'Read less'
};

var _excluded$j = ["input", "inputComponent", "InputComponent", "classNamePrefix", "invalidText", "meta"];
var didWarnAboutDeprecation = false;

var ReduxFormWrapper = function ReduxFormWrapper(_ref) {
  var input = _ref.input,
      inputComponent = _ref.inputComponent,
      InputComponent = _ref.InputComponent;
      _ref.classNamePrefix;
      _ref.invalidText;
      var _ref$meta = _ref.meta,
      touched = _ref$meta.touched,
      error = _ref$meta.error,
      submitError = _ref$meta.submitError;
      _ref$meta.warning;
      var other = _objectWithoutProperties(_ref, _excluded$j);

  if (inputComponent === undefined && InputComponent === undefined) return null;
  var InputComponentConnect = inputComponent ? inputComponent : InputComponent;

  if (process.env.NODE_ENV !== "production" && InputComponent !== undefined) {
    warning(didWarnAboutDeprecation, 'The `InputComponent` prop of ReduxFormWrapper has been deprecated and will be removed ' + 'in the next major release of `@wfp/ui`. Please use ' + '`children` instead.');
    didWarnAboutDeprecation = true;
  }
  /* if (typeof children === 'object') {
    const element = React.cloneElement(children, {
      input,
      other,
      labelText: (
        <React.Fragment>
          {other.labelText}
          {other.required && <div className="wfp--label__required" />}
        </React.Fragment>
      ),
      invalidText: error,
      onBlur: input.onBlur,
      onChange: input.onChange,
      invalid: touched && error
    })
  return (element) 
  } */


  return /*#__PURE__*/React.createElement(InputComponentConnect, _extends({}, input, other, {
    labelText: /*#__PURE__*/React.createElement(React.Fragment, null, other.labelText, other.required && /*#__PURE__*/React.createElement("div", {
      className: "wfp--label__required"
    })),
    invalidText: error || submitError,
    onBlur: input.onBlur,
    onChange: input.onChange,
    invalid: touched && (error || submitError) ? true : false
  }));
};

ReduxFormWrapper.propTypes = {
  /**
   * Provide a custom className that is applied directly to the underlying
   * input node
   */
  className: PropTypes.string,

  /**
   * Specify the input component which is getting connected
   */
  inputComponent: PropTypes.func.isRequired,

  /**
   * Specify whether the control is disabled
   */
  disabled: PropTypes.bool,

  /**
   * Provide a unique identifier for the control
   */
  id: PropTypes.string,

  /**
   * Provide the text that will be read by a screen reader when visiting this
   * control
   */
  labelText: PropTypes.node.isRequired,

  /**
   * Optionally provide an `onChange` handler that is called whenever <InputComponent>
   * is updated
   */
  onChange: PropTypes.func,

  /**
   * Optionally provide an `onClick` handler that is called whenever the
   * <InputComponent> is clicked
   */
  onClick: PropTypes.func,

  /**
   * Specify the placeholder attribute for the <textarea>
   */
  placeholder: PropTypes.string,

  /**
   * Provide the current value of the <textarea>
   */
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  /**
   * Specify whether the control is currently invalid.
   * Either a boolean in combination with `invalidText` or an `object`( eg. { message: "Message", …otherErrorProperties }) can be passed.
   */
  invalid: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),

  /**
   * Provide the text that is displayed when the control is in an invalid state
   */
  invalidText: PropTypes.string,

  /**
   * Provide text that is used alongside the control label for additional help
   */
  helperText: PropTypes.node,

  /**
   * Specify whether you want the underlying label to be visually hidden
   */
  hideLabel: PropTypes.bool
};
ReduxFormWrapper.defaultProps = {
  onChange: function onChange() {},
  onClick: function onClick() {}
};
var ReduxFormWrapper$1 = ReduxFormWrapper;

var prefix$l = settings$1.prefix;

var SecondaryNavigationTitle = function SecondaryNavigationTitle(_ref) {
  var className = _ref.className,
      children = _ref.children;
  var wrapperClasses = classnames$1("".concat(prefix$l, "--secondary-navigation__title"), className);
  return /*#__PURE__*/React.createElement("h1", {
    className: wrapperClasses
  }, children);
};

SecondaryNavigationTitle.propTypes = {
  /**
   * The CSS class name to be placed on the wrapping element.
   */
  className: PropTypes.string,

  /**
   * The content of the SecondaryNavigation can be fully customized.
   */
  children: PropTypes.node.isRequired
};
/** The SecondaryNavigation shows the page title and and optional tab navigation. */

var SecondaryNavigation = function SecondaryNavigation(_ref2) {
  var additional = _ref2.additional,
      children = _ref2.children,
      className = _ref2.className,
      wrapperClassName = _ref2.wrapperClassName,
      id = _ref2.id,
      pageWidth = _ref2.pageWidth;
  var wrapperClasses = classnames$1("".concat(prefix$l, "--secondary-navigation"), className, wrapperClassName);
  return /*#__PURE__*/React.createElement("div", {
    id: id,
    className: wrapperClasses
  }, /*#__PURE__*/React.createElement(Wrapper$1, {
    pageWidth: pageWidth,
    className: "".concat(prefix$l, "--secondary-navigation__wrapper")
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefix$l, "--secondary-navigation__list")
  }, children), additional && /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefix$l, "--secondary-navigation__additional")
  }, additional)));
};

SecondaryNavigation.propTypes = {
  children: PropTypes.node.isRequired,

  /**
   * The CSS class name to be placed on the wrapping element
   */
  className: PropTypes.string,
  id: PropTypes.string,

  /**
   * Specify the max-width on desktop devices (same as \`Wrapper\` component)
   */
  pageWidth: PropTypes.oneOf(['sm', 'md', 'lg', 'full']),
  wrapperClassName: PropTypes.string,

  /**
   * The additional prop is for any additional information tto be added at the right corner
   */
  additional: PropTypes.node
};
SecondaryNavigation.defaultProps = {
  pageWidth: 'lg'
};

var _excluded$i = ["children", "inline", "small", "vertical", "className", "role", "selectedPage", "onSelectionChange"];
var prefix$k = settings$1.prefix;
/** Step Navigation provide indications to help users reach their destination from their current position */

function StepNavigation(_ref) {
  var _classNames, _classNames2;

  var children = _ref.children,
      inline = _ref.inline,
      small = _ref.small,
      vertical = _ref.vertical,
      className = _ref.className,
      role = _ref.role,
      selectedPage = _ref.selectedPage,
      onSelectionChange = _ref.onSelectionChange;
      _objectWithoutProperties(_ref, _excluded$i);

  var _useState = useState(true),
      _useState2 = _slicedToArray(_useState, 2),
      dropdownHidden = _useState2[0];
      _useState2[1];

  var _useState3 = useState({}),
      _useState4 = _slicedToArray(_useState3, 2),
      elRefs = _useState4[0],
      setElRefs = _useState4[1];

  var getTabAt = function getTabAt(index) {
    return elRefs["tab".concat(index)] || React.Children.toArray(children)[index];
  };

  React.useEffect(function () {
    // add or remove refs
    setElRefs(function (elRefs) {
      return Array(arrLength).fill().map(function (_, i) {
        return elRefs[i] || /*#__PURE__*/createRef();
      });
    });
  }, [arrLength]);

  var getTabs = function getTabs() {
    return React.Children.map(children, function (tab) {
      return tab;
    });
  };

  var arrLength = getTabs().length; // const setTabAt = (index, tabRef) => {
  //   //setElRefs({ ...elRefs, [`tab${index}`]: tabRef });
  // };

  var handleTabClick = function handleTabClick(onSelectionChange) {
    return function (index, label, evt) {
      evt.preventDefault();
      selectTabAt(index, onSelectionChange);
    };
  };

  var handleTabAnchorFocus = function handleTabAnchorFocus(onSelectionChange) {
    return function (index) {
      var tabCount = React.Children.count(children) - 1;
      var tabIndex = index;

      if (index < 0) {
        tabIndex = tabCount;
      } else if (index > tabCount) {
        tabIndex = 0;
      }

      var tab = getTabAt(tabIndex);

      if (tab) {
        selectTabAt(tabIndex, onSelectionChange);

        if (tab.tabAnchor) {
          tab.tabAnchor.focus();
        }
      }
    };
  }; // const handleDropdownClick = () => {
  //   setDropdownHidden(!dropdownHidden);
  // };


  var selectTabAt = function selectTabAt(index, onSelectionChange) {

    if (typeof onSelectionChange === 'function') {
      onSelectionChange(index);
    }
  };

  var tabsWithProps = getTabs().map(function (tab, index) {
    var newTab = /*#__PURE__*/React.cloneElement(tab, {
      index: index,
      selectedPage: selectedPage,
      handleTabClick: handleTabClick(onSelectionChange),
      handleTabAnchorFocus: handleTabAnchorFocus(onSelectionChange),
      ref: elRefs[index]
    });
    return newTab;
  });
  var classes = {
    tabs: classnames$1(className, (_classNames = {}, _defineProperty(_classNames, "".concat(prefix$k, "--step-navigation"), true), _defineProperty(_classNames, "".concat(prefix$k, "--step-navigation--vertical"), vertical), _defineProperty(_classNames, "".concat(prefix$k, "--step-navigation--small"), small), _defineProperty(_classNames, "".concat(prefix$k, "--step-navigation--regular"), !small), _classNames)),
    tablist: classnames$1("".concat(prefix$k, "--step-navigation__nav"), (_classNames2 = {}, _defineProperty(_classNames2, "".concat(prefix$k, "--step-navigation__nav--hidden"), dropdownHidden), _defineProperty(_classNames2, "".concat(prefix$k, "--step-navigation__nav--inline"), inline), _classNames2))
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("nav", {
    className: classes.tabs,
    role: role
  }, /*#__PURE__*/React.createElement("ul", {
    role: "tablist",
    className: classes.tablist
  }, tabsWithProps)));
}
StepNavigation.defaultProps = {
  role: 'navigation',
  selectedPage: 0
};
StepNavigation.propTypes = {
  /**
   * Pass in a collection of <StepNavigationItem> children to be rendered depending on the
   * currently selected tab
   */
  children: PropTypes.node,

  /**
   * Provide a className that is applied to the root <nav> component for the
   * <Tabs>
   */
  className: PropTypes.string,

  /**
   * Specify whether the StepNavigation will be displayed small
   */
  small: PropTypes.bool,

  /**
   * Specify whether the StepNavigation will be displayed vertically
   */
  vertical: PropTypes.bool,

  /**
   * By default, this value is "navigation". You can also provide an alternate
   * role if it makes sense from the accessibility-side
   */
  role: PropTypes.string.isRequired,

  /**
   * Provide an optional handler that is called whenever the selection
   * changes. This method is called with the index of the tab that was
   * selected
   */
  onSelectionChange: PropTypes.func,

  /**
   * Optionally provide an index for the currently selected <Tab>
   */
  selectedPage: PropTypes.number
};

var prefix$j = settings$1.prefix;

var StepNavigationItem = /*#__PURE__*/function (_React$Component) {
  _inherits(StepNavigationItem, _React$Component);

  var _super = _createSuper(StepNavigationItem);

  function StepNavigationItem() {
    _classCallCheck(this, StepNavigationItem);

    return _super.apply(this, arguments);
  }

  _createClass(StepNavigationItem, [{
    key: "render",
    value: function render() {
      var _this = this;

      var _this$props = this.props,
          className = _this$props.className,
          handleTabClick = _this$props.handleTabClick,
          index = _this$props.index,
          label = _this$props.label,
          status = _this$props.status,
          helperText = _this$props.helperText,
          selectedPage = _this$props.selectedPage,
          _onClick = _this$props.onClick,
          page = _this$props.page,
          renderAnchor = _this$props.renderAnchor;
      var classes = classnames$1("".concat(prefix$j, "--step-navigation__nav-item"), _defineProperty({}, "".concat(prefix$j, "--step-navigation__nav-item--before"), page < selectedPage), _defineProperty({}, "".concat(prefix$j, "--step-navigation__nav-item--selected"), page === selectedPage), _defineProperty({}, "".concat(prefix$j, "--step-navigation__nav-item--").concat(status), status), className);
      var anchorProps = {
        className: "".concat(prefix$j, "--step-navigation__nav-link"),
        ref: function ref(e) {
          _this.tabAnchor = e;
        }
      };
      var icon = {
        'not-started': {
          icon: iconEllipsis
        },
        warning: {
          icon: iconWarningGlyph
        },
        locked: {
          icon: iconLocked
        },
        skip: {
          icon: iconOverflowMenu
        },
        disabled: {
          icon: iconErrorGlyph
        },
        complete: {
          icon: iconCheckmark
        },
        summary: {
          icon: iconMenu
        }
      };
      return /*#__PURE__*/React.createElement("li", {
        tabIndex: -1,
        className: classes,
        onClick: function onClick(evt) {
          if (status !== 'locked') {
            handleTabClick(index, label, evt);

            _onClick(evt);
          }
        },
        role: "presentation"
      }, typeof renderAnchor !== 'undefined' ? renderAnchor(anchorProps) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefix$j, "--step-navigation__nav-item__indicator")
      }, status && page !== selectedPage ? /*#__PURE__*/React.createElement(Icon$1, {
        icon: icon[status].icon,
        width: "14",
        height: "14",
        description: "Step Item"
      }) : /*#__PURE__*/React.createElement("span", null, page + 1)), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", {
        className: "".concat(prefix$j, "--step-navigation__nav-item__text")
      }, label), helperText && /*#__PURE__*/React.createElement("span", {
        className: "".concat(prefix$j, "--step-navigation__nav-item__helper-text")
      }, helperText))));
    }
  }]);

  return StepNavigationItem;
}(React.Component);

_defineProperty(StepNavigationItem, "propTypes", {
  /**
   * Provide a className that is applied to the StepNavigation component
   *
   */
  className: PropTypes.string,

  /**
   * Provide status one of these status prop type to your step to give more meaning.
   *
   */
  status: PropTypes.oneOf(['not-started', 'warning', 'complete', 'skip', 'disabled', 'locked']),

  /**
   * Provide text that is used alongside the control label for additional help
   *
   */
  helperText: PropTypes.node,

  /**
   * Provide the index of the each item
   *
   */
  index: PropTypes.number,

  /**
   * Provide the text that will be read by a screen reader when visiting this control
   *
   */
  label: PropTypes.string,

  /**
   * By default, this value is "presentation". You can also provide an alternate
   * role if it makes sense from the accessibility-side
   */
  role: PropTypes.string.isRequired,

  /**
   * On click handler to change the currently active item.
   **/
  onClick: PropTypes.func.isRequired,

  /**
   * The page number of the step.
   **/
  page: PropTypes.number.isRequired,

  /**
   * Optionally provide an index for the currently selected <Tab>
   */
  selectedPage: PropTypes.number.isRequired,

  /**
   * An optional parameter to allow overriding the anchor rendering.
   * Useful for using Tab along with react-router or other client
   * side router libraries.
   */
  renderAnchor: PropTypes.func
});

_defineProperty(StepNavigationItem, "defaultProps", {
  role: 'presentation',
  label: 'provide a label',
  tabIndex: 0,
  selectedPage: 0,
  onClick: function onClick() {}
});

var _excluded$h = ["children", "className", "disabled", "label"];
var prefix$i = settings$1.prefix;

var SelectItemGroup = function SelectItemGroup(_ref) {
  var children = _ref.children,
      className = _ref.className,
      disabled = _ref.disabled,
      label = _ref.label,
      other = _objectWithoutProperties(_ref, _excluded$h);

  var classNames = classnames$1("".concat(prefix$i, "--select-optgroup"), className);
  return /*#__PURE__*/React.createElement("optgroup", _extends({
    className: classNames,
    label: label,
    disabled: disabled
  }, other), children);
};

SelectItemGroup.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  label: PropTypes.string.isRequired
};
SelectItemGroup.defaultProps = {
  disabled: false,
  label: 'Provide label'
};
var SelectItemGroup$1 = SelectItemGroup;

var _excluded$g = ["active", "children", "className", "sidebarMobileHeader", "sidebar"],
    _excluded2 = ["className", "children", "noPadding"],
    _excluded3 = ["className", "children", "noPadding"],
    _excluded4 = ["className", "children", "noPadding"],
    _excluded5 = ["children"],
    _excluded6 = ["children"];
var prefix$h = settings$1.prefix;
function Sidebar(_ref) {
  var active = _ref.active,
      children = _ref.children,
      className = _ref.className;
      _ref.sidebarMobileHeader;
      var sidebar = _ref.sidebar,
      other = _objectWithoutProperties(_ref, _excluded$g);

  var classes = classnames$1("".concat(prefix$h, "--sidebar-content__container"), className, _defineProperty({}, "".concat(prefix$h, "--sidebar-content__container--active"), active));
  return /*#__PURE__*/React.createElement("div", _extends({
    className: classes
  }, other), /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefix$h, "--sidebar-item-content")
  }, sidebar), /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefix$h, "--content-section")
  }, children));
}
Sidebar.propTypes = {
  /**
   The children of content area
  */
  children: PropTypes.node,

  /**
   The `active` prop show the content section when an item is clicked. It's useful in mobile view 
  */
  active: PropTypes.bool,

  /**
   The Sidebar is usually where the sidebar items will be. 
   `<SidebarHeader/>` can be called in `Sidebar` and example search can be used in here
  */
  Sidebar: PropTypes.node,

  /**
     The sidebarMobileHeader is shwon when view is in mobile version. 
     `<SidebarBackButton/>` can used in the `sidebarMobileHeader` prop
  */
  sidebarMobileHeader: PropTypes.node
};
function SidebarHeader(_ref2) {
  var className = _ref2.className,
      children = _ref2.children,
      noPadding = _ref2.noPadding,
      other = _objectWithoutProperties(_ref2, _excluded2);

  var classes = classnames$1("".concat(prefix$h, "--sidebar-content__header"), className, _defineProperty({}, "".concat(prefix$h, "--sidebar-content__header--no-padding"), noPadding));
  return /*#__PURE__*/React.createElement("div", _extends({
    className: classes
  }, other), children);
}
SidebarHeader.propTypes = {
  /**
   The children of header of content area
  */
  children: PropTypes.node,

  /**
   Disable the default padding of the SidebarHeader
  */
  noPadding: PropTypes.bool
};
function SidebarContentHeader(_ref3) {
  var className = _ref3.className,
      children = _ref3.children;
      _ref3.noPadding;
      var other = _objectWithoutProperties(_ref3, _excluded3);

  var classes = classnames$1("".concat(prefix$h, "--sidebar-content-mobile-header"), className, {});
  return /*#__PURE__*/React.createElement("div", _extends({
    className: classes
  }, other), children);
}
SidebarContentHeader.propTypes = {
  /**
   The children of header of content area
  */
  children: PropTypes.node
};
function SidebarContentBody(_ref4) {
  var className = _ref4.className,
      children = _ref4.children;
      _ref4.noPadding;
      var other = _objectWithoutProperties(_ref4, _excluded4);

  var classes = classnames$1("".concat(prefix$h, "--sidebar-content__children"), className, {});
  return /*#__PURE__*/React.createElement("div", _extends({
    id: "scroll-container",
    className: classes
  }, other), children);
}
SidebarContentBody.propTypes = {
  /**
   The children of header of content area
  */
  children: PropTypes.node
};
function SidebarScroll(_ref5) {
  var children = _ref5.children,
      other = _objectWithoutProperties(_ref5, _excluded5);

  return /*#__PURE__*/React.createElement("div", _extends({
    className: "".concat(prefix$h, "--sidebar-content__scroll")
  }, other), children);
}
SidebarScroll.propTypes = {
  /**
  children will be sidebar items beneath the header. `SidebarScroll` wraps around the children to keep them scrolling while the header content is fixed
  */
  children: PropTypes.node
};
function SidebarBackButton(_ref6) {
  var children = _ref6.children,
      other = _objectWithoutProperties(_ref6, _excluded6);

  return /*#__PURE__*/React.createElement("div", _extends({
    className: "".concat(prefix$h, "--sidebar-content__back-button")
  }, other), /*#__PURE__*/React.createElement(Icon$1, {
    icon: iconChevronLeft
  }), children);
}
SidebarBackButton.propTypes = {
  /**
   The children of back button of content area
  */
  children: PropTypes.node
};

var _excluded$f = ["className", "index", "kind", "name", "onClick", "onKeyDown", "selected", "text", "icon", "href"];
var prefix$g = settings$1.prefix;

var Switch = function Switch(props) {
  var className = props.className,
      index = props.index,
      kind = props.kind,
      name = props.name,
      onClick = props.onClick,
      onKeyDown = props.onKeyDown,
      selected = props.selected,
      text = props.text,
      icon = props.icon,
      href = props.href,
      other = _objectWithoutProperties(props, _excluded$f);

  var handleClick = function handleClick(e) {
    e.preventDefault();
    onClick({
      index: index,
      name: name,
      text: text
    });
  };

  var handleKeyDown = function handleKeyDown(e) {
    var key = e.key || e.which;

    if (key === 'Enter' || key === 13 || key === ' ' || key === 32) {
      onKeyDown({
        index: index,
        name: name,
        text: text
      });
    }
  };

  var classes = classnames$1(className, "".concat(prefix$g, "--content-switcher-btn"), _defineProperty({}, "".concat(prefix$g, "--content-switcher--selected"), selected));
  var commonProps = {
    onClick: handleClick,
    onKeyDown: handleKeyDown,
    className: classes
  };
  var btnIcon = icon ? /*#__PURE__*/React.cloneElement(icon, {
    className: classnames$1(icon.props.className, "".concat(prefix$g, "--content-switcher__icon"))
  }) : null;

  if (kind === 'button') {
    return /*#__PURE__*/React.createElement("button", _extends({}, other, commonProps), btnIcon, text);
  }

  return /*#__PURE__*/React.createElement("a", _extends({
    href: href
  }, other, commonProps), btnIcon, text);
};

Switch.propTypes = {
  className: PropTypes.string,
  index: PropTypes.number,
  kind: PropTypes.oneOf(['button', 'anchor']).isRequired,
  name: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onClick: PropTypes.func,
  onKeyDown: PropTypes.func,
  selected: PropTypes.bool,
  text: PropTypes.string.isRequired,
  icon: PropTypes.element,
  href: PropTypes.string
};
Switch.defaultProps = {
  selected: false,
  kind: 'anchor',
  text: 'Provide text',
  href: '',
  onClick: function onClick() {},
  onKeyDown: function onKeyDown() {}
};
var Switch$1 = Switch;

var _excluded$e = ["disabled", "labelText", "className", "id", "formItemClassName", "placeholder", "type", "onChange", "onClick", "hideLabel", "invalid", "invalidText", "helperText", "inputRef", "pattern", "required"];
var prefix$f = settings$1.prefix;
/** Text inputs enable the user to interact with and input content and data. This component can be used for long and short form entries. */

var TextInput = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var _classNames;

  var disabled = props.disabled;
      props.labelText;
      var className = props.className,
      id = props.id,
      formItemClassName = props.formItemClassName;
      props.placeholder;
      var type = props.type;
      props.onChange;
      props.onClick;
      var hideLabel = props.hideLabel;
      props.invalid;
      props.invalidText;
      var helperText = props.helperText,
      _props$inputRef = props.inputRef,
      inputRef = _props$inputRef === void 0 ? ref : _props$inputRef,
      pattern = props.pattern,
      required = props.required,
      other = _objectWithoutProperties(props, _excluded$e);

  var textInputClasses = classnames$1("".concat(prefix$f, "--text"), className, (_classNames = {}, _defineProperty(_classNames, "".concat(prefix$f, "--text--helpertext"), helperText), _defineProperty(_classNames, "".concat(prefix$f, "--text--nolabel"), hideLabel), _defineProperty(_classNames, "".concat(prefix$f, "--text--required"), required), _classNames));
  var newProps = {
    disabled: disabled,
    id: id
  };
  return /*#__PURE__*/React.createElement(Input$1, _extends({}, props, {
    formItemClassName: formItemClassName
  }), function (e) {
    return /*#__PURE__*/React.createElement("input", _extends({
      pattern: pattern,
      type: type
    }, other, newProps, {
      ref: inputRef,
      className: textInputClasses
    }, e));
  });
});
TextInput.propTypes = {
  /**
   * Specify an optional className to be applied to the &lt;input&gt; node
   */
  className: PropTypes.string,

  /**
   * Optionally provide the default value of the &lt;input&gt;
   */
  defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  /**
   * Specify whether the &lt;input&gt; should be disabled
   */
  disabled: PropTypes.bool,

  /**
   * Specify an optional className to be applied to the form-item node
   */
  formItemClassName: PropTypes.string,

  /**
   * Specify a custom `id` for the &lt;input&gt;
   */
  id: PropTypes.string,

  /**
   * Provide the text that will be read by a screen reader when visiting this
   * control
   */
  labelText: PropTypes.node,

  /**
   * Specify a custom `name` for the &lt;input&gt;
   */
  name: PropTypes.string,

  /**
   * Optionally provide an `onChange` handler that is called whenever &lt;input&gt;
   * is updated
   */
  onChange: PropTypes.func,

  /**
   * Optionally provide an `onClick` handler that is called whenever the
   * &lt;input&gt; is clicked
   */
  onClick: PropTypes.func,

  /**
   * Specify the placeholder attribute for the &lt;input&gt;
   */
  placeholder: PropTypes.string,

  /**
   * Specify the type of the &lt;input&gt;
   */
  type: PropTypes.string,

  /**
   * Specify the value of the &lt;input&gt;
   */
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  /**
   * Specify whether you want the underlying label to be visually hidden
   */
  hideLabel: PropTypes.bool,

  /**
   * Specify whether the control is currently invalid.
   * Either a boolean in combination with `invalidText` or an `object`( eg. { message: "Message", …otherErrorProperties }) can be passed.
   */
  invalid: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),

  /**
   * Provide the text that is displayed when the control is in an invalid state
   */
  invalidText: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),

  /**
   * Provide additional component that is used alongside the input for customization
   */
  additional: PropTypes.node,

  /**
   * Provide text that is used alongside the control label for additional help
   */
  helperText: PropTypes.node
};
TextInput.defaultProps = {
  className: 'wfp--text-input',
  disabled: false,
  onChange: function onChange() {},
  onClick: function onClick() {},
  invalid: false,
  invalidText: '',
  helperText: ''
};
var TextInput$1 = TextInput;

var _excluded$d = ["additional", "ariaLabelInput", "className", "disabled", "formatLabel", "formItemClassName", "fullWidth", "id", "inputType", "hideLabel", "hideControls", "hideTextInput", "labelText", "min", "minLabel", "max", "maxLabel", "step", "invalid", "invalidText", "onChange", "onClick", "helperText", "allowEmpty", "inputRef"];
var prefix$e = settings$1.prefix;

var defaultFormatLabel = function defaultFormatLabel(value, label) {
  return typeof label === 'function' ? label(value) : "".concat(value).concat(label);
};

function PropTypeEmptyString(props, propName, componentName) {
  componentName = componentName || 'ANONYMOUS';

  if (props[propName]) {
    var value = props[propName];

    if (typeof value === 'string' && value !== '') {
      return new Error(propName + ' in ' + componentName + ' is not an empty string');
    }
  }

  return null;
}
/** Sliders provide a visual indication of adjustable content, where the user can move the handle along a horizontal track to increase or decrease the value. */


function Slider(props) {
  var _classNames;

  props.additional;
      var ariaLabelInput = props.ariaLabelInput,
      className = props.className,
      disabled = props.disabled,
      _props$formatLabel = props.formatLabel,
      formatLabel = _props$formatLabel === void 0 ? defaultFormatLabel : _props$formatLabel;
      props.formItemClassName;
      var fullWidth = props.fullWidth,
      id = props.id,
      inputType = props.inputType,
      hideLabel = props.hideLabel,
      hideControls = props.hideControls,
      hideTextInput = props.hideTextInput;
      props.labelText;
      var min = props.min,
      minLabel = props.minLabel,
      max = props.max,
      maxLabel = props.maxLabel,
      _props$step = props.step,
      step = _props$step === void 0 ? 1 : _props$step;
      props.invalid;
      props.invalidText;
      var _props$onChange = props.onChange,
      onChange = _props$onChange === void 0 ? function () {} : _props$onChange;
      props.onClick;
      var helperText = props.helperText;
      props.allowEmpty;
      var inputRef = props.inputRef,
      other = _objectWithoutProperties(props, _excluded$d);

  var initialValue = props.value;

  var _useState = useState(initialValue),
      _useState2 = _slicedToArray(_useState, 2),
      value = _useState2[0],
      setValue = _useState2[1];

  useEffect(function () {
    setValue(props.value);
  }, [props.value]);
  var newInputRef = useRef(null);

  var _inputRef = inputRef ? inputRef : newInputRef;

  var handleChange = function handleChange(evt) {
    if (!disabled) {
      evt.persist();
      evt.imaginaryTarget = _inputRef;

      if (evt.target.value > max) {
        setValue(max);
        onChange(parseFloat(max), evt);
      }
      /* else if (evt.target.value < min) {
      setValue(evt.target.value);
      onChange(parseFloat(min), evt);
      }*/
      else {
        setValue(evt.target.value);
        onChange(parseFloat(evt.target.value), evt);
      }
    }
  };

  var numberInputClasses = classnames$1("".concat(prefix$e, "--slider--wrapper"), className, (_classNames = {}, _defineProperty(_classNames, "".concat(prefix$e, "--slider--helpertext"), helperText), _defineProperty(_classNames, "".concat(prefix$e, "--slider--nolabel"), hideLabel), _defineProperty(_classNames, "".concat(prefix$e, "--slider--nocontrols"), hideControls), _classNames));
  var sliderContainerClasses = classnames$1("".concat(prefix$e, "--slider-container"), _defineProperty({}, "".concat(prefix$e, "--slider-container--full-width"), fullWidth));
  var newProps = {
    disabled: disabled,
    id: id,
    max: max,
    min: min,
    step: step,
    onChange: handleChange,
    value: value
  };
  var inputClasses = classnames$1("".concat(prefix$e, "--input"), "".concat(prefix$e, "--slider-text-input"));
  var sliderClasses = classnames$1("".concat(prefix$e, "--slider"), _defineProperty({}, "".concat(prefix$e, "--slider--disabled"), disabled), className);
  var sliderRangeWrapperClasses = classnames$1("".concat(prefix$e, "--slider__range-wrapper"), _defineProperty({}, "".concat(prefix$e, "--slider__range-wrapper--disabled"), disabled), className);
  var valueMinimal = value < min ? min : value;
  return /*#__PURE__*/React.createElement(Input$1, _extends({}, props, {
    formItemClassName: numberInputClasses
  }), function () {
    return /*#__PURE__*/React.createElement("div", {
      className: sliderContainerClasses
    }, /*#__PURE__*/React.createElement("span", {
      className: "".concat(prefix$e, "--slider__range-label")
    }, formatLabel(min, minLabel)), /*#__PURE__*/React.createElement("div", {
      className: sliderRangeWrapperClasses
    }, /*#__PURE__*/React.createElement("div", {
      className: "".concat(prefix$e, "--slider__range-before"),
      style: {
        width: "".concat((valueMinimal - min) / (max - min) * 100, "%")
      }
    }), /*#__PURE__*/React.createElement("input", _extends({
      className: sliderClasses,
      type: "range"
    }, other, newProps, {
      ref: _inputRef
    }))), /*#__PURE__*/React.createElement("span", {
      className: "".concat(prefix$e, "--slider__range-label")
    }, formatLabel(max, maxLabel)), !hideTextInput && /*#__PURE__*/React.createElement(TextInput$1, {
      disabled: disabled,
      type: inputType,
      id: "input-for-slider",
      className: inputClasses,
      value: value,
      onChange: handleChange,
      labelText: "",
      "aria-label": ariaLabelInput
    }));
  });
}

Slider.propTypes = {
  /**
   * Specify an optional className to be applied to the wrapper node
   */
  className: PropTypes.string,

  /**
   * `true` to hide the number input box.
   */
  hideTextInput: PropTypes.bool,

  /**
   * Specify an optional className to be applied to the form-item node
   */
  formItemClassName: PropTypes.string,

  /**
   * Specify if the control should be disabled, or not
   */
  disabled: PropTypes.bool,

  /**
   * Specify whether you want the underlying label to be visually hidden
   */
  hideLabel: PropTypes.bool,

  /**
   * Specify a custom `id` for the input
   */
  id: PropTypes.string.isRequired,

  /**
   * Generic `label` that will be used as the textual representation of what
   * this field is for
   */
  labelText: PropTypes.node,

  /**
   * The minimum value.
   */
  min: PropTypes.number.isRequired,

  /**
   * The label associated with the minimum value.
   */
  minLabel: PropTypes.string,

  /**
   * The maximum value.
   */
  max: PropTypes.number.isRequired,

  /**
   * The label associated with the maximum value.
   */
  maxLabel: PropTypes.string,

  /**
   * The callback to format the label associated with the minimum/maximum value.
   */
  formatLabel: PropTypes.func,

  /**
   * The new value is available in 'imaginaryTarget.value'
   * i.e. to get the value: evt.imaginaryTarget.value
   */
  onChange: PropTypes.func,

  /**
   * Provide an optional function to be called when the up/down button is clicked
   */
  onClick: PropTypes.func,

  /**
   * The `name` attribute of the `<input>`.
   */
  name: PropTypes.string,

  /**
   * The `type` attribute of the `<input>`.
   */
  inputType: PropTypes.string,

  /**
   * The `ariaLabel` for the `<input>`.
   */
  ariaLabelInput: PropTypes.string,

  /**
   * A value determining how much the value should increase/decrease by moving the thumb by mouse.
   */
  step: PropTypes.number,

  /**
   * Specify the value of the input, if undefined or null the value is empty
   */
  value: PropTypes.oneOfType([PropTypeEmptyString, PropTypes.number]),

  /**
   * Specify whether the control is currently invalid.
   * Either a boolean in combination with `invalidText` or an `object`( eg. { message: "Message", …otherErrorProperties }) can be passed.
   */
  invalid: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),

  /**
   * Message which is displayed if the value is invalid.
   */
  invalidText: PropTypes.string,

  /**
   * Provide additional component that is used alongside the input for customization
   */
  additional: PropTypes.node,

  /**
   * Provide text that is used alongside the control label for additional help
   */
  helperText: PropTypes.node,

  /**
   * `true` to allow empty string.
   */
  allowEmpty: PropTypes.bool,

  /**
   * Use the width of the parent element
   */
  fullWidth: PropTypes.bool
};
Slider.defaultProps = {
  fullWidth: false,
  hideTextInput: false,
  step: 1,
  disabled: false,
  minLabel: '',
  maxLabel: '',
  inputType: 'number',
  ariaLabelInput: 'Slider number input',
  min: 0
};

var _excluded$c = ["active", "additional", "button", "children", "className", "href", "subContent", "image", "hint", "noImage", "showAdditionalIcon", "title", "kind", "wrapper"];
var prefix$d = settings$1.prefix;
/** The item component to show entries inside a list, like a sidebar or an overview page. */

var Item = function Item(_ref) {
  var _classnames;

  var active = _ref.active,
      additional = _ref.additional;
      _ref.button;
      var children = _ref.children,
      className = _ref.className;
      _ref.href;
      var subContent = _ref.subContent,
      image = _ref.image,
      hint = _ref.hint,
      noImage = _ref.noImage,
      showAdditionalIcon = _ref.showAdditionalIcon,
      title = _ref.title,
      _ref$kind = _ref.kind,
      kind = _ref$kind === void 0 ? 'large' : _ref$kind,
      _ref$wrapper = _ref.wrapper,
      wrapper = _ref$wrapper === void 0 ? 'none' : _ref$wrapper,
      other = _objectWithoutProperties(_ref, _excluded$c);

  var classNames = classnames$1((_classnames = {}, _defineProperty(_classnames, "".concat(prefix$d, "--item"), true), _defineProperty(_classnames, "".concat(prefix$d, "--item--").concat(kind), kind), _defineProperty(_classnames, "".concat(prefix$d, "--item--").concat(wrapper), wrapper), _defineProperty(_classnames, "".concat(prefix$d, "--item--active"), active), _classnames), className);
  return /*#__PURE__*/React.createElement("div", _extends({
    className: classNames
  }, other), image ? /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefix$d, "--item__image")
  }, image) : noImage ? /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefix$d, "--item__image ").concat(prefix$d, "--item__image-empty")
  }) : null, /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefix$d, "--item__content")
  }, title && /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefix$d, "--item__title-wrapper")
  }, /*#__PURE__*/React.createElement("h2", {
    className: "".concat(prefix$d, "--item__title")
  }, title), additional && /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefix$d, "--item__additional")
  }, additional, showAdditionalIcon && /*#__PURE__*/React.createElement(Icon$1, {
    icon: iconChevronRight,
    className: "".concat(prefix$d, "--item__additional-icon")
  }))), /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefix$d, "--item__text-wrapper")
  }, /*#__PURE__*/React.createElement("div", null, children && /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefix$d, "--item__text")
  }, children), subContent && /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefix$d, "--item__sub-content")
  }, subContent)), /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefix$d, "--item__right")
  }, hint && /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefix$d, "--item__hint")
  }, hint)))));
};
Item.propTypes = {
  /**
   * Provide the description for the item content
   */
  children: PropTypes.node,

  /**
   * Provide the title for the item contet
   */
  title: PropTypes.node,

  /**
   * Provide the icon for the item content
   */
  icon: PropTypes.node,

  /**
   * Provide one or multiple buttons
   */
  button: PropTypes.node,

  /**
   * Provide a custom className to be applied to the containing <a> node
   */
  className: PropTypes.string,

  /**
   * Provide a kind to use different appearances.
   */
  kind: PropTypes.oneOf(['undefined', 'large', 'horizontal']),

  /**
   * Provide a wrap to use different borders.
   */
  wrapper: PropTypes.oneOf(['undefined', 'sidebar', 'repeater'])
};
var Item$1 = Item;

var _excluded$b = ["className", "children", "responsive", "withBorder"];
var prefix$c = settings$1.prefix;
/** Tables are used to make large volumes of data easy to understand and to access. */

function Table(_ref) {
  var _classNames;

  var className = _ref.className,
      children = _ref.children,
      responsive = _ref.responsive,
      withBorder = _ref.withBorder,
      other = _objectWithoutProperties(_ref, _excluded$b);

  var classes = classnames$1("".concat(prefix$c, "--table"), (_classNames = {}, _defineProperty(_classNames, "".concat(prefix$c, "--table--responsive"), responsive), _defineProperty(_classNames, "".concat(prefix$c, "--table--with-border"), withBorder), _classNames), className);
  return /*#__PURE__*/React.createElement("table", _extends({}, other, {
    className: classes
  }), children);
}
Table.propTypes = {
  /**
   * Provide the content for the Table, usually `<thead />` or `<tbody/>`
   */
  children: PropTypes.node,

  /**
   * Provide a custom className to be applied to the containing `<table />` node
   */
  className: PropTypes.string,

  /**
   * Displays the `<table />` as a responsive layout on small devices
   */
  responsive: PropTypes.bool,

  /**
   * Displays a border around the `<table />` node
   */
  withBorder: PropTypes.bool
};

var _excluded$a = ["className", "isSorted", "isSortedDesc", "sortType"];
function TableSorting(_ref) {
  var className = _ref.className,
      isSorted = _ref.isSorted,
      isSortedDesc = _ref.isSortedDesc,
      sortType = _ref.sortType;
      _objectWithoutProperties(_ref, _excluded$a);

  var classes = classnames$1(className, 'wfp--table--sorting', {
    'wfp--table--is-sorted': isSorted,
    'wfp--table--is-sortable': sortType
  });
  return /*#__PURE__*/React.createElement("span", {
    className: classes
  }, isSorted ? isSortedDesc ? /*#__PURE__*/React.createElement(Icon$1, {
    icon: iconCaretDown
  }) : /*#__PURE__*/React.createElement(Icon$1, {
    icon: iconCaretUp
  }) : '');
}
TableSorting.propTypes = {
  /**
   * Provide the content for the Table, usually `<thead />` or `<tbody/>`
   */
  children: PropTypes.node,

  /**
   * Provide a custom className to be applied to the containing <table /> node
   */
  className: PropTypes.string,

  /**
   * Displays a border around the  <table /> node
   */
  withBorder: PropTypes.bool
};

var prefix$b = settings$1.prefix;

var ReactTablePagination = function ReactTablePagination(_ref) {
  var data = _ref.data,
      page = _ref.page,
      pageSizeOptions = _ref.pageSizeOptions,
      paginationClassName = _ref.paginationClassName,
      totalItems = _ref.totalItems,
      style = _ref.style,
      onPageChange = _ref.onPageChange,
      onPageSizeChange = _ref.onPageSizeChange,
      isLastPage = _ref.isLastPage,
      pages = _ref.pages;
      _ref.showPageSizeOptions;
      var pageInputDisabled = _ref.pageInputDisabled,
      pageSize = _ref.pageSize,
      pagesUnknown = _ref.pagesUnknown,
      backwardText = _ref.backwardText,
      forwardText = _ref.forwardText,
      itemsPerPageText = _ref.itemsPerPageText,
      itemsPerPageFollowsText = _ref.itemsPerPageFollowsText,
      itemRangeText = _ref.itemRangeText,
      pageRangeText = _ref.pageRangeText,
      pageSizesDisabled = _ref.pageSizesDisabled,
      itemText = _ref.itemText,
      pageNumberText = _ref.pageNumberText;

  var getSafePage = function getSafePage(newPage) {
    if (isNaN(newPage)) {
      newPage = page;
    }

    return newPage;
  };

  var changePage = function changePage(page) {
    var nextPage = getSafePage(page.page - 1); // Update Page

    if (page !== nextPage) {
      onPageChange(nextPage);
    } // Update PageSize


    if (pageSize !== page.pageSize) {
      onPageSizeChange(page.pageSize);
    }
  };

  var propList = {
    isLastPage: isLastPage,
    pages: pages,
    //showPageSizeOptions,
    pageInputDisabled: pageInputDisabled,
    pageSize: pageSize,
    pagesUnknown: pagesUnknown,
    backwardText: backwardText,
    forwardText: forwardText,
    itemsPerPageText: itemsPerPageText,
    itemsPerPageFollowsText: itemsPerPageFollowsText,
    itemRangeText: itemRangeText,
    pageRangeText: pageRangeText,
    pageSizesDisabled: pageSizesDisabled,
    itemText: itemText,
    pageNumberText: pageNumberText
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classnames$1(paginationClassName, '-pagination'),
    style: style
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefix$b, "-pagination")
  }, /*#__PURE__*/React.createElement(Pagination, _extends({
    onChange: changePage,
    pageSizes: pageSizeOptions,
    page: page,
    totalItems: totalItems ? totalItems : data ? data.length : undefined
  }, propList))));
};

var ReactTablePagination$1 = ReactTablePagination;

var prefix$a = settings$1.prefix;

var Tab = /*#__PURE__*/function (_React$Component) {
  _inherits(Tab, _React$Component);

  var _super = _createSuper(Tab);

  function Tab() {
    _classCallCheck(this, Tab);

    return _super.apply(this, arguments);
  }

  _createClass(Tab, [{
    key: "setTabFocus",
    value: function setTabFocus(evt) {
      var leftKey = 37;
      var rightKey = 39;

      if (evt.which === leftKey) {
        this.props.handleTabAnchorFocus(this.props.index - 1);
      } else if (evt.which === rightKey) {
        this.props.handleTabAnchorFocus(this.props.index + 1);
      } else {
        return;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      var _this$props = this.props,
          className = _this$props.className,
          disabled = _this$props.disabled,
          handleTabClick = _this$props.handleTabClick;
          _this$props.handleTabAnchorFocus;
          var handleTabKeyDown = _this$props.handleTabKeyDown,
          href = _this$props.href,
          index = _this$props.index,
          label = _this$props.label,
          selected = _this$props.selected,
          tabIndex = _this$props.tabIndex,
          _onClick = _this$props.onClick,
          _onKeyDown = _this$props.onKeyDown,
          renderAnchor = _this$props.renderAnchor,
          renderListElement = _this$props.renderListElement;
      var classes = classnames$1("".concat(prefix$a, "--tabs__nav-item"), _defineProperty({}, "".concat(prefix$a, "--tabs__nav-item--disabled"), disabled), _defineProperty({}, "".concat(prefix$a, "--tabs__nav-item--selected"), selected), className);
      var selectedClasses = classnames$1("".concat(prefix$a, "--tabs__nav-item"), "".concat(prefix$a, "--tabs__nav-item--selected"), className);
      var anchorProps = {
        className: 'wfp--tabs__nav-link',
        href: disabled ? undefined : href,
        label: label,
        role: 'tab',
        tabIndex: tabIndex,
        'aria-selected': selected,
        ref: function ref(e) {
          _this.tabAnchor = e;
        }
      }; //  {...other}

      var liProps = {
        tabIndex: -1,
        className: classes,
        onClick: function onClick(evt) {
          if (!disabled) {
            handleTabClick(index, label, evt);

            _onClick(evt);
          }
        },
        onKeyDown: function onKeyDown(evt) {
          if (!disabled) {
            _this.setTabFocus(evt);

            handleTabKeyDown(index, label, evt);

            _onKeyDown(evt);
          }
        },
        role: 'presentation',
        selected: selected
      };
      return /*#__PURE__*/React.createElement(React.Fragment, null, renderListElement ? renderListElement(_objectSpread2(_objectSpread2(_objectSpread2({}, this.props), liProps), {}, {
        anchor: anchorProps,
        selectedClasses: selectedClasses
      })) : /*#__PURE__*/React.createElement("li", liProps, renderAnchor ? renderAnchor(anchorProps) : disabled ? /*#__PURE__*/React.createElement("span", anchorProps, label) : /*#__PURE__*/React.createElement("a", anchorProps, label)));
    }
  }]);

  return Tab;
}(React.Component);

_defineProperty(Tab, "propTypes", {
  /**
   * Specify an optional className to be added to your Tab
   */
  className: PropTypes.string,

  /**
   * A handler that is invoked when a user clicks on the control.
   * Reserved for usage in Tabs
   */
  handleTabClick: PropTypes.func,

  /**
   * A handler that is invoked when a user presses left/right key.
   * Reserved for usage in Tabs
   */
  handleTabAnchorFocus: PropTypes.func,

  /**
   * A handler that is invoked on the key down event for the control.
   * Reserved for usage in Tabs
   */
  handleTabKeyDown: PropTypes.func,

  /**
   * Whether your Tab is disabled.
   */
  disabled: PropTypes.bool,

  /**
   * Provide a string that represents the `href` of the Tab
   */
  href: PropTypes.string.isRequired,

  /**
   * The index of your Tab in your Tabs. Reserved for usage in Tabs
   */
  index: PropTypes.number,

  /**
   * Provide the contents of your Tab
   */
  label: PropTypes.node,

  /**
   * Provide an accessibility role for your Tab
   */
  role: PropTypes.string.isRequired,

  /**
   * Provide a handler that is invoked when a user clicks on the control
   */
  onClick: PropTypes.func.isRequired,

  /**
   * Provide a handler that is invoked on the key down event for the control
   */
  onKeyDown: PropTypes.func.isRequired,

  /**
   * Whether your Tab is selected.
   * Reserved for usage in Tabs
   */
  selected: PropTypes.bool.isRequired,

  /**
   * Specify the tab index of the <a> node
   */
  tabIndex: PropTypes.number.isRequired,

  /*
   * An optional parameter to allow overriding the anchor rendering.
   * Useful for using Tab along with react-router or other client
   * side router libraries.
   **/
  renderAnchor: PropTypes.func,

  /*
   * An optional parameter to allow overriding the content rendering.
   **/
  renderContent: PropTypes.func,

  /*
   * An optional parameter to allow overriding the list element rendering.
   **/
  renderListElement: PropTypes.oneOfType([PropTypes.node, PropTypes.func])
});

_defineProperty(Tab, "defaultProps", {
  role: 'presentation',
  label: 'provide a label',
  tabIndex: 0,
  href: '#',
  selected: false,
  onClick: function onClick() {},
  onKeyDown: function onKeyDown() {}
});

var _excluded$9 = ["selected", "children"];

var TabContent = function TabContent(props) {
  var selected = props.selected,
      children = props.children,
      other = _objectWithoutProperties(props, _excluded$9);

  return /*#__PURE__*/React.createElement("div", _extends({}, other, {
    selected: selected,
    hidden: !selected
  }), children);
};

TabContent.propTypes = {
  /**
   * Specify whether the TabContent is selected
   */
  selected: PropTypes.bool,

  /**
   * Pass in content to render inside of the TabContent
   */
  children: PropTypes.node
};
TabContent.defaultProps = {
  selected: false
};
var TabContent$1 = TabContent;

var _excluded$8 = ["ariaLabel", "disableAnimation", "inline", "className", "customTabContent", "triggerHref", "role", "onSelectionChange"];
var prefix$9 = settings$1.prefix;
/** Tabs allow users to navigate easily between views within the same context */

var Tabs = /*#__PURE__*/function (_React$Component) {
  _inherits(Tabs, _React$Component);

  var _super = _createSuper(Tabs);

  function Tabs(props) {
    var _this;

    _classCallCheck(this, Tabs);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "getTabAt", function (index) {
      return _this["tab".concat(index)] || React.Children.toArray(_this.props.children)[index];
    });

    _defineProperty(_assertThisInitialized(_this), "getSizes", function () {
      if (_this.rootRef.current === null || _this.rootRef.current.length > 1) {
        return null;
      }

      var rootBounds = _this.rootRef.current.getBoundingClientRect();

      var sizes = {};
      Object.values(_this.rootRef.current.children).forEach(function (el, key) {
        var bounds = el.children[0].getBoundingClientRect();
        var left = bounds.left - rootBounds.left;
        var right = rootBounds.right - bounds.right;
        sizes[key] = {
          left: left,
          right: right
        };
      });

      _this.setState({
        sizes: sizes
      });

      return sizes;
    });

    _defineProperty(_assertThisInitialized(_this), "setTabAt", function (index, tabRef) {
      _this["tab".concat(index)] = tabRef;
    });

    _defineProperty(_assertThisInitialized(_this), "handleTabClick", function (onSelectionChange) {
      return function (index, label, evt) {
        if (evt) {
          evt.preventDefault();
        }

        _this.selectTabAt(index, onSelectionChange);
      };
    });

    _defineProperty(_assertThisInitialized(_this), "handleTabKeyDown", function (onSelectionChange) {
      return function (index, label, evt) {
        var key = evt.key || evt.which;

        if (key === 'Enter' || key === 13 || key === ' ' || key === 32) {
          _this.selectTabAt(index, onSelectionChange);
        }
      };
    });

    _defineProperty(_assertThisInitialized(_this), "handleTabAnchorFocus", function (onSelectionChange) {
      return function (index) {
        var tabCount = React.Children.count(_this.props.children) - 1;
        var tabIndex = index;

        if (index < 0) {
          tabIndex = tabCount;
        } else if (index > tabCount) {
          tabIndex = 0;
        }

        var tab = _this.getTabAt(tabIndex);

        if (tab) {
          _this.selectTabAt(tabIndex, onSelectionChange);

          if (tab.tabAnchor) {
            tab.tabAnchor.focus();
          }
        }
      };
    });

    _defineProperty(_assertThisInitialized(_this), "selectTabAt", function (index, onSelectionChange) {
      if (_this.state.selected !== index) {
        _this.setState({
          selected: index
        });

        if (typeof onSelectionChange === 'function') {
          onSelectionChange(index);
        }
      }
    });

    _this.state = {}; // Create the ref

    _this.rootRef = /*#__PURE__*/React.createRef();
    return _this;
  }

  _createClass(Tabs, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.getSizes();
      window.addEventListener('resize', this.getSizes);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.getSizes);
    }
  }, {
    key: "getTabs",
    value: function getTabs() {
      return React.Children.map(this.props.children, function (tab) {
        return tab;
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props;
          _this$props.ariaLabel;
          var disableAnimation = _this$props.disableAnimation,
          inline = _this$props.inline,
          className = _this$props.className,
          customTabContent = _this$props.customTabContent;
          _this$props.triggerHref;
          var role = _this$props.role,
          onSelectionChange = _this$props.onSelectionChange,
          other = _objectWithoutProperties(_this$props, _excluded$8);

      var _this$state = this.state,
          selected = _this$state.selected,
          sizes = _this$state.sizes;
      var tabsWithProps = this.getTabs().map(function (tab, index) {
        var newTab = /*#__PURE__*/React.cloneElement(tab, {
          index: index,
          selected: index === selected,
          handleTabClick: _this2.handleTabClick(onSelectionChange),
          handleTabAnchorFocus: _this2.handleTabAnchorFocus(onSelectionChange),
          ref: function ref(e) {
            _this2.setTabAt(index, e);
          },
          handleTabKeyDown: _this2.handleTabKeyDown(onSelectionChange)
        });
        return newTab;
      });
      var tabContentWithProps = !customTabContent ? React.Children.map(tabsWithProps, function (tab) {
        var _tab$props = tab.props,
            children = _tab$props.children,
            selected = _tab$props.selected;

        if (!children) {
          return null;
        }

        return /*#__PURE__*/React.createElement(TabContent$1, {
          className: "".concat(prefix$9, "--tab-content"),
          "aria-hidden": !selected,
          hidden: !selected,
          selected: selected
        }, children);
      }) : null;
      var classes = {
        tabs: classnames$1("".concat(prefix$9, "--tabs"), _defineProperty({}, "".concat(prefix$9, "--tabs--no-animation"), disableAnimation), className),
        tablist: classnames$1("".concat(prefix$9, "--tabs__nav"), _defineProperty({}, "".concat(prefix$9, "--tabs__nav--inline"), inline))
      };
      var sizeBar = sizes ? sizes[selected] : undefined;
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("nav", _extends({}, other, {
        className: classes.tabs,
        role: role
      }), /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefix$9, "--tabs__nav__bar"),
        style: sizeBar
      }), /*#__PURE__*/React.createElement("ul", {
        ref: this.rootRef,
        role: "tablist",
        className: classes.tablist
      }, tabsWithProps)), tabContentWithProps);
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(_ref, state) {
      var selected = _ref.selected;
      var prevSelected = state.prevSelected;
      return prevSelected === selected ? null : {
        selected: selected,
        prevSelected: selected
      };
    }
  }]);

  return Tabs;
}(React.Component);

_defineProperty(Tabs, "propTypes", {
  /**
   * Specify the text to be read by screen-readers when visiting the <Tabs>
   * component
   */
  ariaLabel: PropTypes.string,

  /**
   * Pass in a collection of <Tab> children to be rendered depending on the
   * currently selected tab
   */
  children: PropTypes.node,

  /**
   * Provide a className that is applied to the root <nav> component for the
   * <Tabs>
   */
  className: PropTypes.string,

  /**
   * Provide a customTabContent by using independent action triggers
   * inside the Tabs
   */
  customTabContent: PropTypes.bool,

  /**
   * Specify whether the animation should be used
   */
  disableAnimation: PropTypes.bool,

  /**
   * Specify whether the Tabs are displayed inline
   */
  inline: PropTypes.bool,

  /**
   * Specify whether the Tab content is hidden
   */
  hidden: PropTypes.bool,

  /**
   * By default, this value is "navigation". You can also provide an alternate
   * role if it makes sense from the accessibility-side
   */
  role: PropTypes.string.isRequired,

  /**
   * Optionally provide an `onClick` handler that is invoked when a <Tab> is
   * clicked
   */
  onClick: PropTypes.func,

  /**
   * Optionally provide an `onKeyDown` handler that is invoked when keyed
   * navigation is triggered
   */
  onKeyDown: PropTypes.func,

  /**
   * Provide an optional handler that is called whenever the selection
   * changes. This method is called with the index of the tab that was
   * selected
   */
  onSelectionChange: PropTypes.func,

  /**
   * Provide a string that represents the `href` for the triggered <Tab>
   */
  triggerHref: PropTypes.string.isRequired,

  /**
   * Optionally provide an index for the currently selected <Tab>
   */
  selected: PropTypes.number
});

_defineProperty(Tabs, "defaultProps", {
  role: 'navigation',
  triggerHref: '#',
  selected: 0,
  ariaLabel: 'listbox'
});

var Tabs$1 = Tabs;

var _excluded$7 = ["children", "className", "type"];
var prefix$8 = settings$1.prefix;
var TYPES = {
  info: 'Info',
  error: 'error',
  success: 'Success',
  warning: 'Warning',
  custom: 'Custom'
};
/** Tag is used to label, categorize, or organize items using keywords that describe them. */

var Tag = function Tag(_ref) {
  var children = _ref.children,
      className = _ref.className,
      type = _ref.type,
      other = _objectWithoutProperties(_ref, _excluded$7);

  var tagClass = "".concat(prefix$8, "--tag--").concat(type);
  var tagClasses = classnames$1("".concat(prefix$8, "--tag"), tagClass, className);
  return /*#__PURE__*/React.createElement("span", _extends({
    className: tagClasses
  }, other), children || TYPES[type]);
};

Tag.propTypes = {
  /**
   * Provide content to be rendered inside of a <Tag>
   */
  children: PropTypes.node,

  /**
   * Provide a custom className that is applied to the containing <span>
   */
  className: PropTypes.string,

  /**
   * Specify the type of the <Tag>
   */
  type: PropTypes.oneOf(Object.keys(TYPES)).isRequired,

  /**
   * Wrap the line if too long.
   */
  wrap: PropTypes.bool
};
Tag.defaultProps = {
  type: 'info'
};
var Tag$1 = Tag;

var prefix$7 = settings$1.prefix;
var textLookup = {
  h1: 'h1',
  h2: 'h2',
  h3: 'h3',
  h4: 'h4',
  h5: 'h5',
  h6: 'h6',
  title: 'h1',
  subtitle: 'h3',
  p: 'p',
  caption: 'div'
};
/**
 *Text is a component for displaying paragraphs. You can use Text to standardize text across your web app. For longer sections or full articles use the <Story /> component instead.
 */

var Text = function Text(_ref) {
  var _classnames;

  var children = _ref.children,
      className = _ref.className,
      kind = _ref.kind,
      spacingTop = _ref.spacingTop,
      spacingBottom = _ref.spacingBottom;
  var tagName = {
    name: textLookup[kind] ? textLookup[kind] : 'div'
  };
  var classNames = classnames$1((_classnames = {}, _defineProperty(_classnames, "".concat(prefix$7, "--text"), true), _defineProperty(_classnames, "".concat(prefix$7, "--text__").concat(kind), kind), _defineProperty(_classnames, "".concat(prefix$7, "--text__spacing-top-").concat(spacingTop), spacingTop), _defineProperty(_classnames, "".concat(prefix$7, "--text__spacing-bottom-").concat(spacingBottom), spacingBottom), _defineProperty(_classnames, "".concat(className), className), _classnames));
  return /*#__PURE__*/React.createElement(tagName.name, {
    className: classNames
  }, children);
};

Text.propTypes = {
  /**
    The Text content
  */
  children: PropTypes.node,

  /**
    Additional className for Story
  */
  className: PropTypes.string,

  /**
    Additional className for Story
  */
  kind: PropTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'title', 'subtitle', 'p', 'i', 'bold', 'strong', 'sup', 'a', 'code', 'inline-highlight', 'caption']),

  /**
    Override spacing on top
  */
  spacingTop: PropTypes.oneOf(['3xs', '2xs', 'xs', 'md', 'lg', 'xl', '2xl', '3xl', '4xl']),

  /**
  Override spacing on bottom
  */
  spacingBottom: PropTypes.oneOf(['3xs', '2xs', 'xs', 'md', 'lg', 'xl', '2xl', '3xl', '4xl'])
};
var Text$1 = Text;

var _excluded$6 = ["className", "formItemClassName", "id", "labelText", "hideLabel", "onChange", "onClick", "invalid", "invalidText", "inputRef", "helperText", "fullWidth", "viewOnly"];
var prefix$6 = settings$1.prefix;
/** A textarea is an input dedicated for a large volume of text. It may be used in a variety of components like forms, comment sections, and forums. */

var TextArea = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var _classNames2;

  var className = props.className,
      formItemClassName = props.formItemClassName,
      id = props.id,
      labelText = props.labelText,
      hideLabel = props.hideLabel,
      _onChange = props.onChange,
      _onClick = props.onClick,
      invalid = props.invalid,
      invalidText = props.invalidText,
      _props$inputRef = props.inputRef,
      inputRef = _props$inputRef === void 0 ? ref : _props$inputRef,
      helperText = props.helperText,
      fullWidth = props.fullWidth;
      props.viewOnly;
      var other = _objectWithoutProperties(props, _excluded$6);

  var textareaProps = {
    id: id,
    onChange: function onChange(evt) {
      if (!other.disabled) {
        _onChange(evt);
      }
    },
    onClick: function onClick(evt) {
      if (!other.disabled) {
        _onClick(evt);
      }
    }
  };
  var textareaClasses = classnames$1("".concat(prefix$6, "--text-area"), className, _defineProperty({}, "".concat(prefix$6, "--textarea-fullwidth"), fullWidth));
  var labelClasses = classnames$1("".concat(prefix$6, "--label"), (_classNames2 = {}, _defineProperty(_classNames2, "".concat(prefix$6, "--visually-hidden"), hideLabel), _defineProperty(_classNames2, "".concat(prefix$6, "--label--disabled"), other.disabled), _classNames2));
  var label = labelText ? /*#__PURE__*/React.createElement("label", {
    htmlFor: id,
    className: labelClasses
  }, labelText) : null;
  var helperTextClasses = classnames$1("".concat(prefix$6, "--form__helper-text"), _defineProperty({}, "".concat(prefix$6, "--form__helper-text--disabled"), other.disabled));
  var error = invalid ? /*#__PURE__*/React.createElement("div", {
    className: "wfp--form-requirement"
  }, invalidText) : null;
  var input = invalid ? /*#__PURE__*/React.createElement("textarea", _extends({}, other, textareaProps, {
    ref: inputRef,
    className: textareaClasses,
    "data-invalid": true
  })) : /*#__PURE__*/React.createElement("textarea", _extends({}, other, {
    ref: inputRef
  }, textareaProps, {
    className: textareaClasses
  }));
  var helper = helperText ? /*#__PURE__*/React.createElement("div", {
    className: helperTextClasses
  }, helperText) : null;
  return /*#__PURE__*/React.createElement(FormItem$1, {
    className: formItemClassName
  }, label, input, helper, error);
});
TextArea.propTypes = {
  /**
   * Provide a custom className that is applied directly to the underlying
   * &lt;textarea&gt; node
   */
  className: PropTypes.string,
  // /**
  //  * Specify the `cols` attribute for the underlying &lt;textarea&gt; node
  //  */
  // cols: PropTypes.number,

  /**
   * Optionally provide the default value of the &lt;textarea&gt;
   */
  defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  /**
   * Specify whether the control is disabled
   */
  disabled: PropTypes.bool,

  /**
   * Provide a unique identifier for the control
   */
  id: PropTypes.string,

  /**
   * Provide the text that will be read by a screen reader when visiting this
   * control
   */
  labelText: PropTypes.node.isRequired,

  /**
   * Optionally provide an `onChange` handler that is called whenever &lt;textarea&gt;
   * is updated
   */
  onChange: PropTypes.func,

  /**
   * Optionally provide an `onClick` handler that is called whenever the
   * &lt;textarea&gt; is clicked
   */
  onClick: PropTypes.func,

  /**
   * Specify the placeholder attribute for the &lt;textarea&gt;
   */
  placeholder: PropTypes.string,

  /**
   * Specify the rows attribute for the &lt;textarea&gt;
   */
  rows: PropTypes.number,

  /**
   * Provide the current value of the &lt;textarea&gt;
   */
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  /**
   * Specify whether the control is currently invalid.
   * Either a boolean in combination with `invalidText` or an `object`( eg. { message: "Message", …otherErrorProperties }) can be passed.
   */
  invalid: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),

  /**
   * Provide the text that is displayed when the control is in an invalid state
   */
  invalidText: PropTypes.string,

  /**
   * Provide text that is used alongside the control label for additional help
   */
  helperText: PropTypes.node,

  /**
   * Specify whether you want the underlying label to be visually hidden
   */
  hideLabel: PropTypes.bool,

  /**
   * Specify whether you want `textarea` width to be 100%, this will overide cols set
   */
  fullWidth: PropTypes.bool,

  /**
   * Specify whether you want `textarea` is view only
   */
  viewOnly: PropTypes.bool
};
TextArea.defaultProps = {
  disabled: false,
  onChange: function onChange() {},
  onClick: function onClick() {},
  placeholder: '',
  rows: 4,
  invalid: false,
  invalidText: '',
  helperText: '',
  fullWidth: true
};
var TextArea$1 = TextArea;

var _excluded$5 = ["className", "defaultToggled", "toggled", "onChange", "onToggle", "id", "name", "labelA", "labelB"];
var prefix$5 = settings$1.prefix;
/** A toggle is used to quickly switch between two possible states. They are commonly used for “on/off” switches */

var Toggle = function Toggle(_ref) {
  var _classNames;

  var className = _ref.className,
      defaultToggled = _ref.defaultToggled,
      toggled = _ref.toggled,
      _onChange = _ref.onChange,
      onToggle = _ref.onToggle,
      id = _ref.id,
      name = _ref.name,
      labelA = _ref.labelA,
      labelB = _ref.labelB,
      other = _objectWithoutProperties(_ref, _excluded$5);

  var input;
  var wrapperClasses = classnames$1((_classNames = {}, _defineProperty(_classNames, "".concat(prefix$5, "--form-item"), true), _defineProperty(_classNames, className, className), _classNames));
  var checkedProps = {};

  if (typeof toggled !== 'undefined') {
    checkedProps.checked = toggled;
  } else {
    checkedProps.defaultChecked = defaultToggled;
  }

  var htmlFor = id ? id : name;
  return /*#__PURE__*/React.createElement("div", {
    className: wrapperClasses
  }, /*#__PURE__*/React.createElement("input", _extends({}, other, checkedProps, {
    type: "checkbox",
    id: htmlFor,
    className: "".concat(prefix$5, "--toggle"),
    onChange: function onChange(evt) {
      _onChange && _onChange(evt);
      onToggle(input.checked, htmlFor, evt);
    },
    ref: function ref(el) {
      input = el;
    }
  })), /*#__PURE__*/React.createElement("label", {
    className: "".concat(prefix$5, "--toggle__label"),
    htmlFor: htmlFor
  }, /*#__PURE__*/React.createElement("span", {
    className: "".concat(prefix$5, "--toggle__text--left")
  }, labelA), /*#__PURE__*/React.createElement("span", {
    className: "".concat(prefix$5, "--toggle__appearance")
  }), /*#__PURE__*/React.createElement("span", {
    className: "".concat(prefix$5, "--toggle__text--right")
  }, labelB)));
};

Toggle.propTypes = {
  /**
   * Specify a custom className to apply to the form-item node
   */
  className: PropTypes.string,

  /**
   * Specify whether the toggle should be on by default
   */
  defaultToggled: PropTypes.bool,

  /**
   * Provide an optional hook that is called when the control is toggled
   */
  onToggle: PropTypes.func,

  /**
   * Provide an id that unique represents the underlying `input`
   */
  id: PropTypes.string,

  /**
   * Provide an name that unique represents the underlying `input`
   */
  name: PropTypes.string.isRequired,

  /**
   * Specify whether the control is toggled
   */
  toggled: PropTypes.bool,

  /**
   * Specify the label for the "off" position
   */
  labelA: PropTypes.string.isRequired,

  /**
   * Specify the label for the "on" position
   */
  labelB: PropTypes.string.isRequired
};
Toggle.defaultProps = {
  defaultToggled: false,
  labelA: 'Off',
  labelB: 'On',
  name: 'toggle',
  onToggle: function onToggle() {}
};
var Toggle$1 = Toggle;

var _excluded$4 = ["alt", "className", "children", "description", "ellipsis", "extendedDescription", "image", "showName", "small", "missingImage", "name"];
var prefix$4 = settings$1.prefix;
/** The User is used inside the MainNavigation and form, and can display an avatar and username. */

var User = function User(_ref) {
  var _classNames, _classNames2;

  var alt = _ref.alt,
      className = _ref.className,
      children = _ref.children,
      description = _ref.description,
      ellipsis = _ref.ellipsis,
      extendedDescription = _ref.extendedDescription,
      image = _ref.image,
      showName = _ref.showName,
      small = _ref.small,
      missingImage = _ref.missingImage,
      name = _ref.name,
      other = _objectWithoutProperties(_ref, _excluded$4);

  var avatar;

  if (!image && missingImage === 'avatar') {
    avatar = /*#__PURE__*/React.createElement(Icon$1, _extends({
      icon: iconUser,
      fill: "#ffffff",
      width: "14",
      height: "14",
      description: alt,
      className: "".concat(prefix$4, "--user__icon ").concat(prefix$4, "--user__icon--empty")
    }, other));
  } else if (image === undefined && missingImage === 'letter') {
    avatar = /*#__PURE__*/React.createElement("svg", {
      id: "Layer_1",
      className: "".concat(prefix$4, "--user__icon ").concat(prefix$4, "--user__icon--empty ").concat(prefix$4, "--user__icon--letter"),
      x: "0px",
      y: "0px",
      viewBox: "0 0 25 25",
      height: "25px",
      width: "25px"
    }, /*#__PURE__*/React.createElement("text", {
      x: "50%",
      y: "57%",
      dominantBaseline: "middle",
      textAnchor: "middle"
    }, name && name.toUpperCase()[0]));
  } else {
    avatar = /*#__PURE__*/React.createElement("div", {
      className: "".concat(prefix$4, "--user__icon")
    }, /*#__PURE__*/React.createElement("img", {
      alt: alt,
      src: image
    }));
  }

  var classes = classnames$1("".concat(prefix$4, "--user"), className, (_classNames = {}, _defineProperty(_classNames, "".concat(prefix$4, "--user--has-description"), description), _defineProperty(_classNames, "".concat(prefix$4, "--user--has-extended-description"), extendedDescription), _classNames));
  var titleClasses = classnames$1((_classNames2 = {}, _defineProperty(_classNames2, "".concat(prefix$4, "--user__title"), true), _defineProperty(_classNames2, "".concat(prefix$4, "--user__title--ellipsis"), ellipsis), _defineProperty(_classNames2, "".concat(prefix$4, "--user__title--small"), small), _classNames2));
  return /*#__PURE__*/React.createElement("div", _extends({
    className: classes
  }, other), avatar, showName && /*#__PURE__*/React.createElement("span", {
    className: titleClasses
  }, /*#__PURE__*/React.createElement("span", null, name), description && /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefix$4, "--user__description")
  }, description)), children, extendedDescription && /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefix$4, "--user__extended-description")
  }, extendedDescription));
};

User.propTypes = {
  /**
   * The alt-text of the avatar
   */
  alt: PropTypes.string,

  /**
   * Sets the max-width of the user name to 130px and shows an ellipsis
   */
  ellipsis: PropTypes.bool,

  /**
   * Provide a custom className that is applied directly to the underlying
   * &lt;textarea&gt; node
   */
  className: PropTypes.string,

  /**
   * Additional description under the Name will also increase the size
   * of the Avatar use &lt;List kind="simple" small /&gt; as default content
   */
  description: PropTypes.node,

  /**
   * Selects the generated empty icon if no image is provided.
   * Can be `avatar` or `letter`.
   */
  missingImage: PropTypes.oneOf(['avatar', 'letter']),

  /**
   * Extended Description column
   */
  extendedDescription: PropTypes.node,

  /**
   * Url to an avatar image The size of the image is 25px * 25px.
   * Provide at least 50px * 50px to support HiDPI displays.
   */
  image: PropTypes.string,

  /**
   * Show the name next to the avatar
   */
  showName: PropTypes.bool,

  /**
   * The username which will be displayed. Usually `Firstname Lastname`.
   */
  name: PropTypes.string
};
User.defaultProps = {
  alt: 'User Icon',
  missingImage: 'avatar',
  ellipsis: false,
  showName: true
};
var User$1 = User;

var scaleLookup = {
  thousand: {
    pow: 1000,
    defaultmaximumFractionDigits: 2,
    default: {
      after: 'T'
    }
  },
  million: {
    pow: 1000000,
    defaultmaximumFractionDigits: 1,
    default: {
      after: 'M'
    }
  },
  billion: {
    pow: 1000000000,
    defaultmaximumFractionDigits: 2,
    default: {
      after: 'B'
    }
  }
};
var scaleLookup$1 = scaleLookup;

var Invalid = function Invalid(props) {
  return /*#__PURE__*/React.createElement("span", {
    className: props.className + ' invalid'
  }, "\u2013");
}; // For invalid Values

var InvalidSvg = function InvalidSvg(props) {
  return /*#__PURE__*/React.createElement("tspan", {
    className: props.className + ' invalid'
  }, "\u2013");
};

var StringUnit = function StringUnit(value) {
  if (value) {
    var before = value.before ? value.before + ' ' : '';
    var afterOutput = value.output && value.output.default ? value.output.default.after + '' : '';
    var after = value.after ? ' ' + value.after : '';
    return before + value.value + afterOutput + after;
  } else return '';
};

var StringUnit$1 = StringUnit;

var _excluded$3 = ["style"];

var SvgUnit = function SvgUnit(value, props) {
  var style = props.style,
      other = _objectWithoutProperties(props, _excluded$3);

  if (value) return /*#__PURE__*/React.createElement("text", _extends({
    className: props.className
  }, other), /*#__PURE__*/React.createElement("tspan", {
    style: style
  }, value.before, " "), /*#__PURE__*/React.createElement("tspan", {
    style: style
  }, value.value), /*#__PURE__*/React.createElement("tspan", {
    style: style
  }, ' ', value.output ? value.output.default.after + '' : '', value.after));else return /*#__PURE__*/React.createElement(InvalidSvg, {
    className: props.className
  });
};

var SvgUnit$1 = SvgUnit;

var currencyCalc = function currencyCalc(props, after, before, afterSingular, isAbsolute) {
  var children = props.children,
      input = props.input,
      output = props.output,
      minimumFractionDigits = props.minimumFractionDigits,
      maximumFractionDigits = props.maximumFractionDigits,
      _props$localeStringLa = props.localeStringLanguage,
      localeStringLanguage = _props$localeStringLa === void 0 ? 'en-EN' : _props$localeStringLa,
      calcOnly = props.calcOnly,
      string = props.string,
      svg = props.svg,
      hideZero = props.hideZero; // Remove commas

  var value = typeof children === 'string' ? children.replace(/,/g, '') : children; // Parse as float

  value = parseFloat(value); // Input

  value = value !== 0 && input && scaleLookup$1[input] ? scaleLookup$1[input].pow * value : value; // output

  var outputCalc = output && scaleLookup$1[output] ? scaleLookup$1[output] : undefined;
  value = value !== 0 && output ? value / outputCalc.pow : value;
  var minimumFractionDigitsCalculated = isAbsolute === true && output === undefined ? minimumFractionDigits === 0 :
  /*: maximumFractionDigits === 0
  ? 0*/
  typeof minimumFractionDigits === 'number' ? minimumFractionDigits : outputCalc && outputCalc.defaultmaximumFractionDigits ? outputCalc.defaultmaximumFractionDigits : 2;
  var maximumFractionDigitsCalculated = isAbsolute === true && output === undefined ? maximumFractionDigits === 0 : value <= 0.005 ? 4 : value <= 0.05 ? 3 : value <= 0.5 ? 2 : maximumFractionDigits === 0 ? 0 : typeof maximumFractionDigits === 'number' ? maximumFractionDigits : outputCalc && outputCalc.defaultmaximumFractionDigits ? outputCalc.defaultmaximumFractionDigits : 2;
  var toLocalStringConfig = {
    //maximumSignificantDigits: maximumSignificantDigits,
    minimumFractionDigits: minimumFractionDigitsCalculated,
    maximumFractionDigits: maximumFractionDigitsCalculated > minimumFractionDigitsCalculated ? maximumFractionDigitsCalculated : minimumFractionDigitsCalculated
  }; // Convert to Locale String

  value = value.toLocaleString(localeStringLanguage, toLocalStringConfig);
  var calcObject = {
    value: value,
    before: before,
    after: after,
    output: outputCalc
  };
  var className = props.className;

  if (value === '1' && afterSingular) {
    className = className + ' wfp--unit--singular';
  }

  if ((!value || value === 'NaN' || parseFloat(value) === 0) && hideZero) return false;else if (calcOnly) return calcObject;else if (svg) return SvgUnit$1(calcObject, props);else if (string) return StringUnit$1(calcObject, props);else if (value !== false) return /*#__PURE__*/React.createElement("span", {
    className: className
  }, value);else return /*#__PURE__*/React.createElement(Invalid, {
    className: props.className
  });
};
var currencyCalc$1 = currencyCalc;

var percentageCalc = function percentageCalc(props, after, before) {
  var calcOnly = props.calcOnly,
      children = props.children,
      from = props.from,
      string = props.string,
      svg = props.svg,
      hideZero = props.hideZero,
      maximumSignificantDigits = props.maximumSignificantDigits,
      maximumFractionDigits = props.maximumFractionDigits; // Remove commas

  var value = typeof children === 'string' ? children.replace(/,/g, '') : children; // Parse as float

  value = parseFloat(value);

  if (parseFloat(from) === 0) {
    value = false;
  } else if (from) {
    value = value / parseFloat(from) * 100;
  } // Convert to Locale String


  value = value.toLocaleString('en-EN', {
    minimumFractionDigits: maximumSignificantDigits ? maximumSignificantDigits : 0,
    maximumSignificantDigits: maximumSignificantDigits,
    maximumFractionDigits: value <= 0.5 ? 5 : maximumFractionDigits ? maximumFractionDigits : 1
  });
  var calcObject = {
    value: value,
    before: before,
    after: after,
    output: undefined
  };
  if ((!value || value === 'NaN' || parseFloat(value) === 0) && hideZero) return false;else if (calcOnly) return calcObject;else if (svg) return SvgUnit$1(calcObject, props);else if (string) return StringUnit$1(calcObject, props);else if (value !== false) return /*#__PURE__*/React.createElement("span", {
    className: props.className
  }, value);else return /*#__PURE__*/React.createElement(Invalid, {
    className: props.className
  });
};
var percentageCalc$1 = percentageCalc;

var SimpleCalc = function SimpleCalc(props, after, before) {
  var calcOnly = props.calcOnly,
      className = props.className,
      children = props.children,
      string = props.string,
      svg = props.svg,
      hideUnit = props.hideUnit; // Remove commas

  var value = children;
  var afterCalc = after ? after : '';
  var unit = hideUnit ? '' : before + children + afterCalc;
  var calcObject = {
    value: value,
    before: before,
    after: after,
    output: value + unit
  };
  if (calcOnly) return calcObject;else if (svg) return SvgUnit$1({
    value: value + unit,
    before: before,
    after: after
  }, props);else if (string) return StringUnit$1(calcObject, props);else if (value !== false) return /*#__PURE__*/React.createElement("span", {
    className: className
  }, value);
};

var SimpleCalc$1 = SimpleCalc;

var YearMonthGen = function YearMonthGen(props) {
  var children = props.children;
  var value = children;
  var newDate;
  /* Generate Date from Date */

  if (typeof value === 'number' && value.length >= 7) {
    newDate = new Date(value, props);
  } else if (value.getMonth) {
    /* Use Date Object */
    newDate = value;
  } else {
    /* Generate Date from String YYYYMM */
    var year = value.toString().substring(0, 4);
    var month = parseInt(value.toString().substring(4, 7), 10) - 1;
    newDate = new Date(year, month, 1);
  }

  var monthName = newDate.toLocaleString('en-us', {
    month: 'short'
  });
  var monthNameFull = newDate.toLocaleString('en-us', {
    month: 'long'
  });
  return {
    monthName: monthName,
    monthNameFull: monthNameFull,
    year: newDate.getFullYear(),
    date: newDate
  };
};
/*const MonthYearCalcDate = ( value, showZero, showUnit ) => {
  const year = value.toString().substring(0, 4);
  const month = parseInt(value.toString().substring(4, 7), 10) - 1;
  const newDate = new Date(year, month, 1);
  return newDate
}*/
// Format YYYYMM / from 201709  => Sep 2017


var YearMonthCalc = function YearMonthCalc(props) {
  var className = props.className,
      string = props.string,
      svg = props.svg,
      calcOnly = props.calcOnly;
  var YearMonthgenerated = YearMonthGen(props);
  var calcObject = {
    value: YearMonthgenerated.monthName + ' ' + YearMonthgenerated.year,
    before: '',
    after: '',
    output: undefined
  };
  if (calcOnly) return calcObject;else if (svg) return SvgUnit$1(calcObject, props);else if (string) return StringUnit$1(calcObject, props);else if (calcObject !== false) return /*#__PURE__*/React.createElement("span", {
    className: className
  }, calcObject.value);
};
var YearMonthCalc$1 = YearMonthCalc;

var Usd = function Usd(props) {
  return currencyCalc$1(props, '', 'US$');
}; // Generate People

var People = function People(props) {
  return currencyCalc$1(props, 'People', undefined, true, true);
}; // Generate Partners

var Partners = function Partners(props) {
  return currencyCalc$1(props, 'Partners', undefined, true, true);
}; // Generate MT

var Mt = function Mt(props) {
  return currencyCalc$1(props, 'MT', undefined, true);
}; // Generate MetricTons

var MetricTons = function MetricTons(props) {
  return currencyCalc$1(props, 'MetricTons', undefined, true);
}; // Generate Months

var Months = function Months(props) {
  return currencyCalc$1(props, 'Months', undefined, true, 'Month');
}; // Generate Num

var Num = function Num(props) {
  return currencyCalc$1(props, '');
}; // Generate Beneficiaries

var Beneficiaries = function Beneficiaries(props) {
  return currencyCalc$1(props, 'Beneficaries', undefined, true, true);
}; // Generate Households

var Households = function Households(props) {
  return currencyCalc$1(props, 'Households', undefined, true, true);
}; // Generate Trips

var Trips = function Trips(props) {
  return currencyCalc$1(props, 'Trips', undefined, true, true);
}; // Generate kg

var Kg = function Kg(props) {
  return SimpleCalc$1(props, 'kg');
}; // Generate Households

var Level = function Level(props) {
  return SimpleCalc$1(props, '');
}; // Generate Countries

var Countries = function Countries(props) {
  return SimpleCalc$1(props, 'Countries');
}; // Generate None

var None = function None(props) {
  return SimpleCalc$1(props, '');
}; // Generate Percentage

var Percentage = function Percentage(props) {
  return percentageCalc$1(props, '%');
}; // Generate YearMonth

var YearMonth = function YearMonth(props) {
  return YearMonthCalc$1(props);
};

var prefix$3 = settings$1.prefix; // All Unit Components together in <Unit type="Unitname" />

var components = {
  Usd: Usd,
  Partners: Partners,
  Beneficiaries: Beneficiaries,
  Households: Households,
  Months: Months,
  Mt: Mt,
  Kg: Kg,
  MetricTons: MetricTons,
  Num: Num,
  Level: Level,
  None: None,
  Trips: Trips,
  Countries: Countries,
  People: People,
  Percentage: Percentage,
  YearMonth: YearMonth
};
/** The Unit component method returns a component with a language and unit sensitive representation of this number based on [Numbers and Unit from the Editorial Guidelines](https://cdn.wfp.org/guides/editorial/content/numbers-and-units/) the [Numbers and Units Reference on developer.mozilla.org](http://cdn.wfp.org/guides/editorial/content/numbers-and-units). */

var Unit = function Unit(props) {
  var className = props.className,
      output = props.output,
      string = props.string,
      textAnchor = props.textAnchor,
      setup = props.setup;
  var type = props.type ? props.type.charAt(0).toUpperCase() + props.type.slice(1) : 'None';
  var Unit = components[type]; //const unitHideClass = setup && setup.hideUnit ? 'wfp--unit--hide' : '';

  var textAnchorCalc = textAnchor ? textAnchor : 'start';
  var unitClassName = type ? "".concat(prefix$3, "--unit--").concat(type.toLowerCase()) : '';
  var outputClassName = output && scaleLookup$1[output] ? "".concat(prefix$3, "--unit--").concat(output) : '';
  var setupClassName = setup ? "".concat(prefix$3, "--unit--").concat(setup) : '';
  var classNameCalc = "".concat(prefix$3, "--unit ").concat(className, " ").concat(unitClassName, " ").concat(outputClassName, " ").concat(setupClassName);

  if (string) {
    return Unit(props);
  }

  if (Unit === undefined) {
    //  console.warn(`The unit "${type}" is undefined`);
    return null;
  }

  return /*#__PURE__*/React.createElement(Unit, _extends({}, props, {
    className: classNameCalc,
    textAnchor: textAnchorCalc
  }));
};

Unit.propTypes = {
  /**
    The value which should be displayed
  */
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  /**
    Only used for type Percentage will divide value/from string, float
  */
  from: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  /**
    Hide the Unit if it's value is zero.
  */
  hideEmpty: PropTypes.bool,

  /**
    The minimum number of fraction digits to use. Possible values are from 0 to 20. Only used on numeric types 
  */
  minimumFractionDigits: PropTypes.number,

  /**
    A value between 1-21, The maximum number of significant digits to use. Possible values are from 1 to 21; the default is minimumSignificantDigits.
  */
  maximumSignificantDigits: PropTypes.number,

  /**
    A value between 1-21, The minimum number of fraction digits to use. Possible values are from 0 to 20. Only used on numeric types 
  */
  maximumFractionDigits: PropTypes.number,

  /**
   * A string with a BCP 47 language code, or an array of language codes. For the general form and interpretation of the locale argument see the [toLocaleString on developer.mozilla.org](https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Global_Objects/Date/toLocaleString) page.
   */
  locale: PropTypes.string,

  /**
    Render output as svg text 
  */
  svg: PropTypes.bool,

  /**
    The unit type  */
  type: PropTypes.oneOf(['none', 'usd', 'partners', 'beneficiaries', 'households', 'months', 'mt', 'metricTons', 'kg', 'num', 'yearMonth', 'level', 'people', 'countries', 'percentage'])
};
Unit.defaultProps = {
  type: 'none',
  svg: false,
  localeStringLanguage: 'en-EN'
};
var Unit$1 = Unit;

var _excluded$2 = ["value", "secondaryValue", "className", "href", "title"];
var prefix$2 = settings$1.prefix;
/** Value are typically used to show KPI values and additional information. */

var Value = function Value(_ref) {
  var value = _ref.value,
      secondaryValue = _ref.secondaryValue,
      className = _ref.className;
      _ref.href;
      var title = _ref.title,
      other = _objectWithoutProperties(_ref, _excluded$2);

  var classNames = classnames$1("".concat(prefix$2, "--value"), className);
  return /*#__PURE__*/React.createElement("div", _extends({
    className: classNames
  }, other), /*#__PURE__*/React.createElement("h4", {
    className: "".concat(prefix$2, "--value__title")
  }, title), /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefix$2, "--value__primary-value")
  }, value), /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefix$2, "--value__secondary-value")
  }, secondaryValue));
};

Value.propTypes = {
  /**
   * Provide the content for the primary Value
   */
  value: PropTypes.node,

  /**
   * Provide the content for the secondary Value
   */
  secondaryValue: PropTypes.node,

  /**
   * Provide the content for the title
   */
  title: PropTypes.node,

  /**
   * Provide a custom className to be applied to the containing <a> node
   */
  className: PropTypes.string
};
var Value$1 = Value;

var colors = {
  main: {
    name: 'main',
    hex: '#007DBC',
    // previously 0A6EB4
    scss: '$color__main',
    type: 'communications'
  },
  'sequential-default-07': {
    name: 'sequential-default-07',
    hex: '#9DEAFF',
    scss: '$color__sequential-default-07',
    type: 'sequential-default',
    shortDescription: 'sequential default 07'
  },
  'sequential-default-06': {
    name: 'sequential-default-06',
    hex: '#73C3FE',
    scss: '$color__sequential-default-06',
    type: 'sequential-default',
    shortDescription: 'sequential default 06'
  },
  'sequential-default-05': {
    name: 'sequential-default-05',
    hex: '#4AA1E2',
    scss: '$color__sequential-default-05',
    type: 'sequential-default',
    shortDescription: 'sequential default 05'
  },
  'sequential-default-04': {
    name: 'sequential-default-04',
    hex: '#0780C0',
    scss: '$color__sequential-default-04',
    type: 'sequential-default',
    shortDescription: 'sequential default 04'
  },
  'sequential-default-03': {
    name: 'sequential-default-03',
    hex: '#005F9B',
    scss: '$color__sequential-default-03',
    type: 'sequential-default',
    shortDescription: 'sequential default 03'
  },
  'sequential-default-02': {
    name: 'sequential-default-02',
    hex: '#003F76',
    scss: '$color__sequential-default-02',
    type: 'sequential-default',
    shortDescription: 'sequential default 02'
  },
  'sequential-default-01': {
    name: 'sequential-default-01',
    hex: '#002153',
    scss: '$color__sequential-default-01',
    type: 'sequential-default',
    shortDescription: 'sequential default 01'
  },
  'sequential-secondary-07': {
    name: 'sequential-secondary-07',
    hex: '#bdf9c4',
    scss: '$color__sequential-secondary-07',
    type: 'sequential-secondary',
    shortDescription: 'sequential secondary 07'
  },
  'sequential-secondary-06': {
    name: 'sequential-secondary-06',
    hex: '#89eaa8',
    scss: '$color__sequential-secondary-06',
    type: 'sequential-secondary',
    shortDescription: 'sequential secondary 06'
  },
  'sequential-secondary-05': {
    name: 'sequential-secondary-05',
    hex: '#5fd79a',
    scss: '$color__sequential-secondary-05',
    type: 'sequential-secondary',
    shortDescription: 'sequential secondary 05'
  },
  'sequential-secondary-04': {
    name: 'sequential-secondary-04',
    hex: '#41c196',
    scss: '$color__sequential-secondary-04',
    type: 'sequential-secondary',
    shortDescription: 'sequential secondary 04'
  },
  'sequential-secondary-03': {
    name: 'sequential-secondary-03',
    hex: '#33aa96',
    scss: '$color__sequential-secondary-03',
    type: 'sequential-secondary',
    shortDescription: 'sequential secondary 03'
  },
  'sequential-secondary-02': {
    name: 'sequential-secondary-02',
    hex: '#319298',
    scss: '$color__sequential-secondary-02',
    type: 'sequential-secondary',
    shortDescription: 'sequential secondary 02'
  },
  'sequential-secondary-01': {
    name: 'sequential-secondary-01',
    hex: '#367a96',
    scss: '$color__sequential-secondary-01',
    type: 'sequential-secondary',
    shortDescription: 'sequential secondary 01'
  },
  'categorical-corporate-01': {
    name: 'categorical-01',
    hex: '#007DBC',
    scss: '$color__categorical-corporate-01',
    type: 'categorical',
    shortDescription: 'categorical-01'
  },
  'categorical-corporate-02': {
    name: 'categorical-02',
    hex: '#36B5C5',
    scss: '$color__categorical-corporate-02',
    type: 'categorical',
    shortDescription: 'categorical-02'
  },
  'categorical-corporate-03': {
    name: 'categorical-03',
    hex: '#00B485',
    scss: '$color__categorical-corporate-03',
    type: 'categorical',
    shortDescription: 'categorical-03'
  },
  'categorical-corporate-04': {
    name: 'categorical-04',
    hex: '#008868',
    scss: '$color__categorical-corporate-04',
    type: 'categorical',
    shortDescription: 'categorical-04'
  },
  'categorical-corporate-05': {
    name: 'categorical-05',
    hex: '#1A4262',
    scss: '$color__categorical-corporate-05',
    type: 'categorical',
    shortDescription: 'categorical-05'
  },
  'categorical-corporate-06': {
    name: 'categorical-06',
    hex: '#982B56',
    scss: '$color__categorical-corporate-06',
    type: 'categorical',
    shortDescription: 'categorical-06'
  },
  'categorical-corporate-07': {
    name: 'categorical-07',
    hex: '#EF404C',
    scss: '$color__categorical-corporate-07',
    type: 'categorical',
    shortDescription: 'categorical-07'
  },
  'categorical-corporate-08': {
    name: 'categorical-08',
    hex: '#F47847',
    scss: '$color__categorical-corporate-08',
    type: 'categorical',
    shortDescription: 'categorical-08'
  },
  'categorical-corporate-09': {
    name: 'categorical-09',
    hex: '#B79F8D',
    scss: '$color__categorical-corporate-09',
    type: 'categorical',
    shortDescription: 'categorical-09'
  },
  'categorical-corporate-10': {
    name: 'categorical-10',
    hex: '#ECDFBB',
    scss: '$color__categorical-corporate-10',
    type: 'categorical',
    shortDescription: 'categorical-10'
  },
  female: {
    name: 'female',
    hex: '#3f7e44',
    scss: '$color__female',
    type: 'symbolic',
    shortDescription: 'Indicate female'
  },
  male: {
    name: 'male',
    hex: '#26bde2',
    scss: '$color__male',
    type: 'symbolic',
    shortDescription: 'Indicate male'
  },
  national: {
    name: 'national',
    hex: '#3C5979',
    scss: '$color__national',
    type: 'symbolic',
    shortDescription: 'Indicate national staff'
  },
  international: {
    name: 'international',
    hex: '#fcc30b',
    scss: '$color__international',
    type: 'symbolic',
    shortDescription: 'Indicate international staff'
  },
  'brand-01': {
    name: 'brand-01',
    hex: '#007DBC',
    //previously 0A6EB4
    scss: 'var(--brand-01)',
    css: 'color__brand-01',
    type: 'brand',
    shortDescription: 'WFP brand color'
  },
  'interactive-01': {
    name: 'interactive-01',
    hex: '#0b77c2',
    scss: 'var(--interactive-01)',
    css: 'color__interactive-01',
    type: 'brand',
    shortDescription: 'Primary interactive color, Primary buttons'
  },
  'interactive-02': {
    name: 'interactive-02',
    hex: '#085387',
    scss: '$interactive-02',
    css: 'color__interactive-02',
    type: 'brand',
    shortDescription: 'BannerNavigation'
  },
  'accent-01': {
    name: 'accent-01',
    hex: '#f7b825',
    scss: '$accent-01',
    css: 'color__accent-01',
    type: 'brand-accent',
    //replaced type brand to brand-accent to prevent it from showing it
    shortDescription: 'Accent colour (recommended)'
  },
  'brand-01-20': {
    name: 'brand-01-20',
    hex: '#c2dbec',
    scss: '$brand-01-20',
    css: 'color__brand-01-20',
    type: 'brand-extended'
  },
  'brand-01-30': {
    name: 'brand-01-30',
    hex: '#85b7da',
    scss: '$brand-01-30',
    css: 'color__brand-01-30',
    type: 'brand-extended'
  },
  'brand-01-40': {
    name: 'brand-01-40',
    hex: '#4792c7',
    scss: '$brand-01-40',
    css: 'color__brand-01-40',
    type: 'brand-extended'
  },
  'brand-01-60': {
    name: 'brand-01-60',
    hex: '#085387',
    scss: '$brand-01-60',
    css: 'color__brand-01-60',
    type: 'brand-extended'
  },
  'brand-01-70': {
    name: 'brand-01-70',
    hex: '#05375a',
    scss: '$brand-01-70',
    css: 'color__brand-01-70',
    type: 'brand-extended'
  },
  'brand-01-80': {
    name: 'brand-01-80',
    hex: '#031c2d',
    scss: '$brand-01-80',
    css: 'color__brand-01-80',
    type: 'brand-extended'
  },
  'ui-01': {
    name: 'ui-01',
    hex: '#ffffff',
    scss: '$ui-01',
    css: 'color__ui-01',
    type: 'ui',
    shortDescription: 'Primary container background; Secondary page background',
    description: 'This colour is used as the page background if there are no Modules on top of it.'
  },
  'ui-02': {
    name: 'ui-02',
    hex: '#eff2f5',
    scss: 'var(--ui-02)',
    css: 'color__ui-02',
    type: 'ui',
    shortDescription: 'Primary page background; Secondary container background',
    description: 'Use this colour as page background if there are modules on top of it to increase the contrast between the modules.'
  },
  'ui-03': {
    name: 'ui-03',
    hex: '#f0f3f6',
    scss: '$ui-03',
    css: 'color__ui-03',
    type: 'ui',
    shortDescription: 'Subtle border, Tertiary background color'
  },
  'ui-04': {
    name: 'ui-04',
    hex: '#dfe3e6',
    scss: '$ui-04',
    css: 'color__ui-04',
    type: 'ui',
    shortDescription: '3:1 AA element contrast; Medium contrast border'
  },
  'ui-05': {
    name: 'ui-05',
    hex: '#8c9ba5',
    scss: '$ui-03',
    css: 'color__ui-05',
    type: 'ui',
    shortDescription: '4.5:1 AA element contrast; High contrast border; Emphasis elements'
  },
  'ui-06': {
    name: 'ui-06',
    hex: '#0b1923',
    scss: '$ui-06',
    css: 'color__ui-06',
    type: 'ui',
    shortDescription: ''
  },
  'text-01': {
    name: 'text-01',
    hex: '#031c2d',
    scss: '$text-01',
    css: 'color__text-01',
    type: 'ui',
    shortDescription: 'Primary text colour; Input labels;'
  },
  'text-02': {
    name: 'text-02',
    hex: '#5a6872',
    scss: '$text-02',
    css: 'color__text-02',
    type: 'ui',
    shortDescription: 'Secondary text; Help text'
  },
  'text-03': {
    name: 'text-03',
    hex: '#dfe6eb',
    scss: '$text-03',
    css: 'color__text-03',
    type: 'ui',
    shortDescription: 'Placeholder text'
  },
  'text-04': {
    name: 'text-04',
    hex: '#ffffff',
    scss: '$text-04',
    css: 'color__text-04',
    type: 'ui',
    shortDescription: ''
  },
  'inverse-01': {
    name: 'inverse-01',
    hex: '#ffffff',
    scss: '$inverse-01',
    css: 'color__inverse-01',
    type: 'ui',
    shortDescription: 'Inverse text color; Inverse icon color'
  },
  // 'inverse-02': {
  //   name: 'inverse-02',
  //   hex: '#f0f3f6',
  //   scss: '$inverse-02',
  //   css: 'color__inverse-02',
  //   type: 'ui',
  //   shortDescription: 'High contrast backgrounds; High contrast elements',
  // },
  'field-01': {
    name: 'field-01',
    hex: '#ffffff',
    scss: '$field-02',
    css: 'color__field-01',
    type: 'ui',
    shortDescription: 'Default input fields; Fields on $ui-backgrounds'
  },

  /*'field-02': {
    name: 'field-02',
    hex: '#fbfcfc',
    scss: '$field-02',
    css: 'color__field-02',
    type: 'ui',
  },*/
  'field-border-01': {
    name: 'field-border-01',
    hex: '#d4d7d9',
    scss: '$field-border-01',
    css: 'color__field-border-01',
    type: 'ui',
    shortDescription: ''
  },
  'disabled-01': {
    name: 'disabled-01',
    hex: '#f9fbfc',
    scss: '$disabled-01',
    css: 'color__disabled-01',
    type: 'ui',
    shortDescription: ''
  },
  'disabled-02': {
    name: 'disabled-02',
    hex: '#dfe6eb',
    scss: '$disabled-02',
    css: 'color__disabled-02',
    type: 'ui',
    shortDescription: ''
  },
  'sdg-01': {
    name: 'sdg-01',
    hex: '#E5243B',
    scss: '$sdg-01',
    css: 'color__sdg-01',
    type: 'sdg',
    shortDescription: 'No poverty, red'
  },
  'sdg-02': {
    name: 'sdg-02',
    hex: '#DDA63A',
    scss: '$sdg-02',
    css: 'color__sdg-02',
    type: 'sdg',
    shortDescription: 'Zero hunger, mustard'
  },
  'sdg-03': {
    name: 'sdg-03',
    hex: '#4C9F38',
    scss: '$sdg-03',
    css: 'color__sdg-03',
    type: 'sdg',
    shortDescription: 'Good health and well-being, kelly green'
  },
  'sdg-04': {
    name: 'sdg-04',
    hex: '#C5192D',
    scss: '$sdg-04',
    css: 'color__sdg-04',
    type: 'sdg',
    shortDescription: 'Quality education, dark red'
  },
  'sdg-05': {
    name: 'sdg-05',
    hex: '#FF3A21',
    scss: '$sdg-05',
    css: 'color__sdg-05',
    type: 'sdg',
    shortDescription: 'Gender equality, red orange'
  },
  'sdg-06': {
    name: 'sdg-06',
    hex: '#26BDE2',
    scss: '$sdg-06',
    css: 'color__sdg-06',
    type: 'sdg',
    shortDescription: 'Clean water and sanitation, bright blue'
  },
  'sdg-07': {
    name: 'sdg-07',
    hex: '#FCC30B',
    scss: '$sdg-07',
    css: 'color__sdg-07',
    type: 'sdg',
    shortDescription: 'Affordable and clean energy, yellow'
  },
  'sdg-08': {
    name: 'sdg-08',
    hex: '#A21942',
    scss: '$sdg-08',
    css: 'color__sdg-08',
    type: 'sdg',
    shortDescription: 'Decent work and economic growth, burgundy red'
  },
  'sdg-09': {
    name: 'sdg-09',
    hex: '#FD6925',
    scss: '$sdg-09',
    css: 'color__sdg-09',
    type: 'sdg',
    shortDescription: 'Industry, innovation and infrastructure, orange'
  },
  'sdg-10': {
    name: 'sdg-10',
    hex: '#DD1367',
    scss: '$sdg-10',
    css: 'color__sdg-10',
    type: 'sdg',
    shortDescription: 'Reduced inequalities, magentas'
  },
  'sdg-11': {
    name: 'sdg-11',
    hex: '#FD9D24',
    scss: '$sdg-11',
    css: 'color__sdg-11',
    type: 'sdg',
    shortDescription: 'Sustainable cities and communities, golden yellow'
  },
  'sdg-12': {
    name: 'sdg-12',
    hex: '#BF8B2E',
    scss: '$sdg-12',
    css: 'color__sdg-12',
    type: 'sdg',
    shortDescription: 'Responsible consumption and production, dark mustard'
  },
  'sdg-13': {
    name: 'sdg-13',
    hex: '#3F7E44',
    scss: '$sdg-10',
    css: 'color__sdg-13',
    type: 'sdg',
    shortDescription: 'Climate action, dark green'
  },
  'sdg-14': {
    name: 'sdg-14',
    hex: '#0A97D9',
    scss: '$sdg-14',
    css: 'color__sdg-14',
    type: 'sdg',
    shortDescription: 'Life below water, blue'
  },
  'sdg-15': {
    name: 'sdg-15',
    hex: '#56C02B',
    scss: '$sdg-15',
    css: 'color__sdg-15',
    type: 'sdg',
    shortDescription: 'Life on land, lime green'
  },
  'sdg-16': {
    name: 'sdg-16',
    hex: '#00689D',
    scss: '$sdg-16',
    css: 'color__sdg-16',
    type: 'sdg',
    shortDescription: 'Peace, justice and stron institutions, royal blue'
  },
  'sdg-17': {
    name: 'sdg-17',
    hex: '#19486A',
    scss: '$sdg-17',
    css: 'color__sdg-17',
    type: 'sdg',
    shortDescription: 'Partnership for the goals, navy blue'
  },
  'support-01': {
    name: 'support-01',
    hex: '#c5192d',
    scss: '$support-01',
    css: 'color__support-01',
    type: 'support',
    shortDescription: 'Error (same as color__red)',
    description: 'Use the error color to indicate an error or to focus the attention on something which is crucial to see. Paired with a cross icon, red delivers the message that something went wrong.'
  },
  'support-light-01': {
    name: 'support-light-01',
    hex: '#f1c6cb',
    scss: '$support-light-01',
    css: 'color__support-light-01',
    type: 'support',
    shortDescription: 'Lighter version of color-red',
    description: ''
  },
  'support-02': {
    name: 'support-02',
    hex: '#689e18',
    scss: '$support-02',
    css: 'color__support-02',
    type: 'support',
    shortDescription: 'Success',
    description: 'Use green to indicate success state. Paired with a checkmark icon the user knows that the operation was successfully completed.'
  },
  'support-light-02': {
    name: 'support-light-02',
    hex: '#ccdbcd',
    scss: '$support-light-02',
    css: 'color__support-light-02',
    type: 'support',
    shortDescription: 'Lighter version of green',
    description: ''
  },
  'support-03': {
    name: 'support-03',
    hex: '#f7b825',
    scss: '$support-03',
    css: 'color__support-03',
    type: 'support',
    shortDescription: 'Warning (same as color__yellow)',
    description: 'Use yellow to indicate a transient warning which is less important than an error message. Yellow typically consists of items which require the user’s immediate attention, or indicate a waiting period. Although this overlaps with the use of red, yellow is more transient in nature.'
  },
  'support-light-03': {
    name: 'support-light-03',
    hex: '#fdedc9',
    scss: '$support-light-03',
    css: 'color__support-light-03',
    type: 'support',
    shortDescription: 'Lighter version of yellow',
    description: ''
  },
  'support-04': {
    name: 'support-04',
    hex: '#85b7da',
    scss: '$support-04',
    css: 'color__support-04',
    type: 'support',
    shortDescription: 'Info',
    description: ''
  },
  'support-light-04': {
    name: 'support-light-04',
    hex: '#c2dbec',
    scss: '$support-light-04',
    css: 'color__support-light-04',
    type: 'support',
    shortDescription: '',
    description: ''
  }
};
var colors$1 = colors; // main: {
//   name: 'main',
//   hex: '#0A6EB4',
//   scss: '$color__main',
//   type: 'communications',
// },
// navy: {
//   name: 'navy',
//   hex: '#19486a',
//   scss: '$color__navy',
//   // shortDescription: 'Same as SDG 17',
//   shortDescription: '',
//   type: 'communications',
// },
// aqua: {
//   name: 'aqua',
//   hex: '#26bde2',
//   // shortDescription: 'Same as SDG 6',
//   shortDescription: '',
//   scss: '$color__aqua',
//   type: 'communications',
// },
// 'dark-green': {
//   name: 'dark-green',
//   hex: '#3f7e44',
//   // shortDescription: 'Same as SDG 13',
//   shortDescription: '',
//   scss: '$color__dark-green',
//   type: 'communications',
// },
// lime: {
//   name: 'lime',
//   hex: '#97d700',
//   scss: '$color__lime',
//   type: 'communications',
// },
// yellow: {
//   name: 'yellow',
//   hex: '#fcc30b',
//   // shortDescription: 'Same as SDG 7',
//   shortDescription: '',
//   scss: '$color__yellow',
//   type: 'communications',
// },
// ochre: {
//   name: 'ochre',
//   hex: '#dda63a',
//   // shortDescription: 'Same as SDG 2',
//   shortDescription: '',
//   scss: '$color__ochre',
//   type: 'communications',
// },
// orange: {
//   name: 'orange',
//   hex: '#fd6925',
//   // shortDescription: 'Same as SDG 9',
//   shortDescription: '',
//   scss: '$color__orange',
//   type: 'communications',
// },
// red: {
//   name: 'red',
//   hex: '#c5192d',
//   // shortDescription: 'Same as SDG 1',
//   shortDescription: '',
//   scss: '$color__red',
//   type: 'communications',
// },
// 'dark-red': {
//   name: 'dark-red',
//   hex: '#a21942',
//   // shortDescription: 'Same as SDG 8',
//   shortDescription: '',
//   scss: '$color__dark-red',
//   type: 'communications',
// },
// magenta: {
//   name: 'magenta',
//   hex: '#dd1367',
//   // shortDescription: 'Same as SDG 10',
//   shortDescription: '',
//   scss: '$color__magenta',
//   type: 'communications',
// },

function useDetectPrint() {
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isPrinting = _useState2[0],
      toggleStatus = _useState2[1];

  useEffect(function () {
    var printMq = typeof window !== 'undefined' && window.matchMedia && window.matchMedia('print');

    var mqEvent = function mqEvent(mqList) {
      return toggleStatus(!!mqList.matches);
    };

    printMq.addListener(mqEvent);
    return function () {
      return printMq.removeListener(mqEvent);
    };
  });
  return isPrinting;
}

var _excluded$1 = ["gutter", "children", "grow", "justify", "align", "columns", "className"];
var prefix$1 = settings$1.prefix;
/** Grid layout */

var Grid = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _classnames;

  var gutter = _ref.gutter,
      children = _ref.children,
      grow = _ref.grow,
      justify = _ref.justify,
      align = _ref.align;
      _ref.columns;
      var className = _ref.className,
      other = _objectWithoutProperties(_ref, _excluded$1);

  var wrapperClasses = classnames$1("".concat(prefix$1, "--grid"), (_classnames = {}, _defineProperty(_classnames, "".concat(prefix$1, "--grid--spacing-").concat(gutter), gutter), _defineProperty(_classnames, "".concat(prefix$1, "--grid--grow"), grow), _defineProperty(_classnames, "".concat(className), className), _classnames));
  return /*#__PURE__*/React.createElement("div", _extends({
    ref: ref,
    className: wrapperClasses
  }, other, {
    style: {
      justifyContent: justify,
      alignItems: align
    }
  }), children);
});
Grid.propTypes = {
  /** <Col /> components only */
  children: PropTypes.node,

  /** Spacing between columns predefined value from theme.spacing or number for gutter in px  */
  gutter: PropTypes.oneOf(['none', 'xs', 'sm', 'md', 'lg', 'xl']),

  /** Should columns in the last row take 100% of grid width */
  grow: PropTypes.bool,

  /** Set grid justify-content property */
  justify: PropTypes.oneOf(['flex-start', 'flex-end', 'center', 'space-between', 'space-around']),

  /** Set grid align-content property */
  align: PropTypes.oneOf(['flex-start', 'flex-end', 'center', 'stretch'])
};
Grid.defaultProps = {
  gutter: 'xs',
  justify: 'flex-start',
  align: 'flex-start'
};
var Grid$1 = Grid;

var _excluded = ["children", "span", "className", "innerStyle", "lg", "md", "sm", "xs"];
var prefix = settings$1.prefix;
/** Credits are mostly used when a photo need a source attribution. */

var Col = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _classnames;

  var children = _ref.children,
      span = _ref.span,
      className = _ref.className,
      innerStyle = _ref.innerStyle,
      lg = _ref.lg,
      md = _ref.md,
      sm = _ref.sm,
      xs = _ref.xs,
      other = _objectWithoutProperties(_ref, _excluded);

  var wrapperClasses = classnames$1("".concat(prefix, "--grid-col"), (_classnames = {}, _defineProperty(_classnames, "".concat(prefix, "--col--span-").concat(span), span), _defineProperty(_classnames, "".concat(prefix, "--col--lg--").concat(lg), lg), _defineProperty(_classnames, "".concat(prefix, "--col--lg--").concat(md), md), _defineProperty(_classnames, "".concat(prefix, "--col--sm--").concat(sm), sm), _defineProperty(_classnames, "".concat(prefix, "--col--xs--").concat(xs), xs), _defineProperty(_classnames, "".concat(className), className), _classnames));
  var innerClasses = classnames$1("".concat(prefix, "--container-style"));
  return /*#__PURE__*/React.createElement("div", _extends({
    ref: ref,
    className: wrapperClasses
  }, other), /*#__PURE__*/React.createElement("div", {
    className: innerClasses,
    style: innerStyle
  }, children));
});

function columnVariation(props, propName, componentName) {
  componentName = componentName || 'ANONYMOUS';

  if (props[propName]) {
    var value = props[propName];

    if (typeof value === 'number') {
      return value >= 1 && value <= 12 ? null : new Error(propName + ' in ' + componentName + ' is not within 1 to 10');
    }
  } // assume all ok


  return null;
}

Col.propTypes = {
  children: PropTypes.node,

  /** span set how wide each col block when placed next to each other fill 12 columns layout in a row eg: `span={3}`  */
  span: PropTypes.number,

  /** innerStyle represents style prop wrapping the inner container */
  innerStyle: PropTypes.object,

  /** Responsiveness on large(1200) screen will have 12 columns and calcuations will be based on this. range 1-12 */
  lg: columnVariation,

  /** Responsiveness on medium(992) screen will have 12 columns and calcuations will be based on this. range 1-12 */
  md: columnVariation,

  /** Responsiveness on small(768) screen will have 8 columns and calcuations will be based on this */
  sm: PropTypes.oneOf([1, 2, 3, 4, 5, 6, 7, 8]),

  /** Responsiveness on extra small(500) screen will have 4 columns and calcuations will be based on this */
  xs: PropTypes.oneOf([1, 2, 3, 4])
};
var Col$1 = Col;

export { AnchorNavigation, AuthLayout, BackgroundContent, BannerNavigation, BannerNavigationItem, BannerNavigationWithContent, Blockquote$1 as Blockquote, Breadcrumb$1 as Breadcrumb, BreadcrumbHome$1 as BreadcrumbHome, BreadcrumbItem$1 as BreadcrumbItem, Button$1 as Button, Card$1 as Card, Checkbox$1 as Checkbox, Col$1 as Col, ContentSwitcher, ContextMenu$1 as ContextMenu, ContextMenuGroup, ContextMenuItem, Credits$1 as Credits, DateRangePickerInput, Empty$1 as Empty, FileUploader, FileUploaderButton, FileUploaderDropContainer, FileUploaderItem, Footer$1 as Footer, Form$1 as Form, FormControls, FormError$1 as FormError, FormGroup$1 as FormGroup, FormHint$1 as FormHint, FormItem$1 as FormItem, FormLabel$1 as FormLabel, FormWizard$1 as FormWizard, Grid$1 as Grid, Hero$1 as Hero, Icon$1 as Icon, InfoBar$1 as InfoBar, InlineLoading, InlineNotification, Input$1 as Input, InputGroup, Item$1 as Item, Link$1 as Link, List, ListItem, Loading, MainNavigation$1 as MainNavigation, MainNavigationItem$1 as MainNavigationItem, MdxComponents$1 as MdxComponents, Modal, ModalWrapper, Module$1 as Module, ModuleBody$1 as ModuleBody, ModuleFooter$1 as ModuleFooter, ModuleHeader$1 as ModuleHeader, NotificationActionButton, NotificationButton, NotificationTextDetails, NumberInput$1 as NumberInput, Pagination, RadioButton$1 as RadioButton, RadioButtonGroup, ReadMore, ReduxFormWrapper$1 as ReduxFormWrapper, Search, SecondaryNavigation, SecondaryNavigationTitle, Select$1 as Select, SelectItem$1 as SelectItem, SelectItemGroup$1 as SelectItemGroup, Sidebar, SidebarBackButton, SidebarContentBody, SidebarContentHeader, SidebarHeader, SidebarScroll, SingleDatePickerInput, Slider, StepNavigation, StepNavigationItem, Story$1 as Story, SubNavigation, SubNavigationContent, SubNavigationFilter, SubNavigationGroup, SubNavigationHeader, SubNavigationItem, SubNavigationLink, SubNavigationList, SubNavigationTitle, Switch$1 as Switch, Tab, TabContent$1 as TabContent, Table, ReactTablePagination$1 as TablePagination, TableSorting, Tabs$1 as Tabs, Tag$1 as Tag, Text$1 as Text, TextArea$1 as TextArea, TextInput$1 as TextInput, ToastNotification, Toggle$1 as Toggle, Tooltip$1 as Tooltip, Unit$1 as Unit, User$1 as User, Value$1 as Value, Wrapper$1 as Wrapper, colors$1 as colors, notificationStyle$1 as notificationStyle, pageWidths, tooltipStyle, tooltipStyleDark, uniqueId, useDetectPrint };
